export const data = {
  "TIỀN MẶT/NULL": {},
  "BUSAN/TP HO CHI MINH": {
    "msb": null,
    "techcombank": {
      "bank": "BUSAN CN TP HO CHI MINH",
      "region": "HO-CHI-MINH",
      "branch": "BUSAN CN TP HO CHI MINH-79660001"
    }
  },
  "CATHAY/HOI SO CHINH": {
    "msb": null,
    "techcombank": {
      "bank": "CATHAY",
      "region": "QUANG-NAM",
      "branch": "CATHAY HOI SO CHINH-49634001"
    }
  },
  "VIET HOA/HCM": {
    "msb": null,
    "techcombank": {
      "bank": "VIET HOA",
      "region": "HO-CHI-MINH",
      "branch": "VIET HOA HCM-79324001"
    }
  },
  "AGRIBANK/PGD HAI BA TRUNG (HN)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN HN-PGD Q HAI BA TRUNG-01204052"
    }
  },
  "AGRIBANK/TRUNG TAM THANH TOAN (HN)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN TRUNG TAM THANH TOAN-01204009"
    }
  },
  "ABBANK/BA RIA VUNG TAU": {
    "msb": { "code": "77323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/BAC LIEU": {
    "msb": { "code": "95323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/BAC NINH": {
    "msb": { "code": "27323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/CAN THO": {
    "msb": { "code": "92323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/CAN THO  VINH LONG": {
    "msb": { "code": "86323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/CAO LANH": {
    "msb": { "code": "87323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/DA NANG": {
    "msb": { "code": "48323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/DONG XOAI": {
    "msb": { "code": "70323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/GIA LAI": {
    "msb": { "code": "64323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/HA NOI (HN)": {
    "msb": { "code": "01323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/HAI PHONG": {
    "msb": { "code": "31323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/HUE": {
    "msb": { "code": "46323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/KHANH HOA": {
    "msb": { "code": "56323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/LONG AN": {
    "msb": { "code": "80323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/LONG XUYEN": {
    "msb": { "code": "89323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/MY HAO": {
    "msb": { "code": "33323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/MY THO": {
    "msb": { "code": "82323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/PHAN THIET": {
    "msb": { "code": "60323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/PHUC YEN": {
    "msb": { "code": "26323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/QUANG NINH": {
    "msb": { "code": "22323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/RACH GIA": {
    "msb": { "code": "91323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/SON LA": {
    "msb": { "code": "14323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/TAM KY": {
    "msb": { "code": "49323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/TAN TIEN": {
    "msb": { "code": "75323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/TAY NINH": {
    "msb": { "code": "72323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ABBANK/THAI NGUYEN": {
    "msb": { "code": "19323001" },
    "techcombank": {
      "bank": "AN BINH (AB BANK)",
      "region": "Ca nuoc",
      "branch": "AN BINH (AB BANK)-323"
    }
  },
  "ACB/AN GIANG": {
    "msb": { "code": "89307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/BAC NINH": {
    "msb": { "code": "27307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/BINH DINH": {
    "msb": { "code": "52307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/BINH DUONG": {
    "msb": { "code": "74307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/BINH PHUOC": {
    "msb": { "code": "70307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/CA MAU": {
    "msb": { "code": "96307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/CAN THO": {
    "msb": { "code": "92307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/CHO LON": {
    "msb": { "code": "79307005" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/DA NANG": {
    "msb": { "code": "48307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/DAC LAK": {
    "msb": { "code": "66307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/DONG NAI": {
    "msb": { "code": "75307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/DONG THAP": {
    "msb": { "code": "87307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/DUYEN HAI": {
    "msb": { "code": "31307002" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/GIA LAI": {
    "msb": { "code": "64307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/HA NOI (HN)": {
    "msb": { "code": "01307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/HAI DUONG": {
    "msb": { "code": "30307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/HAI PHONG": {
    "msb": { "code": "31307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/HO CHI MINH (HCM)": {
    "msb": { "code": "79307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/HOI AN": {
    "msb": { "code": "49307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/HUE": {
    "msb": { "code": "46307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/HUNG YEN": {
    "msb": { "code": "33307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/KHAI NGUYEN": {
    "msb": { "code": "79307028" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/KHANH HOA": {
    "msb": { "code": "56307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/KIEN GIANG": {
    "msb": { "code": "91307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/LONG AN": {
    "msb": { "code": "80307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/LONG HOA": {
    "msb": { "code": "72307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/NGHE AN": {
    "msb": { "code": "40307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/PHAN RANG": {
    "msb": { "code": "58307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/PHAN THIET": {
    "msb": { "code": "60307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/QUANG NINH": {
    "msb": { "code": "22307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/SAI GON": {
    "msb": { "code": "79307006" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/TAY NINH": {
    "msb": { "code": "72307002" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/THANG LONG": {
    "msb": { "code": "01307004" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/THANH HOA": {
    "msb": { "code": "38307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/THUY NGUYEN": {
    "msb": { "code": "31307003" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/TIEN GIANG": {
    "msb": { "code": "82307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/VINH LONG": {
    "msb": { "code": "86307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/VINH PHUC": {
    "msb": { "code": "26307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "ACB/VUNG TAU": {
    "msb": { "code": "77307001" },
    "techcombank": {
      "bank": "A CHAU (ACB)",
      "region": "Ca nuoc",
      "branch": "A CHAU (ACB)-307"
    }
  },
  "AGRIBANK/TINH THAI NGUYEN": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/A LUOI": {
    "msb": { "code": "46204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN A LUOI-46204010"
    }
  },
  "AGRIBANK/AN BIEN": {
    "msb": { "code": "91204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN AN BIEN-91204016"
    }
  },
  "AGRIBANK/AN DUONG": {
    "msb": { "code": "31204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN AN DUONG HP-31204002"
    }
  },
  "AGRIBANK/AN GIANG": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/AN HUNG": {
    "msb": { "code": "31204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN AN HUNG HP-31204004"
    }
  },
  "AGRIBANK/AN LAO (BINH DINH)": {
    "msb": { "code": "52204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN AN LAO -BINH DINH-52204011"
    }
  },
  "AGRIBANK/AN LAO (HAI PHONG)": {
    "msb": { "code": "31204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN AN LAO HP-31204010"
    }
  },
  "AGRIBANK/AN MINH": {
    "msb": { "code": "91204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN AN MINH-91204017"
    }
  },
  "AGRIBANK/AN NHON": {
    "msb": { "code": "52204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN THI XA AN NHON-52204004"
    }
  },
  "AGRIBANK/AN PHU": {
    "msb": { "code": "79204042" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN AN PHU-79204042"
    }
  },
  "AGRIBANK/AN PHU (AN GIANG)": {
    "msb": { "code": "89204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN AN PHU-89204003"
    }
  },
  "AGRIBANK/AN SUONG": {
    "msb": { "code": "79204041" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN AN SUONG-79204041"
    }
  },
  "AGRIBANK/AN THI": {
    "msb": { "code": "33204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN AN THI-33204011"
    }
  },
  "AGRIBANK/ANH SON": {
    "msb": { "code": "40204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN ANH SON-40204022"
    }
  },
  "AGRIBANK/AYUNPA": {
    "msb": { "code": "64204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN AYUNPA-64204005"
    }
  },
  "AGRIBANK/BA BE": {
    "msb": { "code": "06204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN CN BA BE-06204003"
    }
  },
  "AGRIBANK/BA CHE": {
    "msb": { "code": "22204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BA CHE-22204016"
    }
  },
  "AGRIBANK/BA DINH (HN)": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BA DINH-01204298"
    }
  },
  "AGRIBANK/BA DINH (THANH HOA)": {
    "msb": { "code": "38204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN BA DINH - THANH HOA-38204025"
    }
  },
  "AGRIBANK/BA HON": {
    "msb": { "code": "91204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN BA HON - KIEN GIANG-91204014"
    }
  },
  "AGRIBANK/BA RIA VUNG TAU": {
    "msb": { "code": "77204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN BA RIA VUNG TAU-77204001"
    }
  },
  "AGRIBANK/BA THUOC": {
    "msb": { "code": "38204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BA THUOC-38204027"
    }
  },
  "AGRIBANK/BA TO": {
    "msb": { "code": "51204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BA TO-51204002"
    }
  },
  "AGRIBANK/BA TRI": {
    "msb": { "code": "83204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BA TRI-83204004"
    }
  },
  "AGRIBANK/BA TRIEU (HN)": {
    "msb": { "code": "01204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BA TRIEU-01204295"
    }
  },
  "AGRIBANK/BA VI": {
    "msb": { "code": "01204044" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.BA VI - HA TAY-01204044"
    }
  },
  "AGRIBANK/BA XUYEN": {
    "msb": { "code": "94204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN BA XUYEN-94204003"
    }
  },
  "AGRIBANK/BAC AI": {
    "msb": { "code": "58204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC AI-58204007"
    }
  },
  "AGRIBANK/BAC BINH": {
    "msb": { "code": "60204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC BINH-60204007"
    }
  },
  "AGRIBANK/BAC CAN": {
    "msb": { "code": "06204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC CAN-06204001"
    }
  },
  "AGRIBANK/BAC DIEN BAN": {
    "msb": { "code": "49204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC DIEN BAN-49204019"
    }
  },
  "AGRIBANK/BAC GIANG": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/BAC HA (TINH LAO CAI)": {
    "msb": { "code": "10204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC HA-10204002"
    }
  },
  "AGRIBANK/BAC HA NOI": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/BAC HAI PHONG": {
    "msb": { "code": "31204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HAI PHONG-31204007"
    }
  },
  "AGRIBANK/BAC LIEU": {
    "msb": { "code": "95204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC LIEU-95204001"
    }
  },
  "AGRIBANK/BAC LUONG SON(HOA BINH)": {
    "msb": { "code": "17204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUONG SON-17204007"
    }
  },
  "AGRIBANK/BAC ME": {
    "msb": { "code": "02204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC ME-02204006"
    }
  },
  "AGRIBANK/BAC QUANG": {
    "msb": { "code": "02204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC QUANG-02204008"
    }
  },
  "AGRIBANK/BAC SAI GON (NGA TU GA)": {
    "msb": { "code": "79204046" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC SAI GON-79204046"
    }
  },
  "AGRIBANK/BAC SON": {
    "msb": { "code": "20204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC SON-20204008"
    }
  },
  "AGRIBANK/BAC SONG HUONG": {
    "msb": { "code": "46204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC SONG HUONG-46204011"
    }
  },
  "AGRIBANK/BAC THONG": {
    "msb": { "code": "06204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BACH THONG-06204002"
    }
  },
  "AGRIBANK/BAC TRA MY": {
    "msb": { "code": "49204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC TRA MY-49204015"
    }
  },
  "AGRIBANK/BAC VINH YEN": {
    "msb": { "code": "26204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH YEN - VINH PHUC-26204010"
    }
  },
  "AGRIBANK/BAC YEN": {
    "msb": { "code": "14204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC YEN-14204007"
    }
  },
  "AGRIBANK/BACH KHOA (HA NOI)": {
    "msb": { "code": "01204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI I-01204026"
    }
  },
  "AGRIBANK/BAO LAC": {
    "msb": { "code": "04204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAO LAC-04204014"
    }
  },
  "AGRIBANK/BAO LAM (CAO BANG)": {
    "msb": { "code": "04204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAO LAM-04204012"
    }
  },
  "AGRIBANK/BAO LAM (LAM DONG)": {
    "msb": { "code": "68204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN BAO LAM - NAM LAM DONG-68204015"
    }
  },
  "AGRIBANK/BAO LOC (LAM DONG)": {
    "msb": { "code": "68204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM LAM DONG-68204002"
    }
  },
  "AGRIBANK/BAO THANG": {
    "msb": { "code": "10204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAO THANG-10204008"
    }
  },
  "AGRIBANK/BAO YEN": {
    "msb": { "code": "10204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAO YEN-10204007"
    }
  },
  "AGRIBANK/BAT XAT": {
    "msb": { "code": "10204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAT XAT-10204010"
    }
  },
  "AGRIBANK/BEN CAT": {
    "msb": { "code": "74204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN H.BEN CAT-74204003"
    }
  },
  "AGRIBANK/BEN CAU": {
    "msb": { "code": "72204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BEN CAU-72204007"
    }
  },
  "AGRIBANK/BEN LUC": {
    "msb": { "code": "80204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BEN LUC-80204013"
    }
  },
  "AGRIBANK/BEN NHAT": {
    "msb": { "code": "91204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN BEN NHAT-91204004"
    }
  },
  "AGRIBANK/BEN THANH": {
    "msb": { "code": "79204051" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BEN THANH-79204051"
    }
  },
  "AGRIBANK/BEN TRE": {
    "msb": { "code": "83204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BEN TRE-83204001"
    }
  },
  "AGRIBANK/BIEN HO": {
    "msb": { "code": "64204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN BIEN HO - GIA LAI-64204013"
    }
  },
  "AGRIBANK/BIEN HOA (HA NAM)": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/BIM SON": {
    "msb": { "code": "38204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN THI XA BIM SON-38204022"
    }
  },
  "AGRIBANK/BINH CHANH- HCM": {
    "msb": { "code": "79204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH CHANH-79204022"
    }
  },
  "AGRIBANK/BINH DAI": {
    "msb": { "code": "83204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH DAI-83204006"
    }
  },
  "AGRIBANK/BINH DINH": {
    "msb": { "code": "52204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH DINH-52204001"
    }
  },
  "AGRIBANK/BINH DUONG": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH DUONG-74204001"
    }
  },
  "AGRIBANK/BINH GIA": {
    "msb": { "code": "20204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH GIA-20204012"
    }
  },
  "AGRIBANK/BINH GIANG": {
    "msb": { "code": "30204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH GIANG-30204005"
    }
  },
  "AGRIBANK/BINH LIEU": {
    "msb": { "code": "22204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH LIEU-22204008"
    }
  },
  "AGRIBANK/BINH LONG": {
    "msb": { "code": "70204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH LONG-70204016"
    }
  },
  "AGRIBANK/BINH LUC": {
    "msb": { "code": "35204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH LUC-35204002"
    }
  },
  "AGRIBANK/BINH MINH (VINH LONG)": {
    "msb": { "code": "86204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN THI XA BINH MINH-86204002"
    }
  },
  "AGRIBANK/BINH PHU (HCM)": {
    "msb": { "code": "79204052" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH PHU-79204052"
    }
  },
  "AGRIBANK/BINH PHUOC": {
    "msb": { "code": "70204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH PHUOC-70204001"
    }
  },
  "AGRIBANK/BINH SON": {
    "msb": { "code": "51204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH SON-51204003"
    }
  },
  "AGRIBANK/BINH TAN (KHANH HOA)": {
    "msb": { "code": "56204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM NHA TRANG-56204011"
    }
  },
  "AGRIBANK/BINH TAN (SAI GON)": {
    "msb": { "code": "79204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH TAN-79204010"
    }
  },
  "AGRIBANK/BINH TAN (VINH LONG)": {
    "msb": { "code": "86204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH TAN - VINH LONG-86204007"
    }
  },
  "AGRIBANK/BINH THANH (TP HO CHI MINH)": {
    "msb": { "code": "79204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH THANH-79204019"
    }
  },
  "AGRIBANK/BINH THUAN": {
    "msb": { "code": "60204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH THUAN-60204001"
    }
  },
  "AGRIBANK/BINH TRIEU": {
    "msb": { "code": "79204033" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH TRIEU-79204033"
    }
  },
  "AGRIBANK/BINH XUYEN": {
    "msb": { "code": "26204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH XUYEN-26204008"
    }
  },
  "AGRIBANK/BO TRACH": {
    "msb": { "code": "44204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BO TRACH-44204002"
    }
  },
  "AGRIBANK/BU DANG": {
    "msb": { "code": "70204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BU DANG-70204008"
    }
  },
  "AGRIBANK/BU DOP": {
    "msb": { "code": "70204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BU DOP-70204009"
    }
  },
  "AGRIBANK/BU NHO": {
    "msb": { "code": "70204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN BU NHO-70204010"
    }
  },
  "AGRIBANK/BUON DON": {
    "msb": { "code": "66204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BUON DON-66204017"
    }
  },
  "AGRIBANK/BUON HO (DAK LAK)": {
    "msb": { "code": "66204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN THI XA BUON HO-66204007"
    }
  },
  "AGRIBANK/CA MAU": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/CAI BE": {
    "msb": { "code": "82204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAI BE-82204010"
    }
  },
  "AGRIBANK/CAI LAY": {
    "msb": { "code": "82204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX CAI LAY-82204002"
    }
  },
  "AGRIBANK/CAI NUOC": {
    "msb": { "code": "96204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAI NUOC-96204002"
    }
  },
  "AGRIBANK/CAI RANG": {
    "msb": { "code": "92204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN CAI RANG-92204002"
    }
  },
  "AGRIBANK/CAM DUONG": {
    "msb": { "code": "10204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAM DUONG-10204005"
    }
  },
  "AGRIBANK/CAM GIANG": {
    "msb": { "code": "30204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM GIANG-30204004"
    }
  },
  "AGRIBANK/CAM KHE": {
    "msb": { "code": "25204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM KHE-25204002"
    }
  },
  "AGRIBANK/CAM LAM": {
    "msb": { "code": "56204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM LAM-56204010"
    }
  },
  "AGRIBANK/CAM LE": {
    "msb": { "code": "48204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN QUAN CAM LE-48204016"
    }
  },
  "AGRIBANK/CAM LO": {
    "msb": { "code": "45204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM LO-45204005"
    }
  },
  "AGRIBANK/CAM MY": {
    "msb": { "code": "75204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM MY-75204006"
    }
  },
  "AGRIBANK/CAM RANH": {
    "msb": { "code": "56204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN TX CAM RANH-56204007"
    }
  },
  "AGRIBANK/CAM THUY": {
    "msb": { "code": "38204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM THUY-38204028"
    }
  },
  "AGRIBANK/CAM XUYEN": {
    "msb": { "code": "42204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM XUYEN-42204003"
    }
  },
  "AGRIBANK/CAN DUOC": {
    "msb": { "code": "80204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAN DUOC-80204007"
    }
  },
  "AGRIBANK/CAN GIO": {
    "msb": { "code": "79204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CAN GIO-79204027"
    }
  },
  "AGRIBANK/CAN GIUOC": {
    "msb": { "code": "80204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAN GIUOC-80204014"
    }
  },
  "AGRIBANK/CAN LOC": {
    "msb": { "code": "42204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAN LOC-42204013"
    }
  },
  "AGRIBANK/CANG LONG": {
    "msb": { "code": "84204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CANG LONG-84204002"
    }
  },
  "AGRIBANK/CAO LANH": {
    "msb": { "code": "87204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAO LANH-87204008"
    }
  },
  "AGRIBANK/CAO LOC": {
    "msb": { "code": "20204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAO LOC-20204009"
    }
  },
  "AGRIBANK/CAO PHONG": {
    "msb": { "code": "17204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAO PHONG-17204005"
    }
  },
  "AGRIBANK/CAO THANG": {
    "msb": { "code": "22204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CAO THANG-22204018"
    }
  },
  "AGRIBANK/CAT BA": {
    "msb": { "code": "31204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN CAT BA HP-31204003"
    }
  },
  "AGRIBANK/CAT TIEN (LAM DONG)": {
    "msb": { "code": "68204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAT TIEN-68204006"
    }
  },
  "AGRIBANK/CAU GIAY": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/CAU KHE": {
    "msb": { "code": "84204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAU KE-84204003"
    }
  },
  "AGRIBANK/CAU NGANG": {
    "msb": { "code": "84204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAU NGANG-84204006"
    }
  },
  "AGRIBANK/CHAU DOC": {
    "msb": { "code": "89204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TP CHAU DOC-89204013"
    }
  },
  "AGRIBANK/CHAU DUC": {
    "msb": { "code": "77204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU DUC-77204007"
    }
  },
  "AGRIBANK/CHAU PHU": {
    "msb": { "code": "89204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU PHU-89204010"
    }
  },
  "AGRIBANK/CHAU THANH (AN GIANG)": {
    "msb": { "code": "89204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH- AN GIANG-89204011"
    }
  },
  "AGRIBANK/CHAU THANH (BEN TRE)": {
    "msb": { "code": "83204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-BEN TRE-83204007"
    }
  },
  "AGRIBANK/CHAU THANH (DONG THAP)": {
    "msb": { "code": "87204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH- DONG THAP-87204006"
    }
  },
  "AGRIBANK/CHAU THANH (HAU GIANG)": {
    "msb": { "code": "93204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN H.CHAU THANH-HAU GIANG-93204007"
    }
  },
  "AGRIBANK/CHAU THANH (KIEN GIANG)": {
    "msb": { "code": "91204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH- KIEN GIANG-91204013"
    }
  },
  "AGRIBANK/CHAU THANH (LONG AN)": {
    "msb": { "code": "80204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH - LONG AN-80204006"
    }
  },
  "AGRIBANK/CHAU THANH (TAY NINH)": {
    "msb": { "code": "72204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-TAY NINH-72204010"
    }
  },
  "AGRIBANK/CHAU THANH (THUAN HOA)": {
    "msb": { "code": "94204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN CHAU THANH-SOC TRANG-94204014"
    }
  },
  "AGRIBANK/CHAU THANH (TIEN GIANG)": {
    "msb": { "code": "82204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-TIEN GIANG-82204009"
    }
  },
  "AGRIBANK/CHAU THANH (TRA VINH)": {
    "msb": { "code": "84204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-TRA VINH-84204011"
    }
  },
  "AGRIBANK/CHAU THANH A": {
    "msb": { "code": "93204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH A-93204006"
    }
  },
  "AGRIBANK/CHI LANG (AN GIANG)": {
    "msb": { "code": "89204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN CHI LANG-89204007"
    }
  },
  "AGRIBANK/CHI LANG (LANG SON)": {
    "msb": { "code": "20204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHI LANG-20204010"
    }
  },
  "AGRIBANK/CHI LANG (TP DA NANG)": {
    "msb": { "code": "48204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN CHI LANG -DA NANG-48204010"
    }
  },
  "AGRIBANK/CHI LINH (HAI DUONG)": {
    "msb": { "code": "30204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN SAO DO-30204012"
    }
  },
  "AGRIBANK/CHI NHANH 10 (HCM)": {
    "msb": { "code": "79204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 10-79204018"
    }
  },
  "AGRIBANK/CHIEM HOA": {
    "msb": { "code": "08204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHIEM HOA-08204005"
    }
  },
  "AGRIBANK/CHO CON": {
    "msb": { "code": "48204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO CON -DA NANG-48204009"
    }
  },
  "AGRIBANK/CHO DON": {
    "msb": { "code": "06204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHO DON-06204008"
    }
  },
  "AGRIBANK/CHO GAO (TIEN GIANG)": {
    "msb": { "code": "82204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHO GAO-82204008"
    }
  },
  "AGRIBANK/CHO LACH": {
    "msb": { "code": "83204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHO LACH-83204009"
    }
  },
  "AGRIBANK/CHO LON (TP HO CHI MINH)": {
    "msb": { "code": "79204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO LON-79204016"
    }
  },
  "AGRIBANK/CHO MOI (AN GIANG)": {
    "msb": { "code": "89204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHO MOI- AN GIANG-89204012"
    }
  },
  "AGRIBANK/CHO MOI (BAC CAN)": {
    "msb": { "code": "06204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHO MOI - BAC KAN-06204007"
    }
  },
  "AGRIBANK/CHO MOI (TP DA NANG)": {
    "msb": { "code": "48204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO MOI -DA NANG-48204012"
    }
  },
  "AGRIBANK/CHO VAM": {
    "msb": { "code": "89204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO VAM-89204014"
    }
  },
  "AGRIBANK/CHO XOM MOI": {
    "msb": { "code": "56204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO XOM MOI-56204009"
    }
  },
  "AGRIBANK/CHON THANH": {
    "msb": { "code": "70204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHON THANH-70204013"
    }
  },
  "AGRIBANK/CHU A": {
    "msb": { "code": "64204022" },
    "techcombank": null
  },
  "AGRIBANK/CHU PAH": {
    "msb": { "code": "64204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHU PAH-64204012"
    }
  },
  "AGRIBANK/CHU PRONG": {
    "msb": { "code": "64204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN CHU PRONG-64204002"
    }
  },
  "AGRIBANK/CHU SE": {
    "msb": { "code": "64204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHU SE-64204003"
    }
  },
  "AGRIBANK/CHUONG DUONG": {
    "msb": { "code": "01204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CHUONG DUONG-01204296"
    }
  },
  "AGRIBANK/CHUPUH (GIA LAI)": {
    "msb": { "code": "64204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN CHU PUH-64204024"
    }
  },
  "AGRIBANK/CN CAI TAC": {
    "msb": { "code": "93204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN CAI TAC-93204009"
    }
  },
  "AGRIBANK/CN DAI TAN": {
    "msb": { "code": "30204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN DAI TAN-30204016"
    }
  },
  "AGRIBANK/CN HUYEN TRANG BANG": {
    "msb": { "code": "72204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRANG BANG-72204002"
    }
  },
  "AGRIBANK/CN KHU VUC 3 LONG AN": {
    "msb": { "code": "80204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC III - LONG AN-80204004"
    }
  },
  "AGRIBANK/CN KV BAI CHAY": {
    "msb": { "code": "22204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN KV BAI CHAY-22204009"
    }
  },
  "AGRIBANK/CN- KV GIAN KHAU": {
    "msb": { "code": "37204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC GIAN KHAU-37204013"
    }
  },
  "AGRIBANK/CN SO 1 (TRA VINH)": {
    "msb": { "code": "84204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN SO 1 - TRA VINH-84204008"
    }
  },
  "AGRIBANK/CN SO 2 (THANH HOA)": {
    "msb": { "code": "38204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SO 2 - THANH HOA-38204013"
    }
  },
  "AGRIBANK/CN SO 2 (TRA VINH)": {
    "msb": { "code": "84204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN SO 2 - TRA VINH-84204009"
    }
  },
  "AGRIBANK/CN SO 2 THANH HOA": {
    "msb": { "code": "38204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SO 2 - THANH HOA-38204013"
    }
  },
  "AGRIBANK/CN SO 3 (THANH HOA)": {
    "msb": { "code": "38204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SO 3 - THANH HOA-38204023"
    }
  },
  "AGRIBANK/CN SO 3 THANH HOA": {
    "msb": { "code": "38204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SO 3 - THANH HOA-38204023"
    }
  },
  "AGRIBANK/CN SO 4 (THANH HOA)": {
    "msb": { "code": "38204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SO 4 - THANH HOA-38204024"
    }
  },
  "AGRIBANK/CN SO 4 THANH HOA": {
    "msb": { "code": "38204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SO 4 - THANH HOA-38204024"
    }
  },
  "AGRIBANK/CN TRUNG TAM SAI GON": {
    "msb": { "code": "79204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG TAM SAI GON-79204015"
    }
  },
  "AGRIBANK/CO DO - CAN THO": {
    "msb": { "code": "92204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN CO DO-92204011"
    }
  },
  "AGRIBANK/COC LEU": {
    "msb": { "code": "10204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN CN COC LEU-10204012"
    }
  },
  "AGRIBANK/CON": {
    "msb": { "code": "36204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CON - NAM DINH-36204016"
    }
  },
  "AGRIBANK/CON CUONG": {
    "msb": { "code": "40204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CON CUONG-40204016"
    }
  },
  "AGRIBANK/CON DAO - VUNG TAU": {
    "msb": { "code": "77204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CON DAO-77204009"
    }
  },
  "AGRIBANK/CU CHI": {
    "msb": { "code": "79204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CU CHI-79204028"
    }
  },
  "AGRIBANK/CU KUIN": {
    "msb": { "code": "66204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CU KUIN-66204003"
    }
  },
  "AGRIBANK/CU LAO DUNG": {
    "msb": { "code": "94204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CU LAO DUNG-94204011"
    }
  },
  "AGRIBANK/CU MGAR": {
    "msb": { "code": "66204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CU MGAR-66204023"
    }
  },
  "AGRIBANK/CUA DAI": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN CUA DAI-49204002"
    }
  },
  "AGRIBANK/CUU JUT": {
    "msb": { "code": "67204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CU JUT-67204009"
    }
  },
  "AGRIBANK/DA BAC": {
    "msb": { "code": "17204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DA BAC-17204002"
    }
  },
  "AGRIBANK/DA HUOAI": {
    "msb": { "code": "68204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAHUOAI-68204011"
    }
  },
  "AGRIBANK/DA KIA": {
    "msb": { "code": "70204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN DA KIA-70204005"
    }
  },
  "AGRIBANK/DA LAT": {
    "msb": { "code": "68204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN TP DA LAT-68204003"
    }
  },
  "AGRIBANK/DA NANG": {
    "msb": { "code": "48204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DA NANG-48204001"
    }
  },
  "AGRIBANK/DA TEH": {
    "msb": { "code": "68204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DA TEH-68204005"
    }
  },
  "AGRIBANK/DAC HOA": {
    "msb": { "code": "64204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK DOA-64204021"
    }
  },
  "AGRIBANK/DAC TO": {
    "msb": { "code": "62204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK TO-62204002"
    }
  },
  "AGRIBANK/DACGLONG": {
    "msb": { "code": "67204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK GLONG-67204005"
    }
  },
  "AGRIBANK/DAI HOP": {
    "msb": { "code": "31204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN DAI HOP-31204025"
    }
  },
  "AGRIBANK/DAI LOC": {
    "msb": { "code": "49204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAI LOC-49204008"
    }
  },
  "AGRIBANK/DAI TU": {
    "msb": { "code": "19204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAI TU-19204010"
    }
  },
  "AGRIBANK/DAK HA": {
    "msb": { "code": "62204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK HA-62204003"
    }
  },
  "AGRIBANK/DAK MIL": {
    "msb": { "code": "67204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK MIL-67204006"
    }
  },
  "AGRIBANK/DAK NONG": {
    "msb": { "code": "67204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN TINH DAC NONG-67204001"
    }
  },
  "AGRIBANK/DAK PO": {
    "msb": { "code": "64204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK PO-64204015"
    }
  },
  "AGRIBANK/DAK SONG": {
    "msb": { "code": "67204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK SONG-67204003"
    }
  },
  "AGRIBANK/DAKLAK": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/DAKRLAP": {
    "msb": { "code": "67204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK RLAP-67204002"
    }
  },
  "AGRIBANK/DAKRONG": {
    "msb": { "code": "45204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DA KRONG-45204006"
    }
  },
  "AGRIBANK/DAM DOI": {
    "msb": { "code": "96204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAM DOI-96204004"
    }
  },
  "AGRIBANK/DAT DO": {
    "msb": { "code": "77204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAT DO-77204008"
    }
  },
  "AGRIBANK/DAU TAM TO": {
    "msb": { "code": "68204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM LAM DONG-68204002"
    }
  },
  "AGRIBANK/DAU TIENG": {
    "msb": { "code": "74204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAU TIENG-74204006"
    }
  },
  "AGRIBANK/DI AN": {
    "msb": { "code": "74204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN TX DI AN SONG THAN-74204011"
    }
  },
  "AGRIBANK/DI LINH": {
    "msb": { "code": "68204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DI LINH-68204010"
    }
  },
  "AGRIBANK/DIEN BAN": {
    "msb": { "code": "49204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN TX DIEN BAN-49204021"
    }
  },
  "AGRIBANK/DIEN BIEN": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/DIEN BIEN DONG": {
    "msb": { "code": "11204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN DIEN BIEN DONG-11204007"
    }
  },
  "AGRIBANK/DIEN CHAU": {
    "msb": { "code": "40204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DIEN CHAU-40204020"
    }
  },
  "AGRIBANK/DIEN HONG": {
    "msb": { "code": "64204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DIEN HONG - GIA LAI-64204010"
    }
  },
  "AGRIBANK/DIEN KHANH": {
    "msb": { "code": "56204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DIEN KHANH-56204008"
    }
  },
  "AGRIBANK/DIEN NAM DIEN NGOC": {
    "msb": { "code": "49204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN DIEN NAM - DIEN NGOC-49204022"
    }
  },
  "AGRIBANK/DINH HOA": {
    "msb": { "code": "19204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DINH HOA-19204003"
    }
  },
  "AGRIBANK/DINH LAP": {
    "msb": { "code": "20204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DINH LAP-20204013"
    }
  },
  "AGRIBANK/DINH QUAN": {
    "msb": { "code": "75204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DINH QUAN-75204014"
    }
  },
  "AGRIBANK/DO LUONG": {
    "msb": { "code": "40204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DO LUONG-40204014"
    }
  },
  "AGRIBANK/DO SON": {
    "msb": { "code": "31204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN QUAN DO SON-31204019"
    }
  },
  "AGRIBANK/DOAN HUNG": {
    "msb": { "code": "25204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DOAN HUNG-25204016"
    }
  },
  "AGRIBANK/DON DUONG": {
    "msb": { "code": "68204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DON DUONG-68204013"
    }
  },
  "AGRIBANK/DONG ANH": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/DONG BINH": {
    "msb": { "code": "36204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG BINH-36204013"
    }
  },
  "AGRIBANK/DONG DA (HN)": {
    "msb": { "code": "01204034" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG DA-01204034"
    }
  },
  "AGRIBANK/DONG DA (TP DA NANG)": {
    "msb": { "code": "48204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG DA -DA NANG-48204011"
    }
  },
  "AGRIBANK/DONG DANG": {
    "msb": { "code": "20204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG DANG-20204005"
    }
  },
  "AGRIBANK/DONG GIANG": {
    "msb": { "code": "49204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG GIANG-49204025"
    }
  },
  "AGRIBANK/DONG HA NOI": {
    "msb": { "code": "01204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG HA NOI-01204008"
    }
  },
  "AGRIBANK/DONG HAI": {
    "msb": { "code": "95204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HAI-95204008"
    }
  },
  "AGRIBANK/DONG HAI PHONG": {
    "msb": { "code": "31204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG HAI PHONG-31204006"
    }
  },
  "AGRIBANK/DONG HOA - DONG NAI": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/DONG HOA - PHU YEN": {
    "msb": { "code": "54204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HOA-54204006"
    }
  },
  "AGRIBANK/DONG HUNG": {
    "msb": { "code": "34204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HUNG-34204006"
    }
  },
  "AGRIBANK/DONG HY": {
    "msb": { "code": "19204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HY-19204006"
    }
  },
  "AGRIBANK/DONG KHOI": {
    "msb": { "code": "83204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG KHOI-83204003"
    }
  },
  "AGRIBANK/DONG MY HAI": {
    "msb": { "code": "58204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG MY HAI-58204008"
    }
  },
  "AGRIBANK/DONG NAI": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/DONG PHU": {
    "msb": { "code": "70204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG PHU-70204003"
    }
  },
  "AGRIBANK/DONG SAI GON": {
    "msb": { "code": "79204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG SAI GON-79204014"
    }
  },
  "AGRIBANK/DONG SON (THANH HOA)": {
    "msb": { "code": "38204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG SON-38204021"
    }
  },
  "AGRIBANK/DONG THAP": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/DONG TRIEU": {
    "msb": { "code": "22204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY QUANG NINH-22204003"
    }
  },
  "AGRIBANK/DONG VAN (HA GIANG)": {
    "msb": { "code": "02204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG VAN-02204002"
    }
  },
  "AGRIBANK/DONG XUAN - PHU YEN": {
    "msb": { "code": "54204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG XUAN-54204010"
    }
  },
  "AGRIBANK/DUC CO": {
    "msb": { "code": "64204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DUC CO-64204009"
    }
  },
  "AGRIBANK/DUC HOA": {
    "msb": { "code": "80204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUC HOA-80204008"
    }
  },
  "AGRIBANK/DUC HUE": {
    "msb": { "code": "80204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUC HUE-80204003"
    }
  },
  "AGRIBANK/DUC LIEU": {
    "msb": { "code": "70204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN DUC LIEU-70204004"
    }
  },
  "AGRIBANK/DUC LINH": {
    "msb": { "code": "60204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUC LINH-60204008"
    }
  },
  "AGRIBANK/DUC PHO": {
    "msb": { "code": "51204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUC PHO-51204010"
    }
  },
  "AGRIBANK/DUC THO": {
    "msb": { "code": "42204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DUC THO-42204007"
    }
  },
  "AGRIBANK/DUC TRONG": {
    "msb": { "code": "68204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN LAM DONG II-68204004"
    }
  },
  "AGRIBANK/DUNG QUAT": {
    "msb": { "code": "51204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DUNG QUAT-51204005"
    }
  },
  "AGRIBANK/DUONG KINH": {
    "msb": { "code": "31204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN QUAN DUONG KINH-31204020"
    }
  },
  "AGRIBANK/DUONG MINH CHAU": {
    "msb": { "code": "72204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN H.DUONG MINH CHAU-72204008"
    }
  },
  "AGRIBANK/DUY TIEN": {
    "msb": { "code": "35204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUY TIEN-35204004"
    }
  },
  "AGRIBANK/DUY XUYEN": {
    "msb": { "code": "49204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUY XUYEN-49204023"
    }
  },
  "AGRIBANK/DUYEN HAI": {
    "msb": { "code": "84204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUYEN HAI-84204007"
    }
  },
  "AGRIBANK/EA HLEO": {
    "msb": { "code": "66204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN EA H' LEO-66204030"
    }
  },
  "AGRIBANK/EA KAR": {
    "msb": { "code": "66204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN EA KAR-66204002"
    }
  },
  "AGRIBANK/EA KNOP": {
    "msb": { "code": "66204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN EA KNOP-66204005"
    }
  },
  "AGRIBANK/EA PHE": {
    "msb": { "code": "66204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN EA PHE - DAKLAK-66204014"
    }
  },
  "AGRIBANK/EA RAL": {
    "msb": { "code": "66204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN EA RAL - DAKLAK-66204016"
    }
  },
  "AGRIBANK/EA SOUP": {
    "msb": { "code": "66204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN EA SUP-66204009"
    }
  },
  "AGRIBANK/EA TAM": {
    "msb": { "code": "66204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN EA TAM - DAKLAK-66204026"
    }
  },
  "AGRIBANK/EA TO": {
    "msb": { "code": "66204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN EA TOH-66204021"
    }
  },
  "AGRIBANK/GIA BINH": {
    "msb": { "code": "27204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIA BINH-27204009"
    }
  },
  "AGRIBANK/GIA CAM": {
    "msb": { "code": "25204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA CAM-25204014"
    }
  },
  "AGRIBANK/GIA DINH - CN MIEN DONG": {
    "msb": { "code": "79204037" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN MIEN DONG-79204037"
    }
  },
  "AGRIBANK/GIA DINH HCM": {
    "msb": { "code": "79204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA DINH-79204021"
    }
  },
  "AGRIBANK/GIA LAI": {
    "msb": { "code": "64204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH GIA LAI-64204001"
    }
  },
  "AGRIBANK/GIA LAM - HA NOI": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/GIA LOC": {
    "msb": { "code": "30204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIA LOC-30204006"
    }
  },
  "AGRIBANK/GIA VIEN": {
    "msb": { "code": "37204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIA VIEN-37204007"
    }
  },
  "AGRIBANK/GIANG VO": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/GIAO THUY": {
    "msb": { "code": "36204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIAO THUY-36204010"
    }
  },
  "AGRIBANK/GIO LINH": {
    "msb": { "code": "45204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIO LINH-45204008"
    }
  },
  "AGRIBANK/GIONG RIENG": {
    "msb": { "code": "91204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIONG RIENG-91204005"
    }
  },
  "AGRIBANK/GIONG TROM": {
    "msb": { "code": "83204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIONG TROM-83204010"
    }
  },
  "AGRIBANK/GO CONG DONG": {
    "msb": { "code": "82204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GO CONG DONG-82204006"
    }
  },
  "AGRIBANK/GO CONG TAY": {
    "msb": { "code": "82204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GO CONG TAY-82204007"
    }
  },
  "AGRIBANK/GO DAU": {
    "msb": { "code": "72204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN GO DAU - TAY NINH-72204011"
    }
  },
  "AGRIBANK/GO QUAO": {
    "msb": { "code": "91204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GO QUAO-91204010"
    }
  },
  "AGRIBANK/HA GIANG": {
    "msb": { "code": "02204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA GIANG-02204001"
    }
  },
  "AGRIBANK/HA HOA": {
    "msb": { "code": "25204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA HOA-25204009"
    }
  },
  "AGRIBANK/HA LANG": {
    "msb": { "code": "04204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA LANG-04204002"
    }
  },
  "AGRIBANK/HA LONG I": {
    "msb": { "code": "22204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HA LONG I-22204017"
    }
  },
  "AGRIBANK/HA NAM": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/HA NOI": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/HA NOI II": {
    "msb": { "code": "01204035" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CN HA NOI II-01204035"
    }
  },
  "AGRIBANK/HA QUANG": {
    "msb": { "code": "04204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA QUANG-04204005"
    }
  },
  "AGRIBANK/HA TAY": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/HA THANH": {
    "msb": { "code": "01204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA THANH-01204032"
    }
  },
  "AGRIBANK/HA TINH": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/HA TRUNG": {
    "msb": { "code": "38204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA TRUNG-38204003"
    }
  },
  "AGRIBANK/HAI BA TRUNG - CN THU DO HN": {
    "msb": { "code": "01204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DO-01204030"
    }
  },
  "AGRIBANK/HAI BA TRUNG - HA NOI": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/HAI CHAU": {
    "msb": { "code": "48204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI CHAU-48204003"
    }
  },
  "AGRIBANK/HAI DUONG": {
    "msb": { "code": "30204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HAI DUONG-30204001"
    }
  },
  "AGRIBANK/HAI HA": {
    "msb": { "code": "22204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAI HA-22204013"
    }
  },
  "AGRIBANK/HAI HAU": {
    "msb": { "code": "36204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAI HAU-36204012"
    }
  },
  "AGRIBANK/HAI LANG": {
    "msb": { "code": "45204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAI LANG-45204004"
    }
  },
  "AGRIBANK/HAI PHONG": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/HAM MY": {
    "msb": { "code": "60204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN HAM MY-60204011"
    }
  },
  "AGRIBANK/HAM TAN": {
    "msb": { "code": "60204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAM TAN-60204014"
    }
  },
  "AGRIBANK/HAM THUAN BAC": {
    "msb": { "code": "60204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAM THUAN BAC-60204004"
    }
  },
  "AGRIBANK/HAM THUAN NAM": {
    "msb": { "code": "60204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAM THUAN NAM-60204012"
    }
  },
  "AGRIBANK/HAM YEN": {
    "msb": { "code": "08204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAM YEN-08204004"
    }
  },
  "AGRIBANK/HAU GIANG": {
    "msb": { "code": "93204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAU GIANG-93204001"
    }
  },
  "AGRIBANK/HAU LOC": {
    "msb": { "code": "38204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN HAU LOC-38204020"
    }
  },
  "AGRIBANK/HIEP DUC": {
    "msb": { "code": "49204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HIEP DUC-49204005"
    }
  },
  "AGRIBANK/HIEP HOA": {
    "msb": { "code": "24204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HIEP HOA-24204012"
    }
  },
  "AGRIBANK/HIEP PHUOC": {
    "msb": { "code": "79204050" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HIEP PHUOC-79204050"
    }
  },
  "AGRIBANK/HIEP THANH (TINH LAM DONG)": {
    "msb": { "code": "68204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN DUC TRONG - LAM DONG-68204007"
    }
  },
  "AGRIBANK/HOA AN (CAO BANG)": {
    "msb": { "code": "04204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOA AN-04204004"
    }
  },
  "AGRIBANK/HOA AN (HAU GIANG)": {
    "msb": { "code": "93204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAU GIANG-93204001"
    }
  },
  "AGRIBANK/HOA BINH (BAC LIEU)": {
    "msb": { "code": "95204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOA BINH-95204005"
    }
  },
  "AGRIBANK/HOA BINH (TINH HOA BINH)": {
    "msb": { "code": "17204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HOA BINH-17204001"
    }
  },
  "AGRIBANK/HOA KHANH": {
    "msb": { "code": "66204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA KHANH - DAKLAK-66204025"
    }
  },
  "AGRIBANK/HOA LAC": {
    "msb": { "code": "01204038" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA LAC - HA TAY-01204038"
    }
  },
  "AGRIBANK/HOA LU (GIA LAI)": {
    "msb": { "code": "64204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA LU - GIA LAI-64204018"
    }
  },
  "AGRIBANK/HOA LU (NINH BINH)": {
    "msb": { "code": "37204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOA LU-37204002"
    }
  },
  "AGRIBANK/HOA LUU (HAU GIANG)": {
    "msb": { "code": "93204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA LUU-93204004"
    }
  },
  "AGRIBANK/HOA NINH (LAM DONG)": {
    "msb": { "code": "68204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA NINH - LAM DONG-68204008"
    }
  },
  "AGRIBANK/HOA THANG": {
    "msb": { "code": "66204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA THANG - DAKLAK-66204018"
    }
  },
  "AGRIBANK/HOA THANH": {
    "msb": { "code": "72204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOA THANH-72204005"
    }
  },
  "AGRIBANK/HOA THUAN": {
    "msb": { "code": "66204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA THUAN - DAKLAK-66204029"
    }
  },
  "AGRIBANK/HOA VANG": {
    "msb": { "code": "48204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA VANG DN-48204002"
    }
  },
  "AGRIBANK/HOAI AN": {
    "msb": { "code": "52204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOAI AN-52204010"
    }
  },
  "AGRIBANK/HOAI NHON": {
    "msb": { "code": "52204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOAI NHON-52204008"
    }
  },
  "AGRIBANK/HOAN KIEM": {
    "msb": { "code": "01204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOAN KIEM-01204022"
    }
  },
  "AGRIBANK/HOANG HOA": {
    "msb": { "code": "38204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOANG HOA-38204009"
    }
  },
  "AGRIBANK/HOANG MAI (HN)": {
    "msb": { "code": "01204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG MAI- HA NOI-01204020"
    }
  },
  "AGRIBANK/HOANG MAI (TP VINH)": {
    "msb": { "code": "40204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG MAI-NGHE AN-40204005"
    }
  },
  "AGRIBANK/HOANG QUOC VIET": {
    "msb": { "code": "01204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG QUOC VIET-01204023"
    }
  },
  "AGRIBANK/HOANG SU PHI": {
    "msb": { "code": "02204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOANG SU PHI-02204007"
    }
  },
  "AGRIBANK/HOANH BO": {
    "msb": { "code": "22204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOANH BO-22204014"
    }
  },
  "AGRIBANK/HOC MON": {
    "msb": { "code": "79204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HOC MON-79204013"
    }
  },
  "AGRIBANK/HOI AN": {
    "msb": { "code": "49204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN TP HOI AN-49204011"
    }
  },
  "AGRIBANK/HOI SO CHINH": {
    "msb": { "code": "01204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOI SO CHINH-01204001"
    }
  },
  "AGRIBANK/HOI THUONG": {
    "msb": { "code": "64204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOI THUONG-64204011"
    }
  },
  "AGRIBANK/HON DAT": {
    "msb": { "code": "91204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HON DAT-91204011"
    }
  },
  "AGRIBANK/HONG DAN": {
    "msb": { "code": "95204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HONG DAN-95204004"
    }
  },
  "AGRIBANK/HONG HA": {
    "msb": { "code": "01204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HONG HA-01204018"
    }
  },
  "AGRIBANK/HONG NGU": {
    "msb": { "code": "87204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN TX HONG NGU-87204002"
    }
  },
  "AGRIBANK/HUE": {
    "msb": { "code": "46204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN CN THUA THIEN HUE-46204001"
    }
  },
  "AGRIBANK/HUNG HA": {
    "msb": { "code": "34204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUNG HA-34204011"
    }
  },
  "AGRIBANK/HUNG NGUYEN": {
    "msb": { "code": "40204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUNG NGUYEN-40204009"
    }
  },
  "AGRIBANK/HUNG VUONG (HCM)": {
    "msb": { "code": "79204034" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG VUONG-HCM-79204034"
    }
  },
  "AGRIBANK/HUNG VUONG (HN)": {
    "msb": { "code": "01204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG VUONG- HA NOI-01204028"
    }
  },
  "AGRIBANK/HUNG YEN": {
    "msb": { "code": "33204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HUNG YEN-33204001"
    }
  },
  "AGRIBANK/HUONG AN": {
    "msb": { "code": "49204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN HUONG AN-49204004"
    }
  },
  "AGRIBANK/HUONG HOA": {
    "msb": { "code": "45204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUONG HOA-45204009"
    }
  },
  "AGRIBANK/HUONG KHE": {
    "msb": { "code": "42204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUONG KHE-42204005"
    }
  },
  "AGRIBANK/HUONG SON": {
    "msb": { "code": "42204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUONG SON-42204015"
    }
  },
  "AGRIBANK/HUONG THUY": {
    "msb": { "code": "46204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUONG THUY-46204007"
    }
  },
  "AGRIBANK/HUONG TRA": {
    "msb": { "code": "46204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUONG TRA-46204005"
    }
  },
  "AGRIBANK/HUU LUNG": {
    "msb": { "code": "20204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUU LUNG-20204004"
    }
  },
  "AGRIBANK/HUYEN CHUONG MY": {
    "msb": { "code": "01204050" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.CHUONG MY - HA TAY-01204050"
    }
  },
  "AGRIBANK/HUYEN CO TO": {
    "msb": { "code": "22204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CO TO-22204002"
    }
  },
  "AGRIBANK/HUYEN DAK GLEI": {
    "msb": { "code": "62204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAKGLEI-62204007"
    }
  },
  "AGRIBANK/HUYEN DAM HA": {
    "msb": { "code": "22204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAM HA DONG QUANG NINH-22204007"
    }
  },
  "AGRIBANK/HUYEN DAN PHUONG": {
    "msb": { "code": "01204045" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.DAN PHUONG - HA TAY-01204045"
    }
  },
  "AGRIBANK/HUYEN DIEN BIEN": {
    "msb": { "code": "11204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DIEN BIEN-11204002"
    }
  },
  "AGRIBANK/HUYEN HOAI DUC": {
    "msb": { "code": "01204037" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.HOAI DUC - HA TAY-01204037"
    }
  },
  "AGRIBANK/HUYEN KON RAY": {
    "msb": { "code": "62204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KON TUM-62204001"
    }
  },
  "AGRIBANK/HUYEN MY DUC": {
    "msb": { "code": "01204040" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.MY DUC - HA TAY-01204040"
    }
  },
  "AGRIBANK/HUYEN PHUC THO": {
    "msb": { "code": "01204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.PHUC THO - HA TAY-01204021"
    }
  },
  "AGRIBANK/HUYEN QUOC OAI": {
    "msb": { "code": "01204043" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.QUOC OAI - HA TAY-01204043"
    }
  },
  "AGRIBANK/HUYEN SA THAY": {
    "msb": { "code": "62204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SA THAY-62204009"
    }
  },
  "AGRIBANK/HUYEN THACH THAT": {
    "msb": { "code": "01204047" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THACH THAT - HA TAY-01204047"
    }
  },
  "AGRIBANK/HUYEN THANH OAI": {
    "msb": { "code": "01204039" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THANH OAI - HA TAY-01204039"
    }
  },
  "AGRIBANK/HUYEN THUONG TIN": {
    "msb": { "code": "01204042" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THUONG TIN - HA TAY-01204042"
    }
  },
  "AGRIBANK/HUYEN TRIEU PHONG (QUANG TRI)": {
    "msb": { "code": "45204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRIEU PHONG-45204011"
    }
  },
  "AGRIBANK/HUYEN UNG HOA": {
    "msb": { "code": "01204041" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.UNG HOA - HA TAY-01204041"
    }
  },
  "AGRIBANK/HUYEN VAN DON (QUANG NINH)": {
    "msb": { "code": "22204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN DON-22204015"
    }
  },
  "AGRIBANK/IA GRAI": {
    "msb": { "code": "64204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN IA GRAI-64204004"
    }
  },
  "AGRIBANK/IAPA": {
    "msb": { "code": "64204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN IAPA-64204023"
    }
  },
  "AGRIBANK/KBANG": {
    "msb": { "code": "64204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KBANG-64204007"
    }
  },
  "AGRIBANK/KCN BIEN HOA": {
    "msb": { "code": "75204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC DONG NAI-75204002"
    }
  },
  "AGRIBANK/KCN DA NANG": {
    "msb": { "code": "48204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN KCN DA NANG-48204014"
    }
  },
  "AGRIBANK/KCN DINH TRAM": {
    "msb": { "code": "24204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN KCN DINH TRAM-24204005"
    }
  },
  "AGRIBANK/KCN HOA KHANH": {
    "msb": { "code": "48204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN KCN HOA KHANH-48204013"
    }
  },
  "AGRIBANK/KCN HOA PHU": {
    "msb": { "code": "86204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN KCN HOA PHU-86204008"
    }
  },
  "AGRIBANK/KCN HOA XA": {
    "msb": { "code": "36204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NAM DINH-36204002"
    }
  },
  "AGRIBANK/KCN MINH DUC": {
    "msb": { "code": "33204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN KCN MINH DUC-33204002"
    }
  },
  "AGRIBANK/KCN MY THO (BINH DUC)": {
    "msb": { "code": "82204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN KCN MY THO-82204012"
    }
  },
  "AGRIBANK/KCN SONG THAN": {
    "msb": { "code": "74204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN KCN SONG THAN-74204002"
    }
  },
  "AGRIBANK/KCN TAM PHUOC": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN KCN TAM PHUOC-75204010"
    }
  },
  "AGRIBANK/KCN TAN CHINH": {
    "msb": { "code": "48204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN CHINH -DA NANG-48204017"
    }
  },
  "AGRIBANK/KCN TAN TAO": {
    "msb": { "code": "79204045" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN TAO-79204045"
    }
  },
  "AGRIBANK/KCN TAN THANH": {
    "msb": { "code": "77204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN KCN TAN THANH-77204005"
    }
  },
  "AGRIBANK/KCN THU TAI": {
    "msb": { "code": "52204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH DINH-52204001"
    }
  },
  "AGRIBANK/KCN TIEN SON": {
    "msb": { "code": "27204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN KCN TIEN SON BAC NINH II-27204007"
    }
  },
  "AGRIBANK/KCN TRANG BANG": {
    "msb": { "code": "72204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN KCN TRANG BANG-72204004"
    }
  },
  "AGRIBANK/KE SACH": {
    "msb": { "code": "94204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KE SACH-94204005"
    }
  },
  "AGRIBANK/KHANH HOA": {
    "msb": { "code": "56204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KHANH HOA-56204001"
    }
  },
  "AGRIBANK/KHANH SON": {
    "msb": { "code": "56204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KHANH SON-56204013"
    }
  },
  "AGRIBANK/KHANH VINH": {
    "msb": { "code": "56204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KHANH VINH-56204012"
    }
  },
  "AGRIBANK/KHOAI CHAU": {
    "msb": { "code": "33204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN KHOAI CHAU-33204007"
    }
  },
  "AGRIBANK/KHU KINH TE VUNG ANG": {
    "msb": { "code": "42204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN KHU KINH TE VUNG ANG-42204017"
    }
  },
  "AGRIBANK/KIEN AN": {
    "msb": { "code": "31204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN KIEN AN HP-31204014"
    }
  },
  "AGRIBANK/KIEN GIANG": {
    "msb": { "code": "91204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KIEN GIANG-91204001"
    }
  },
  "AGRIBANK/KIEN HAI": {
    "msb": { "code": "91204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIEN HAI-91204003"
    }
  },
  "AGRIBANK/KIEN LUONG": {
    "msb": { "code": "91204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIEN LUONG-91204009"
    }
  },
  "AGRIBANK/KIEN THUY": {
    "msb": { "code": "31204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN KIEN THUY HP-31204013"
    }
  },
  "AGRIBANK/KIEN XUONG": {
    "msb": { "code": "34204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIEN XUONG-34204010"
    }
  },
  "AGRIBANK/KIM BANG": {
    "msb": { "code": "35204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM BANG-35204005"
    }
  },
  "AGRIBANK/KIM BOI": {
    "msb": { "code": "17204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM BOI-17204012"
    }
  },
  "AGRIBANK/KIM DONG - HUNG YEN": {
    "msb": { "code": "33204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM DONG-33204008"
    }
  },
  "AGRIBANK/KIM NGAN": {
    "msb": { "code": "66204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN KIM NGAN - DAKLAK-66204010"
    }
  },
  "AGRIBANK/KIM SON": {
    "msb": { "code": "37204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM SON-37204006"
    }
  },
  "AGRIBANK/KIM TAN": {
    "msb": { "code": "10204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN CN KIM TAN-10204003"
    }
  },
  "AGRIBANK/KIM THANH - HAI DUONG": {
    "msb": { "code": "30204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM THANH-30204003"
    }
  },
  "AGRIBANK/KIM THANH - LAO CAI": {
    "msb": { "code": "10204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN CN KIM THANH-10204013"
    }
  },
  "AGRIBANK/KINH MON": {
    "msb": { "code": "30204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KINH MON-30204011"
    }
  },
  "AGRIBANK/KKT MO CHU LAI": {
    "msb": { "code": "49204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN KHU KTM CHU LAI-49204010"
    }
  },
  "AGRIBANK/KON TUM": {
    "msb": { "code": "62204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KON TUM-62204001"
    }
  },
  "AGRIBANK/KONGCHRO": {
    "msb": { "code": "64204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH GIA LAI-64204001"
    }
  },
  "AGRIBANK/KRONG ANA": {
    "msb": { "code": "66204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN KRONG ANA-66204022"
    }
  },
  "AGRIBANK/KRONG BONG": {
    "msb": { "code": "66204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KRONG BONG-66204004"
    }
  },
  "AGRIBANK/KRONG BUK": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/KRONG NANG": {
    "msb": { "code": "66204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KRONG NANG-66204015"
    }
  },
  "AGRIBANK/KRONG NO": {
    "msb": { "code": "67204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN CN KRONG NO-67204008"
    }
  },
  "AGRIBANK/KRONG PA": {
    "msb": { "code": "64204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KRONG PA-64204006"
    }
  },
  "AGRIBANK/KRONG PAK": {
    "msb": { "code": "66204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KRONG PAK-66204013"
    }
  },
  "AGRIBANK/KV 2 (LONG AN)": {
    "msb": { "code": "80204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC II - LONG AN-80204019"
    }
  },
  "AGRIBANK/KV CAT HAI": {
    "msb": { "code": "31204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN CAT HAI HP-31204008"
    }
  },
  "AGRIBANK/KV CAU VOI": {
    "msb": { "code": "80204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC CAU VOI-80204010"
    }
  },
  "AGRIBANK/KV DUC HOA": {
    "msb": { "code": "80204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC DUC HOA-80204012"
    }
  },
  "AGRIBANK/KV GO DEN": {
    "msb": { "code": "80204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC GO DEN-80204009"
    }
  },
  "AGRIBANK/KV LAM SON": {
    "msb": { "code": "38204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN LAM SON-THANH HOA-38204006"
    }
  },
  "AGRIBANK/KV MIA DUONG TAN HUNG": {
    "msb": { "code": "72204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN KV MIA DUONG TAN HUNG-72204003"
    }
  },
  "AGRIBANK/KV SAN THANG": {
    "msb": { "code": "12204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAI CHAU-12204001"
    }
  },
  "AGRIBANK/KV TRIEU HAI": {
    "msb": { "code": "45204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN TX QUANG TRI-45204007"
    }
  },
  "AGRIBANK/KV1 THAI BINH": {
    "msb": { "code": "34204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC I - THAI BINH-34204008"
    }
  },
  "AGRIBANK/KV3 (LONG AN)": {
    "msb": { "code": "80204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LONG AN-80204001"
    }
  },
  "AGRIBANK/KY ANH": {
    "msb": { "code": "42204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KY ANH-42204011"
    }
  },
  "AGRIBANK/KY SON (HAI PHONG)": {
    "msb": { "code": "31204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN KY SON-31204024"
    }
  },
  "AGRIBANK/KY SON (HOA BINH)": {
    "msb": { "code": "17204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KY SON- HOA BINH-17204006"
    }
  },
  "AGRIBANK/KY SON (NGHE AN)": {
    "msb": { "code": "40204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KY SON - NGHE AN-40204012"
    }
  },
  "AGRIBANK/LAC DUONG": {
    "msb": { "code": "68204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN LAC DUONG - LAM DONG-68204009"
    }
  },
  "AGRIBANK/LAC SON": {
    "msb": { "code": "17204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAC SON-17204009"
    }
  },
  "AGRIBANK/LAC THUY": {
    "msb": { "code": "17204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN LAC THUY-17204011"
    }
  },
  "AGRIBANK/LAGI (BINH THUAN)": {
    "msb": { "code": "60204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN TX LA GI-60204013"
    }
  },
  "AGRIBANK/LAI CHAU": {
    "msb": { "code": "12204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAI CHAU-12204001"
    }
  },
  "AGRIBANK/LAI VUNG": {
    "msb": { "code": "87204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAI VUNG-87204010"
    }
  },
  "AGRIBANK/LAK": {
    "msb": { "code": "66204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAK-66204024"
    }
  },
  "AGRIBANK/LAM DONG": {
    "msb": { "code": "68204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAM DONG-68204001"
    }
  },
  "AGRIBANK/LAM HA": {
    "msb": { "code": "68204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAM HA-68204012"
    }
  },
  "AGRIBANK/LAM THAO": {
    "msb": { "code": "25204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAM THAO-25204005"
    }
  },
  "AGRIBANK/LANG CHANH": {
    "msb": { "code": "38204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LANG CHANH-38204031"
    }
  },
  "AGRIBANK/LANG GIANG": {
    "msb": { "code": "24204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LANG GIANG-24204013"
    }
  },
  "AGRIBANK/LANG HA": {
    "msb": { "code": "01204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LANG HA-01204010"
    }
  },
  "AGRIBANK/LAO BAO": {
    "msb": { "code": "45204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN CN LAO BAO-45204003"
    }
  },
  "AGRIBANK/LAO CAI": {
    "msb": { "code": "10204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAO CAI-10204001"
    }
  },
  "AGRIBANK/LAP THACH": {
    "msb": { "code": "26204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAP THACH-26204005"
    }
  },
  "AGRIBANK/LAP VO": {
    "msb": { "code": "87204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAP VO-87204007"
    }
  },
  "AGRIBANK/LE HONG PHONG (DAKLAK)": {
    "msb": { "code": "66204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN LE HONG PHONG - DAK LAK-66204028"
    }
  },
  "AGRIBANK/LE LOI (HCM)": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/LE QUANG DINH-CN GIA DINH-HCM": {
    "msb": { "code": "79204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA DINH-79204021"
    }
  },
  "AGRIBANK/LE THUY": {
    "msb": { "code": "44204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LE THUY-44204003"
    }
  },
  "AGRIBANK/LIEN CHIEU": {
    "msb": { "code": "48204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN LIEN CHIEU DN-48204008"
    }
  },
  "AGRIBANK/LOC AN": {
    "msb": { "code": "68204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN LOC AN - NAM LAM DONG-68204014"
    }
  },
  "AGRIBANK/LOC BINH": {
    "msb": { "code": "20204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LOC BINH-20204007"
    }
  },
  "AGRIBANK/LOC HA": {
    "msb": { "code": "42204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LOC HA-42204004"
    }
  },
  "AGRIBANK/LOC HIEP": {
    "msb": { "code": "70204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN LOC HIEP-70204011"
    }
  },
  "AGRIBANK/LOC NINH": {
    "msb": { "code": "70204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LOC NINH-70204006"
    }
  },
  "AGRIBANK/LOC PHAT": {
    "msb": { "code": "68204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN LOC PHAT - NAM LAM DONG-68204016"
    }
  },
  "AGRIBANK/LOC THANH": {
    "msb": { "code": "68204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN LOC THANH - NAM LAM DONG-68204017"
    }
  },
  "AGRIBANK/LONG AN": {
    "msb": { "code": "80204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LONG AN-80204001"
    }
  },
  "AGRIBANK/LONG BIEN": {
    "msb": { "code": "01204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LONG BIEN-01204019"
    }
  },
  "AGRIBANK/LONG DIEN (BA RIA VUNG TAU)": {
    "msb": { "code": "77204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LONG DIEN-77204006"
    }
  },
  "AGRIBANK/LONG HO": {
    "msb": { "code": "86204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LONG HO-86204004"
    }
  },
  "AGRIBANK/LONG MY": {
    "msb": { "code": "93204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LONG MY-93204002"
    }
  },
  "AGRIBANK/LONG PHU": {
    "msb": { "code": "94204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LONG PHU-94204009"
    }
  },
  "AGRIBANK/LONG THANH": {
    "msb": { "code": "75204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM DONG NAI-75204003"
    }
  },
  "AGRIBANK/LUC NAM": {
    "msb": { "code": "24204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUC NAM-24204007"
    }
  },
  "AGRIBANK/LUC NGAN": {
    "msb": { "code": "24204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUC NGAN-24204011"
    }
  },
  "AGRIBANK/LUC YEN": {
    "msb": { "code": "15204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUC YEN-15204006"
    }
  },
  "AGRIBANK/LUONG SON(BINH THUAN)": {
    "msb": { "code": "60204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN LUONG SON-60204010"
    }
  },
  "AGRIBANK/LUONG SON(HOA BINH)": {
    "msb": { "code": "17204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUONG SON-17204007"
    }
  },
  "AGRIBANK/LUONG TAI": {
    "msb": { "code": "27204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUONG TAI-27204004"
    }
  },
  "AGRIBANK/LY NHAN": {
    "msb": { "code": "35204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LY NHAN-35204007"
    }
  },
  "AGRIBANK/LY SON": {
    "msb": { "code": "51204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LY SON-51204004"
    }
  },
  "AGRIBANK/LY THAI TO": {
    "msb": { "code": "44204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN LY THAI TO - Q.BINH-44204011"
    }
  },
  "AGRIBANK/LY THUONG KIET (HCM)": {
    "msb": { "code": "79204047" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN LY THUONG KIET-HCM-79204047"
    }
  },
  "AGRIBANK/LY THUONG KIET (HN)": {
    "msb": { "code": "01204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LY THUONG KIET- HA NOI.-01204294"
    }
  },
  "AGRIBANK/LY THUONG KIET (QUANG BINH)": {
    "msb": { "code": "44204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN LY THUONG KIET - Q.BINH-44204008"
    }
  },
  "AGRIBANK/M DRAK": {
    "msb": { "code": "66204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN M' DRAK-66204006"
    }
  },
  "AGRIBANK/MAI CHAU": {
    "msb": { "code": "17204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MAI CHAU-17204003"
    }
  },
  "AGRIBANK/MAI SON": {
    "msb": { "code": "14204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MAI SON-14204011"
    }
  },
  "AGRIBANK/MANG THIT": {
    "msb": { "code": "86204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MANG THIT-86204006"
    }
  },
  "AGRIBANK/MANG YANG": {
    "msb": { "code": "64204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MANG YANG-64204008"
    }
  },
  "AGRIBANK/MAO KHE": {
    "msb": { "code": "22204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN MAO KHE-22204020"
    }
  },
  "AGRIBANK/ME LINH": {
    "msb": { "code": "01204051" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN ME LINH-01204051"
    }
  },
  "AGRIBANK/MEO VAC": {
    "msb": { "code": "02204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MEO VAC-02204003"
    }
  },
  "AGRIBANK/MIEN DONG": {
    "msb": { "code": "79204037" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN MIEN DONG-79204037"
    }
  },
  "AGRIBANK/MINH HOA (BINH DUONG)": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH DUONG-74204001"
    }
  },
  "AGRIBANK/MINH HOA (QUANG BINH)": {
    "msb": { "code": "44204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MINH HOA-44204010"
    }
  },
  "AGRIBANK/MINH LONG": {
    "msb": { "code": "51204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN MINH LONG-51204013"
    }
  },
  "AGRIBANK/MO CAY": {
    "msb": { "code": "83204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BEN TRE-83204001"
    }
  },
  "AGRIBANK/MO CAY NAM (BEN TRE)": {
    "msb": { "code": "83204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MO CAY NAM-83204005"
    }
  },
  "AGRIBANK/MO DUC": {
    "msb": { "code": "51204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MO DUC-51204007"
    }
  },
  "AGRIBANK/MOC CHAU": {
    "msb": { "code": "14204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MOC CHAU-14204009"
    }
  },
  "AGRIBANK/MONG CAI": {
    "msb": { "code": "22204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG QUANG NINH-22204005"
    }
  },
  "AGRIBANK/MU CANG CHAI": {
    "msb": { "code": "15204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MU CANG CHAI-15204010"
    }
  },
  "AGRIBANK/MUONG ANG": {
    "msb": { "code": "11204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN MUONG ANG-11204008"
    }
  },
  "AGRIBANK/MUONG CHA": {
    "msb": { "code": "11204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MUONG CHA-11204006"
    }
  },
  "AGRIBANK/MUONG KHUONG": {
    "msb": { "code": "10204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MUONG KHUONG-10204004"
    }
  },
  "AGRIBANK/MUONG LA": {
    "msb": { "code": "14204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MUONG LA-14204002"
    }
  },
  "AGRIBANK/MUONG LAY": {
    "msb": { "code": "11204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN TX MUONG LAY-11204009"
    }
  },
  "AGRIBANK/MUONG NHE": {
    "msb": { "code": "11204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MUONG NHE-11204010"
    }
  },
  "AGRIBANK/MUONG TE": {
    "msb": { "code": "12204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MUONG TE-12204006"
    }
  },
  "AGRIBANK/MY DINH": {
    "msb": { "code": "01204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN MY DINH-01204024"
    }
  },
  "AGRIBANK/MY HAO": {
    "msb": { "code": "33204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG YEN II-33204010"
    }
  },
  "AGRIBANK/MY LAM": {
    "msb": { "code": "91204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN MY LAM-91204015"
    }
  },
  "AGRIBANK/MY LOC": {
    "msb": { "code": "36204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN MY LOC-36204009"
    }
  },
  "AGRIBANK/MY LUONG": {
    "msb": { "code": "89204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN MY LUONG-89204015"
    }
  },
  "AGRIBANK/MY THANH (HCM)": {
    "msb": { "code": "79204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN MY THANH-79204049"
    }
  },
  "AGRIBANK/MY TU": {
    "msb": { "code": "94204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN MY TU-94204007"
    }
  },
  "AGRIBANK/MY XUYEN": {
    "msb": { "code": "94204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MY XUYEN-94204006"
    }
  },
  "AGRIBANK/NA HANG": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/NA RI": {
    "msb": { "code": "06204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NA RI-06204006"
    }
  },
  "AGRIBANK/NAM AM": {
    "msb": { "code": "31204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM AM-31204018"
    }
  },
  "AGRIBANK/NAM CAM PHA": {
    "msb": { "code": "22204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN H.NAM CAM PHA-22204019"
    }
  },
  "AGRIBANK/NAM CAN": {
    "msb": { "code": "96204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM CAN-96204008"
    }
  },
  "AGRIBANK/NAM DAN": {
    "msb": { "code": "40204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM DAN-40204010"
    }
  },
  "AGRIBANK/NAM DINH": {
    "msb": { "code": "36204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NAM DINH-36204001"
    }
  },
  "AGRIBANK/NAM DO": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/NAM DONG (DAC NONG)": {
    "msb": { "code": "67204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM DONG-67204007"
    }
  },
  "AGRIBANK/NAM DONG (HUE)": {
    "msb": { "code": "46204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM DONG-46204012"
    }
  },
  "AGRIBANK/NAM GIANG": {
    "msb": { "code": "49204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM GIANG-49204006"
    }
  },
  "AGRIBANK/NAM HA NOI": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/NAM HOA": {
    "msb": { "code": "79204039" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HOA-79204039"
    }
  },
  "AGRIBANK/NAM LAM DONG": {
    "msb": { "code": "68204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM LAM DONG-68204002"
    }
  },
  "AGRIBANK/NAM LUONG SON(HOA BINH)": {
    "msb": { "code": "17204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUONG SON-17204007"
    }
  },
  "AGRIBANK/NAM PHAN THIET": {
    "msb": { "code": "60204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM PHAN THIET-60204002"
    }
  },
  "AGRIBANK/NAM PHUOC": {
    "msb": { "code": "49204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM PHUOC-49204003"
    }
  },
  "AGRIBANK/NAM SACH": {
    "msb": { "code": "30204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM SACH-30204002"
    }
  },
  "AGRIBANK/NAM SAI GON": {
    "msb": { "code": "79204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM SAI GON-79204026"
    }
  },
  "AGRIBANK/NAM SONG HUONG": {
    "msb": { "code": "46204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM SONG HUONG-46204002"
    }
  },
  "AGRIBANK/NAM TP TUY HOA": {
    "msb": { "code": "54204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM TP TUY HOA-54204011"
    }
  },
  "AGRIBANK/NAM TRA MY": {
    "msb": { "code": "49204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM TRA MY-49204016"
    }
  },
  "AGRIBANK/NAM TRUC": {
    "msb": { "code": "36204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM TRUC-36204004"
    }
  },
  "AGRIBANK/NGA NAM": {
    "msb": { "code": "94204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGA NAM-94204008"
    }
  },
  "AGRIBANK/NGA SON": {
    "msb": { "code": "38204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGA SON-38204029"
    }
  },
  "AGRIBANK/NGAN SON": {
    "msb": { "code": "06204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGAN SON-06204004"
    }
  },
  "AGRIBANK/NGHE AN": {
    "msb": { "code": "40204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN NGHE AN-40204001"
    }
  },
  "AGRIBANK/NGHI LOC": {
    "msb": { "code": "40204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHI LOC-40204008"
    }
  },
  "AGRIBANK/NGHI SON": {
    "msb": { "code": "38204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN NGHI SON-38204019"
    }
  },
  "AGRIBANK/NGHI XUAN": {
    "msb": { "code": "42204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHI XUAN-42204009"
    }
  },
  "AGRIBANK/NGHIA DAN": {
    "msb": { "code": "40204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHIA DAN-40204003"
    }
  },
  "AGRIBANK/NGHIA HANH": {
    "msb": { "code": "51204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHIA HANH-51204014"
    }
  },
  "AGRIBANK/NGHIA HUNG": {
    "msb": { "code": "36204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHIA HUNG-36204006"
    }
  },
  "AGRIBANK/NGHIA LO": {
    "msb": { "code": "15204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN THI XA NGHIA LO-15204011"
    }
  },
  "AGRIBANK/NGO QUYEN": {
    "msb": { "code": "31204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NGO QUYEN HP-31204005"
    }
  },
  "AGRIBANK/NGOC HIEN": {
    "msb": { "code": "96204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGOC HIEN-96204006"
    }
  },
  "AGRIBANK/NGOC HOI": {
    "msb": { "code": "62204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGOC HOI - KON TUM-62204005"
    }
  },
  "AGRIBANK/NGOC LAC": {
    "msb": { "code": "38204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGOC LAC-38204032"
    }
  },
  "AGRIBANK/NGU HANH SON": {
    "msb": { "code": "48204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN NGU HANH SON-48204006"
    }
  },
  "AGRIBANK/NGU LAO": {
    "msb": { "code": "31204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NGU LAO-31204017"
    }
  },
  "AGRIBANK/NGUYEN BINH": {
    "msb": { "code": "04204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGUYEN BINH-04204003"
    }
  },
  "AGRIBANK/NHA BE": {
    "msb": { "code": "79204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NHA BE-79204011"
    }
  },
  "AGRIBANK/NHAN CHINH": {
    "msb": { "code": "01204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HA NOI-01204007"
    }
  },
  "AGRIBANK/NHO QUAN": {
    "msb": { "code": "37204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NHO QUAN-37204003"
    }
  },
  "AGRIBANK/NHON TRACH": {
    "msb": { "code": "75204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN H.NHON TRACH NAM DONG NAI-75204007"
    }
  },
  "AGRIBANK/NHU THANH": {
    "msb": { "code": "38204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NHU THANH-38204017"
    }
  },
  "AGRIBANK/NHU XUAN": {
    "msb": { "code": "38204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NHU XUAN-38204011"
    }
  },
  "AGRIBANK/NINH BINH": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/NINH GIANG": {
    "msb": { "code": "30204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH GIANG-30204008"
    }
  },
  "AGRIBANK/NINH HAI": {
    "msb": { "code": "58204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH HAI-58204004"
    }
  },
  "AGRIBANK/NINH HOA": {
    "msb": { "code": "56204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH HOA-56204005"
    }
  },
  "AGRIBANK/NINH KIEU": {
    "msb": { "code": "92204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN NINH KIEU-92204009"
    }
  },
  "AGRIBANK/NINH PHUOC - NINH THUAN": {
    "msb": { "code": "58204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH PHUOC-58204005"
    }
  },
  "AGRIBANK/NINH SON": {
    "msb": { "code": "58204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH SON-58204003"
    }
  },
  "AGRIBANK/NINH THUAN": {
    "msb": { "code": "58204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH THUAN-58204001"
    }
  },
  "AGRIBANK/NO TRANG LONG": {
    "msb": { "code": "66204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN NO TRANG LONG - DAK LAK-66204027"
    }
  },
  "AGRIBANK/NONG CONG": {
    "msb": { "code": "38204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NONG CONG-38204012"
    }
  },
  "AGRIBANK/NONG SON": {
    "msb": { "code": "49204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NONG SON-49204013"
    }
  },
  "AGRIBANK/NUI THANH": {
    "msb": { "code": "49204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NUI THANH-49204027"
    }
  },
  "AGRIBANK/ONG ICH KHIEM": {
    "msb": { "code": "48204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN ONG ICH KHIEM -DA NANG-48204015"
    }
  },
  "AGRIBANK/PAC NAM": {
    "msb": { "code": "06204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PAC NAM-06204005"
    }
  },
  "AGRIBANK/PGD  CUA LO": {
    "msb": { "code": "40204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TX CUA LO-40204013"
    }
  },
  "AGRIBANK/PGD 1 (HA NOI)": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD 1 (QUAN 6)": {
    "msb": { "code": "79204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 6-79204008"
    }
  },
  "AGRIBANK/PGD 1 (TP YEN BAI II)": {
    "msb": { "code": "15204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO YEN BAI II-15204003"
    }
  },
  "AGRIBANK/PGD 1 (TX DONG HA)": {
    "msb": { "code": "45204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN TP DONG HA-45204002"
    }
  },
  "AGRIBANK/PGD 10 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 10 (TP YEN BAI II)": {
    "msb": { "code": "15204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO YEN BAI II-15204003"
    }
  },
  "AGRIBANK/PGD 103 (KCN DINH TRAM)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD 12 (KCN DINH TRAM)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD 14 (HA NOI)": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD 2 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 2 (QUAN 6)": {
    "msb": { "code": "79204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 6-79204008"
    }
  },
  "AGRIBANK/PGD 2 (TP YEN BAI II)": {
    "msb": { "code": "15204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO YEN BAI II-15204003"
    }
  },
  "AGRIBANK/PGD 2 (TX DONG HA)": {
    "msb": { "code": "45204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN TP DONG HA-45204002"
    }
  },
  "AGRIBANK/PGD 2/9 (DA NANG)": {
    "msb": { "code": "48204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI CHAU-48204003"
    }
  },
  "AGRIBANK/PGD 3 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 3 (TP YEN BAI)": {
    "msb": { "code": "15204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN TP YEN BAI-15204002"
    }
  },
  "AGRIBANK/PGD 3/2 (NAM DINH)": {
    "msb": { "code": "36204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM TRUC-36204004"
    }
  },
  "AGRIBANK/PGD 3/2 (NGHE AN)": {
    "msb": { "code": "40204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUY HOP-40204006"
    }
  },
  "AGRIBANK/PGD 4 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 4 (TP YEN BAI)": {
    "msb": { "code": "15204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN TP YEN BAI-15204002"
    }
  },
  "AGRIBANK/PGD 5 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 5 (TP YEN BAI II)": {
    "msb": { "code": "15204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO YEN BAI II-15204003"
    }
  },
  "AGRIBANK/PGD 54 (TAM TRINH)": {
    "msb": { "code": "01204033" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAM TRINH-01204033"
    }
  },
  "AGRIBANK/PGD 55 (TAM TRINH)": {
    "msb": { "code": "01204033" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAM TRINH-01204033"
    }
  },
  "AGRIBANK/PGD 6 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 6 (TP YEN BAI)": {
    "msb": { "code": "15204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN TP YEN BAI-15204002"
    }
  },
  "AGRIBANK/PGD 60D HOANG VAN THU-BAC LIEU": {
    "msb": { "code": "95204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC LIEU-95204001"
    }
  },
  "AGRIBANK/PGD 62 (BAC CAN)": {
    "msb": { "code": "06204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC CAN-06204001"
    }
  },
  "AGRIBANK/PGD 7 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 7 (TP YEN BAI)": {
    "msb": { "code": "15204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN TP YEN BAI-15204002"
    }
  },
  "AGRIBANK/PGD 8 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 9 (CAU GIAY)": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD 9 (TP YEN BAI II)": {
    "msb": { "code": "15204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO YEN BAI II-15204003"
    }
  },
  "AGRIBANK/PGD A VUONG": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD AI TU": {
    "msb": { "code": "45204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN TX QUANG TRI-45204007"
    }
  },
  "AGRIBANK/PGD AM TRUNG": {
    "msb": { "code": "42204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM XUYEN-42204003"
    }
  },
  "AGRIBANK/PGD AN BINH (NINH KIEU)": {
    "msb": { "code": "92204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TP CAN THO-92204001"
    }
  },
  "AGRIBANK/PGD AN BINH (VINH LONG)": {
    "msb": { "code": "86204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LONG HO-86204004"
    }
  },
  "AGRIBANK/PGD AN CAU": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD AN CO": {
    "msb": { "code": "72204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TAY NINH-72204001"
    }
  },
  "AGRIBANK/PGD AN DONG": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD AN HAI DONG": {
    "msb": { "code": "48204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN SON TRA DN-48204007"
    }
  },
  "AGRIBANK/PGD AN HOA (KIM SON)": {
    "msb": { "code": "37204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM SON-37204006"
    }
  },
  "AGRIBANK/PGD AN HOA (QUANG TRI)": {
    "msb": { "code": "45204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG TRI-45204001"
    }
  },
  "AGRIBANK/PGD AN HOI": {
    "msb": { "code": "79204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA DINH-79204021"
    }
  },
  "AGRIBANK/PGD AN HUU": {
    "msb": { "code": "82204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TIEN GIANG-82204001"
    }
  },
  "AGRIBANK/PGD AN KHAI": {
    "msb": { "code": "70204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH LONG-70204016"
    }
  },
  "AGRIBANK/PGD AN KHE": {
    "msb": { "code": "48204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH KHE DN-48204005"
    }
  },
  "AGRIBANK/PGD AN LAC": {
    "msb": { "code": "79204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH TAN-79204010"
    }
  },
  "AGRIBANK/PGD AN LO": {
    "msb": { "code": "46204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHONG DIEN-46204004"
    }
  },
  "AGRIBANK/PGD AN LOC": {
    "msb": { "code": "70204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH LONG-70204016"
    }
  },
  "AGRIBANK/PGD AN MY": {
    "msb": { "code": "54204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH PHU YEN-54204001"
    }
  },
  "AGRIBANK/PGD AN NHON": {
    "msb": { "code": "79204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA DINH-79204021"
    }
  },
  "AGRIBANK/PGD AN NINH": {
    "msb": { "code": "54204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH PHU YEN-54204001"
    }
  },
  "AGRIBANK/PGD AN PHUOC (KCN BIEN HOA)": {
    "msb": { "code": "75204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC DONG NAI-75204002"
    }
  },
  "AGRIBANK/PGD AN PHUOC (VINH LONG)": {
    "msb": { "code": "86204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MANG THIT-86204006"
    }
  },
  "AGRIBANK/PGD AN SINH": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/PGD AN THINH": {
    "msb": { "code": "15204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN YEN-15204009"
    }
  },
  "AGRIBANK/PGD AN THOI": {
    "msb": { "code": "91204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU QUOC-91204002"
    }
  },
  "AGRIBANK/PGD AN TRACH": {
    "msb": { "code": "94204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SOC TRANG-94204001"
    }
  },
  "AGRIBANK/PGD AP BAC": {
    "msb": { "code": "82204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TIEN GIANG-82204001"
    }
  },
  "AGRIBANK/PGD ATK": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD AU CO": {
    "msb": { "code": "79204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 8-79204007"
    }
  },
  "AGRIBANK/PGD BA CHIEU": {
    "msb": { "code": "79204041" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN AN SUONG-79204041"
    }
  },
  "AGRIBANK/PGD BA CHUC": {
    "msb": { "code": "89204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRI TON-89204005"
    }
  },
  "AGRIBANK/PGD BA GIA": {
    "msb": { "code": "51204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NGAI-51204001"
    }
  },
  "AGRIBANK/PGD BA GIANG": {
    "msb": { "code": "42204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THACH HA-42204014"
    }
  },
  "AGRIBANK/PGD BA HANG": {
    "msb": { "code": "33204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HUNG YEN-33204001"
    }
  },
  "AGRIBANK/PGD BA HANG DOI": {
    "msb": { "code": "17204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM BOI-17204012"
    }
  },
  "AGRIBANK/PGD BA NGOI": {
    "msb": { "code": "56204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN TX CAM RANH-56204007"
    }
  },
  "AGRIBANK/PGD BA TRIEU (DAC NONG)": {
    "msb": { "code": "67204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN TINH DAC NONG-67204001"
    }
  },
  "AGRIBANK/PGD BA TRIEU (THANH HOA)": {
    "msb": { "code": "38204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SO 3 - THANH HOA-38204023"
    }
  },
  "AGRIBANK/PGD BAC BINH CHANH": {
    "msb": { "code": "79204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH CHANH-79204022"
    }
  },
  "AGRIBANK/PGD BAC CHUONG DUONG": {
    "msb": { "code": "01204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LONG BIEN-01204019"
    }
  },
  "AGRIBANK/PGD BAC CUA VIET": {
    "msb": { "code": "45204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIO LINH-45204008"
    }
  },
  "AGRIBANK/PGD BAC CUONG": {
    "msb": { "code": "10204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN CN COC LEU-10204012"
    }
  },
  "AGRIBANK/PGD BAC DANG": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD BAC HA (THANH PHO HA TINH)": {
    "msb": { "code": "42204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN TP HA TINH-42204002"
    }
  },
  "AGRIBANK/PGD BAC HAI": {
    "msb": { "code": "79204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO LON-79204016"
    }
  },
  "AGRIBANK/PGD BAC LONG BIEN": {
    "msb": { "code": "01204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LONG BIEN-01204019"
    }
  },
  "AGRIBANK/PGD BAC MY AN": {
    "msb": { "code": "48204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN NGU HANH SON-48204006"
    }
  },
  "AGRIBANK/PGD BAC NGAM": {
    "msb": { "code": "10204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAO THANG-10204008"
    }
  },
  "AGRIBANK/PGD BAC NINH PHUOC": {
    "msb": { "code": "58204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH PHUOC-58204005"
    }
  },
  "AGRIBANK/PGD BAC RUONG": {
    "msb": { "code": "60204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TANH LINH-60204005"
    }
  },
  "AGRIBANK/PGD BAC SON": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD BAC THANG LONG": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/PGD BAC VI XUYEN": {
    "msb": { "code": "02204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VI XUYEN-02204012"
    }
  },
  "AGRIBANK/PGD BACH DANG (HCM)": {
    "msb": { "code": "79204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG TAM SAI GON-79204015"
    }
  },
  "AGRIBANK/PGD BACH DANG (HN)": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD BACH HAC": {
    "msb": { "code": "25204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH MIEU-25204015"
    }
  },
  "AGRIBANK/PGD BACH KHOA (HCM)": {
    "msb": { "code": "79204050" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HIEP PHUOC-79204050"
    }
  },
  "AGRIBANK/PGD BACH NGOC": {
    "msb": { "code": "40204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DO LUONG-40204014"
    }
  },
  "AGRIBANK/PGD BACH NHAN": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD BAI BANG": {
    "msb": { "code": "25204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU NINH - PHU THO-25204006"
    }
  },
  "AGRIBANK/PGD BAI NGANG": {
    "msb": { "code": "40204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUYNH LUU-40204004"
    }
  },
  "AGRIBANK/PGD BAI TRANH": {
    "msb": { "code": "38204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NHU XUAN-38204011"
    }
  },
  "AGRIBANK/PGD BALA": {
    "msb": { "code": "51204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NGAI-51204001"
    }
  },
  "AGRIBANK/PGD BAN CO": {
    "msb": { "code": "79204051" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BEN THANH-79204051"
    }
  },
  "AGRIBANK/PGD BAN LAU": {
    "msb": { "code": "10204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MUONG KHUONG-10204004"
    }
  },
  "AGRIBANK/PGD BAN ME": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/PGD BAN PHU": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD BAO AN": {
    "msb": { "code": "58204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN THAP CHAM-58204006"
    }
  },
  "AGRIBANK/PGD BAO BINH": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD BAO HA": {
    "msb": { "code": "10204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAO YEN-10204007"
    }
  },
  "AGRIBANK/PGD BAO NHAI": {
    "msb": { "code": "10204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC HA-10204002"
    }
  },
  "AGRIBANK/PGD BAU CAN": {
    "msb": { "code": "64204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN CHU PRONG-64204002"
    }
  },
  "AGRIBANK/PGD BAU CAT": {
    "msb": { "code": "79204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN BINH-79204020"
    }
  },
  "AGRIBANK/PGD BAU LAM": {
    "msb": { "code": "77204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUYEN MOC-77204003"
    }
  },
  "AGRIBANK/PGD BEN DINH": {
    "msb": { "code": "77204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TP VUNG TAU-77204002"
    }
  },
  "AGRIBANK/PGD BEN HIEP": {
    "msb": { "code": "34204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUYNH PHU-34204007"
    }
  },
  "AGRIBANK/PGD BEN KIENG": {
    "msb": { "code": "40204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DIEN CHAU-40204020"
    }
  },
  "AGRIBANK/PGD BEN THUY": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/PGD BEN TRANH": {
    "msb": { "code": "82204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TIEN GIANG-82204001"
    }
  },
  "AGRIBANK/PGD BIEN DONG": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD BINH AN": {
    "msb": { "code": "74204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN KCN SONG THAN-74204002"
    }
  },
  "AGRIBANK/PGD BINH CHANH- CN CAN GIO": {
    "msb": { "code": "79204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CAN GIO-79204027"
    }
  },
  "AGRIBANK/PGD BINH CHAU": {
    "msb": { "code": "77204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUYEN MOC-77204003"
    }
  },
  "AGRIBANK/PGD BINH DA": {
    "msb": { "code": "01204039" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THANH OAI - HA TAY-01204039"
    }
  },
  "AGRIBANK/PGD BINH DIEN": {
    "msb": { "code": "46204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUONG TRA-46204005"
    }
  },
  "AGRIBANK/PGD BINH DUONG (BINH DINH)": {
    "msb": { "code": "52204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH DINH-52204001"
    }
  },
  "AGRIBANK/PGD BINH HOA": {
    "msb": { "code": "79204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH THANH-79204019"
    }
  },
  "AGRIBANK/PGD BINH HUNG HOA": {
    "msb": { "code": "79204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH TAN-79204010"
    }
  },
  "AGRIBANK/PGD BINH KHANH": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/PGD BINH KHE": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD BINH MINH (NINH BINH)": {
    "msb": { "code": "37204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC BINH MINH-37204011"
    }
  },
  "AGRIBANK/PGD BINH NINH": {
    "msb": { "code": "86204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM BINH-86204003"
    }
  },
  "AGRIBANK/PGD BINH PHONG THANH": {
    "msb": { "code": "80204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LONG AN-80204001"
    }
  },
  "AGRIBANK/PGD BINH PHU (DONG SAI GON)": {
    "msb": { "code": "79204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG SAI GON-79204014"
    }
  },
  "AGRIBANK/PGD BINH PHU (THACH THAT-HNI)": {
    "msb": { "code": "01204047" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THACH THAT - HA TAY-01204047"
    }
  },
  "AGRIBANK/PGD BINH PHU (TRA VINH)": {
    "msb": { "code": "84204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TRA VINH-84204001"
    }
  },
  "AGRIBANK/PGD BINH PHUOC (VINH LONG)": {
    "msb": { "code": "86204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MANG THIT-86204006"
    }
  },
  "AGRIBANK/PGD BINH QUY": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD BINH SON": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD BINH TAM": {
    "msb": { "code": "80204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LONG AN-80204001"
    }
  },
  "AGRIBANK/PGD BINH TAY": {
    "msb": { "code": "79204034" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG VUONG-HCM-79204034"
    }
  },
  "AGRIBANK/PGD BINH THAI": {
    "msb": { "code": "79204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 9-79204012"
    }
  },
  "AGRIBANK/PGD BINH TRI DONG": {
    "msb": { "code": "79204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH TAN-79204010"
    }
  },
  "AGRIBANK/PGD BO SAO": {
    "msb": { "code": "26204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH TUONG-26204003"
    }
  },
  "AGRIBANK/PGD BOM BO": {
    "msb": { "code": "70204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BU DANG-70204008"
    }
  },
  "AGRIBANK/PGD BONG": {
    "msb": { "code": "38204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH LOC-38204014"
    }
  },
  "AGRIBANK/PGD BUI THI XUAN": {
    "msb": { "code": "01204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DO-01204030"
    }
  },
  "AGRIBANK/PGD BUNG": {
    "msb": { "code": "74204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN KCN SONG THAN-74204002"
    }
  },
  "AGRIBANK/PGD BUNG LAO": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD BUON TRAP": {
    "msb": { "code": "66204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN KRONG ANA-66204022"
    }
  },
  "AGRIBANK/PGD BUONG": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD BUONG MRE": {
    "msb": { "code": "66204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA KHANH - DAKLAK-66204025"
    }
  },
  "AGRIBANK/PGD CAI GIANG": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD CAM AN": {
    "msb": { "code": "15204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN BINH-15204005"
    }
  },
  "AGRIBANK/PGD CAM CHE": {
    "msb": { "code": "30204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH HA-30204014"
    }
  },
  "AGRIBANK/PGD CAM DUC": {
    "msb": { "code": "56204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN TX CAM RANH-56204007"
    }
  },
  "AGRIBANK/PGD CAM GIANG": {
    "msb": { "code": "30204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM GIANG-30204004"
    }
  },
  "AGRIBANK/PGD CAM LY": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD CAM NHAN": {
    "msb": { "code": "15204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN BINH-15204005"
    }
  },
  "AGRIBANK/PGD CAM PHU": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD CAM TAN": {
    "msb": { "code": "38204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM THUY-38204028"
    }
  },
  "AGRIBANK/PGD CAM THANH (HA TINH)": {
    "msb": { "code": "42204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM XUYEN-42204003"
    }
  },
  "AGRIBANK/PGD CAM THANH (QUANG NGAI)": {
    "msb": { "code": "51204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NGAI-51204001"
    }
  },
  "AGRIBANK/PGD CAM TRUNG": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD CAM VU": {
    "msb": { "code": "30204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM GIANG-30204004"
    }
  },
  "AGRIBANK/PGD CAN DAN": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD CAN DOT": {
    "msb": { "code": "80204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LONG AN-80204001"
    }
  },
  "AGRIBANK/PGD CANG CUA HOI": {
    "msb": { "code": "40204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TX CUA LO-40204013"
    }
  },
  "AGRIBANK/PGD CANG CUA LO": {
    "msb": { "code": "40204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TX CUA LO-40204013"
    }
  },
  "AGRIBANK/PGD CAO BINH": {
    "msb": { "code": "04204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOA AN-04204004"
    }
  },
  "AGRIBANK/PGD CAO XA": {
    "msb": { "code": "25204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAM THAO-25204005"
    }
  },
  "AGRIBANK/PGD CAP 3 LONG HUNG": {
    "msb": { "code": "33204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN GIANG-33204004"
    }
  },
  "AGRIBANK/PGD CAT LINH": {
    "msb": { "code": "01204035" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CN HA NOI II-01204035"
    }
  },
  "AGRIBANK/PGD CAT NGAN": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD CAT QUE": {
    "msb": { "code": "01204037" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.HOAI DUC - HA TAY-01204037"
    }
  },
  "AGRIBANK/PGD CAU BUOU": {
    "msb": { "code": "01204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH TRI-01204004"
    }
  },
  "AGRIBANK/PGD CAU DAT": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD CAU DOI": {
    "msb": { "code": "86204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN KCN HOA PHU-86204008"
    }
  },
  "AGRIBANK/PGD CAU KHONG": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD CAU LAO": {
    "msb": { "code": "01204041" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.UNG HOA - HA TAY-01204041"
    }
  },
  "AGRIBANK/PGD CAU MOI": {
    "msb": { "code": "86204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VUNG LIEM-86204005"
    }
  },
  "AGRIBANK/PGD CAU QUAN": {
    "msb": { "code": "38204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NONG CONG-38204012"
    }
  },
  "AGRIBANK/PGD CAU RAM": {
    "msb": { "code": "30204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH GIANG-30204008"
    }
  },
  "AGRIBANK/PGD CAU TRU": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD CAU VOI": {
    "msb": { "code": "36204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM TRUC-36204004"
    }
  },
  "AGRIBANK/PGD CAU XE": {
    "msb": { "code": "30204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TU KY-30204007"
    }
  },
  "AGRIBANK/PGD CAY CHANH": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD CHAM MAT": {
    "msb": { "code": "17204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHUONG LAM-17204004"
    }
  },
  "AGRIBANK/PGD CHAN HUNG": {
    "msb": { "code": "26204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH TUONG-26204003"
    }
  },
  "AGRIBANK/PGD CHAN MONG": {
    "msb": { "code": "25204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DOAN HUNG-25204016"
    }
  },
  "AGRIBANK/PGD CHANH HUNG": {
    "msb": { "code": "79204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 8-79204007"
    }
  },
  "AGRIBANK/PGD CHAU GIANG": {
    "msb": { "code": "34204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HUNG-34204006"
    }
  },
  "AGRIBANK/PGD CHAU HUNG": {
    "msb": { "code": "83204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BEN TRE-83204001"
    }
  },
  "AGRIBANK/PGD CHAU KHE": {
    "msb": { "code": "27204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NINH II-27204003"
    }
  },
  "AGRIBANK/PGD CHAU LONG": {
    "msb": { "code": "01204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HONG HA-01204018"
    }
  },
  "AGRIBANK/PGD CHAU O": {
    "msb": { "code": "51204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NGAI-51204001"
    }
  },
  "AGRIBANK/PGD CHI DAO": {
    "msb": { "code": "33204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN VAN LAM-33204006"
    }
  },
  "AGRIBANK/PGD CHIENG KHUONG": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/PGD CHIENG LE": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/PGD CHIENG PAC": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/PGD CHINH THANG": {
    "msb": { "code": "79204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HOC MON-79204013"
    }
  },
  "AGRIBANK/PGD CHO BEN": {
    "msb": { "code": "17204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM BOI-17204012"
    }
  },
  "AGRIBANK/PGD CHO CHANH": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD CHO CHAY": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD CHO CHI": {
    "msb": { "code": "27204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUE VO-27204005"
    }
  },
  "AGRIBANK/PGD CHO CHUA": {
    "msb": { "code": "40204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM DAN-40204010"
    }
  },
  "AGRIBANK/PGD CHO DAU": {
    "msb": { "code": "34204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THAI THUY-34204003"
    }
  },
  "AGRIBANK/PGD CHO DEN": {
    "msb": { "code": "36204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUC NINH-36204008"
    }
  },
  "AGRIBANK/PGD CHO DINH": {
    "msb": { "code": "46204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC SONG HUONG-46204011"
    }
  },
  "AGRIBANK/PGD CHO DONG HA": {
    "msb": { "code": "45204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN TP DONG HA-45204002"
    }
  },
  "AGRIBANK/PGD CHO DUOC": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD CHO DUTRI TRE": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD CHO GAO (HUNG YEN)": {
    "msb": { "code": "33204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN TP HUNG YEN-33204012"
    }
  },
  "AGRIBANK/PGD CHO GAO (NAM DINH)": {
    "msb": { "code": "36204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU BAN-36204003"
    }
  },
  "AGRIBANK/PGD CHO GIAN": {
    "msb": { "code": "33204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN KHOAI CHAU-33204007"
    }
  },
  "AGRIBANK/PGD CHO HOM": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD CHO LOI": {
    "msb": { "code": "36204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU BAN-36204003"
    }
  },
  "AGRIBANK/PGD CHO LON (PHO QUY NHON)": {
    "msb": { "code": "52204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP QUY NHON-52204002"
    }
  },
  "AGRIBANK/PGD CHO LUONG": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD CHO MAI": {
    "msb": { "code": "46204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU VANG-46204009"
    }
  },
  "AGRIBANK/PGD CHO MO (CN HA THANH)": {
    "msb": { "code": "01204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA THANH-01204032"
    }
  },
  "AGRIBANK/PGD CHO MO (CN TRANG AN)": {
    "msb": { "code": "01204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRANG AN-01204029"
    }
  },
  "AGRIBANK/PGD CHO MOI (KHANH HOA)": {
    "msb": { "code": "56204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN TX CAM RANH-56204007"
    }
  },
  "AGRIBANK/PGD CHO MOI (TAY NINH)": {
    "msb": { "code": "72204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TAY NINH-72204001"
    }
  },
  "AGRIBANK/PGD CHO MOI (TX THAI HOA)": {
    "msb": { "code": "40204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THAI HOA-40204019"
    }
  },
  "AGRIBANK/PGD CHO NHE": {
    "msb": { "code": "42204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAN LOC-42204013"
    }
  },
  "AGRIBANK/PGD CHO ROC": {
    "msb": { "code": "40204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN THANH-40204021"
    }
  },
  "AGRIBANK/PGD CHO RONG": {
    "msb": { "code": "37204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NINH BINH-37204009"
    }
  },
  "AGRIBANK/PGD CHO SON (BAC NINH)": {
    "msb": { "code": "27204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN DU BAC NINH II-27204010"
    }
  },
  "AGRIBANK/PGD CHO SON (NGHE AN)": {
    "msb": { "code": "40204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHI LOC-40204008"
    }
  },
  "AGRIBANK/PGD CHO THI": {
    "msb": { "code": "33204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN AN THI-33204011"
    }
  },
  "AGRIBANK/PGD CHO TRAM": {
    "msb": { "code": "44204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LE THUY-44204003"
    }
  },
  "AGRIBANK/PGD CHO VA": {
    "msb": { "code": "27204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN DU BAC NINH II-27204010"
    }
  },
  "AGRIBANK/PGD CHO VINH": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/PGD CHON THANH": {
    "msb": { "code": "70204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH PHUOC-70204001"
    }
  },
  "AGRIBANK/PGD CN PHA LAI": {
    "msb": { "code": "30204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN PHA LAI-30204015"
    }
  },
  "AGRIBANK/PGD CN TRUNG AN": {
    "msb": { "code": "92204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN THOT NOT-92204004"
    }
  },
  "AGRIBANK/PGD CO BI": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD CO DAM": {
    "msb": { "code": "42204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHI XUAN-42204009"
    }
  },
  "AGRIBANK/PGD CO LOA": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/PGD CO NHUE": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD CO RONG": {
    "msb": { "code": "34204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN HAI-34204005"
    }
  },
  "AGRIBANK/PGD CO TIET": {
    "msb": { "code": "25204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM NONG - PHU THO-25204011"
    }
  },
  "AGRIBANK/PGD CONG HIEN": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD CONG HOA": {
    "msb": { "code": "79204041" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN AN SUONG-79204041"
    }
  },
  "AGRIBANK/PGD CONG TIEN": {
    "msb": { "code": "40204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN THANH-40204021"
    }
  },
  "AGRIBANK/PGD COT 8": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD CU PUI": {
    "msb": { "code": "66204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KRONG BONG-66204004"
    }
  },
  "AGRIBANK/PGD CU VAN": {
    "msb": { "code": "19204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAI TU-19204010"
    }
  },
  "AGRIBANK/PGD CUA": {
    "msb": { "code": "40204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN KY-40204015"
    }
  },
  "AGRIBANK/PGD CUA HOI": {
    "msb": { "code": "40204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHI LOC-40204008"
    }
  },
  "AGRIBANK/PGD CUA NAM": {
    "msb": { "code": "01204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG MAI- HA NOI-01204020"
    }
  },
  "AGRIBANK/PGD CUA ONG": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD CUA TUNG": {
    "msb": { "code": "45204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH LINH-45204010"
    }
  },
  "AGRIBANK/PGD CUNG B": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD DA": {
    "msb": { "code": "38204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRIEU SON-38204008"
    }
  },
  "AGRIBANK/PGD DA GIANG": {
    "msb": { "code": "17204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHUONG LAM-17204004"
    }
  },
  "AGRIBANK/PGD DA TON": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD DAI CUONG": {
    "msb": { "code": "01204041" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.UNG HOA - HA TAY-01204041"
    }
  },
  "AGRIBANK/PGD DAI HOC NGAN HANG": {
    "msb": { "code": "79204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 9-79204012"
    }
  },
  "AGRIBANK/PGD DAI HOC NONG NGHIEP": {
    "msb": { "code": "79204033" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH TRIEU-79204033"
    }
  },
  "AGRIBANK/PGD DAI HOC NONG NGHIEP 1 HN": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD DAI KIM": {
    "msb": { "code": "01204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG MAI- HA NOI-01204020"
    }
  },
  "AGRIBANK/PGD DAI NAM": {
    "msb": { "code": "79204051" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BEN THANH-79204051"
    }
  },
  "AGRIBANK/PGD DAI NGAI": {
    "msb": { "code": "94204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN PGD DAI NGAI - SOC TRANG-94204015"
    }
  },
  "AGRIBANK/PGD DAI PHUOC": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD DAI XUYEN": {
    "msb": { "code": "01204046" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.PHU XUYEN - HA TAY-01204046"
    }
  },
  "AGRIBANK/PGD DAK O": {
    "msb": { "code": "70204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHUOC LONG-BINH PHUOC-70204007"
    }
  },
  "AGRIBANK/PGD DAM RONG": {
    "msb": { "code": "68204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAM DONG-68204001"
    }
  },
  "AGRIBANK/PGD DAMRI": {
    "msb": { "code": "68204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAHUOAI-68204011"
    }
  },
  "AGRIBANK/PGD DAN THUONG": {
    "msb": { "code": "25204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA HOA-25204009"
    }
  },
  "AGRIBANK/PGD DAO NGHIA": {
    "msb": { "code": "67204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN TINH DAC NONG-67204001"
    }
  },
  "AGRIBANK/PGD DAP DA": {
    "msb": { "code": "52204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN THI XA AN NHON-52204004"
    }
  },
  "AGRIBANK/PGD DAP THI CAU": {
    "msb": { "code": "27204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TP BAC NINH-27204002"
    }
  },
  "AGRIBANK/PGD DAT LY": {
    "msb": { "code": "66204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA THUAN - DAKLAK-66204029"
    }
  },
  "AGRIBANK/PGD DAU (BAC NINH)": {
    "msb": { "code": "27204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THUAN THANH-27204006"
    }
  },
  "AGRIBANK/PGD DAU (HN)": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/PGD DAU GIAY": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD DE GI": {
    "msb": { "code": "52204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU CAT-52204006"
    }
  },
  "AGRIBANK/PGD DE THAM": {
    "msb": { "code": "04204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CAO BANG-04204001"
    }
  },
  "AGRIBANK/PGD DH TAY NGUYEN": {
    "msb": { "code": "66204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN KIM NGAN - DAKLAK-66204010"
    }
  },
  "AGRIBANK/PGD DI SU": {
    "msb": { "code": "33204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG YEN II-33204010"
    }
  },
  "AGRIBANK/PGD DIEN DONG": {
    "msb": { "code": "40204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DIEN CHAU-40204020"
    }
  },
  "AGRIBANK/PGD DIEN LOC": {
    "msb": { "code": "46204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHONG DIEN-46204004"
    }
  },
  "AGRIBANK/PGD DIEN PHUOC": {
    "msb": { "code": "56204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DIEN KHANH-56204008"
    }
  },
  "AGRIBANK/PGD DIEU TRI": {
    "msb": { "code": "52204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUY PHUOC-52204003"
    }
  },
  "AGRIBANK/PGD DIN MUOI": {
    "msb": { "code": "44204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG NINH-44204004"
    }
  },
  "AGRIBANK/PGD DINH CONG": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD DINH KE": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD DINH THANH": {
    "msb": { "code": "95204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HAI-95204008"
    }
  },
  "AGRIBANK/PGD DINH TIEN HOANG": {
    "msb": { "code": "79204048" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUONG SON-79204048"
    }
  },
  "AGRIBANK/PGD DLIE YANG": {
    "msb": { "code": "66204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN EA H' LEO-66204030"
    }
  },
  "AGRIBANK/PGD DO THANH": {
    "msb": { "code": "79204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH CHANH-79204022"
    }
  },
  "AGRIBANK/PGD DO THI MOI": {
    "msb": { "code": "79204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM SAI GON-79204026"
    }
  },
  "AGRIBANK/PGD DOAN THI DIEM": {
    "msb": { "code": "01204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HA NOI-01204007"
    }
  },
  "AGRIBANK/PGD DONG BANH": {
    "msb": { "code": "20204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LANG SON-20204001"
    }
  },
  "AGRIBANK/PGD DONG BINH CHANH": {
    "msb": { "code": "79204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH CHANH-79204022"
    }
  },
  "AGRIBANK/PGD DONG CHO LON": {
    "msb": { "code": "79204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO LON-79204016"
    }
  },
  "AGRIBANK/PGD DONG CUU": {
    "msb": { "code": "27204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIA BINH-27204009"
    }
  },
  "AGRIBANK/PGD DONG DA (BINH DINH)": {
    "msb": { "code": "52204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP QUY NHON-52204002"
    }
  },
  "AGRIBANK/PGD DONG DO": {
    "msb": { "code": "01204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG VUONG- HA NOI-01204028"
    }
  },
  "AGRIBANK/PGD DONG DU": {
    "msb": { "code": "27204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUE VO-27204005"
    }
  },
  "AGRIBANK/PGD DONG HO": {
    "msb": { "code": "34204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THAI THUY-34204003"
    }
  },
  "AGRIBANK/PGD DONG HUNG (NGHE AN)": {
    "msb": { "code": "40204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUNG NGUYEN-40204009"
    }
  },
  "AGRIBANK/PGD DONG KE": {
    "msb": { "code": "33204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN KHOAI CHAU-33204007"
    }
  },
  "AGRIBANK/PGD DONG KHANH": {
    "msb": { "code": "79204040" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH DO-79204040"
    }
  },
  "AGRIBANK/PGD DONG KHOI": {
    "msb": { "code": "83204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BEN TRE-83204001"
    }
  },
  "AGRIBANK/PGD DONG LAC": {
    "msb": { "code": "06204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC CAN-06204001"
    }
  },
  "AGRIBANK/PGD DONG LAM": {
    "msb": { "code": "34204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN HAI-34204005"
    }
  },
  "AGRIBANK/PGD DONG LOC": {
    "msb": { "code": "42204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAN LOC-42204013"
    }
  },
  "AGRIBANK/PGD DONG LONG": {
    "msb": { "code": "34204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN HAI-34204005"
    }
  },
  "AGRIBANK/PGD DONG MY (HN)": {
    "msb": { "code": "01204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH TRI-01204004"
    }
  },
  "AGRIBANK/PGD DONG MY (THAI BINH)": {
    "msb": { "code": "34204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HUNG-34204006"
    }
  },
  "AGRIBANK/PGD DONG PHUOC": {
    "msb": { "code": "54204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH PHU YEN-54204001"
    }
  },
  "AGRIBANK/PGD DONG PHUONG YEN": {
    "msb": { "code": "01204050" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.CHUONG MY - HA TAY-01204050"
    }
  },
  "AGRIBANK/PGD DONG QUAN (BAC NINH)": {
    "msb": { "code": "27204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NINH II-27204003"
    }
  },
  "AGRIBANK/PGD DONG QUAN (HA NOI)": {
    "msb": { "code": "01204046" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.PHU XUYEN - HA TAY-01204046"
    }
  },
  "AGRIBANK/PGD DONG SON (BIM SON)": {
    "msb": { "code": "38204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN THI XA BIM SON-38204022"
    }
  },
  "AGRIBANK/PGD DONG SON (SON TAY)": {
    "msb": { "code": "01204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TP SON TAY-01204049"
    }
  },
  "AGRIBANK/PGD DONG SON (TIEN GIANG)": {
    "msb": { "code": "82204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TIEN GIANG-82204001"
    }
  },
  "AGRIBANK/PGD DONG TAM": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD DONG THINH (HCM)": {
    "msb": { "code": "79204039" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HOA-79204039"
    }
  },
  "AGRIBANK/PGD DONG THINH (VINH PHUC)": {
    "msb": { "code": "26204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAP THACH-26204005"
    }
  },
  "AGRIBANK/PGD DONG THO": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD DONG TIEN": {
    "msb": { "code": "17204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SONG DA-17204013"
    }
  },
  "AGRIBANK/PGD DONG VAN (HA NAM)": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD DONG VAN (VINH PHUC)": {
    "msb": { "code": "26204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN LAC-26204004"
    }
  },
  "AGRIBANK/PGD DONG XUAN": {
    "msb": { "code": "25204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH BA-25204007"
    }
  },
  "AGRIBANK/PGD DUC GIANG": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD DUC HOP": {
    "msb": { "code": "33204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM DONG-33204008"
    }
  },
  "AGRIBANK/PGD DUC LAC": {
    "msb": { "code": "42204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DUC THO-42204007"
    }
  },
  "AGRIBANK/PGD DUC MINH": {
    "msb": { "code": "67204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN TINH DAC NONG-67204001"
    }
  },
  "AGRIBANK/PGD DUC MY": {
    "msb": { "code": "56204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH HOA-56204005"
    }
  },
  "AGRIBANK/PGD DUC TRUNG": {
    "msb": { "code": "42207007" },
    "techcombank": null
  },
  "AGRIBANK/PGD DUC XUAN": {
    "msb": { "code": "06204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC CAN-06204001"
    }
  },
  "AGRIBANK/PGD DUONG BA TRAC": {
    "msb": { "code": "79204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 8-79204007"
    }
  },
  "AGRIBANK/PGD DUU LAU": {
    "msb": { "code": "25204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA CAM-25204014"
    }
  },
  "AGRIBANK/PGD EA BAR": {
    "msb": { "code": "66204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BUON DON-66204017"
    }
  },
  "AGRIBANK/PGD EA H�DING": {
    "msb": { "code": "66204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CU MGAR-66204023"
    }
  },
  "AGRIBANK/PGD EA KNUECH": {
    "msb": { "code": "66204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KRONG PAK-66204013"
    }
  },
  "AGRIBANK/PGD EA KPAM": {
    "msb": { "code": "66204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CU MGAR-66204023"
    }
  },
  "AGRIBANK/PGD EA NA": {
    "msb": { "code": "66204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN KRONG ANA-66204022"
    }
  },
  "AGRIBANK/PGD EA O": {
    "msb": { "code": "66204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN EA KAR-66204002"
    }
  },
  "AGRIBANK/PGD EA POK": {
    "msb": { "code": "66204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CU MGAR-66204023"
    }
  },
  "AGRIBANK/PGD EA RIENG": {
    "msb": { "code": "66204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN M' DRAK-66204006"
    }
  },
  "AGRIBANK/PGD EA ROC": {
    "msb": { "code": "66204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN EA SUP-66204009"
    }
  },
  "AGRIBANK/PGD EA WERE": {
    "msb": { "code": "66204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BUON DON-66204017"
    }
  },
  "AGRIBANK/PGD GA T1 NOI BAI": {
    "msb": { "code": "01204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SOC SON-01204012"
    }
  },
  "AGRIBANK/PGD GANG THEP": {
    "msb": { "code": "19204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN TP THAI NGUYEN-19204011"
    }
  },
  "AGRIBANK/PGD GHEP": {
    "msb": { "code": "38204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM THANH HOA-38204010"
    }
  },
  "AGRIBANK/PGD GIA CAT": {
    "msb": { "code": "20204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LANG SON-20204001"
    }
  },
  "AGRIBANK/PGD GIA HIEP": {
    "msb": { "code": "68204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DI LINH-68204010"
    }
  },
  "AGRIBANK/PGD GIA LACH": {
    "msb": { "code": "42204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHI XUAN-42204009"
    }
  },
  "AGRIBANK/PGD GIA PHU": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/PGD GIA SANG": {
    "msb": { "code": "19204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN TP THAI NGUYEN-19204011"
    }
  },
  "AGRIBANK/PGD GIA TU": {
    "msb": { "code": "02204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC QUANG-02204008"
    }
  },
  "AGRIBANK/PGD GIANG TIEN": {
    "msb": { "code": "19204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU LUONG-19204009"
    }
  },
  "AGRIBANK/PGD GIANG VO": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD GIAO PHONG": {
    "msb": { "code": "36204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIAO THUY-36204010"
    }
  },
  "AGRIBANK/PGD GIAP BAT": {
    "msb": { "code": "01204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG MAI- HA NOI-01204020"
    }
  },
  "AGRIBANK/PGD GO BOI": {
    "msb": { "code": "52204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUY PHUOC-52204003"
    }
  },
  "AGRIBANK/PGD HA DONG": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD HA LONG 2": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD HA NAM": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD HAC DICH": {
    "msb": { "code": "77204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN THI XA PHU MY-BA RIA V.TAU-77204004"
    }
  },
  "AGRIBANK/PGD HACH TRUNG": {
    "msb": { "code": "42204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM XUYEN-42204003"
    }
  },
  "AGRIBANK/PGD HAI ANH": {
    "msb": { "code": "36204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAI HAU-36204012"
    }
  },
  "AGRIBANK/PGD HAI CANG": {
    "msb": { "code": "52204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP QUY NHON-52204002"
    }
  },
  "AGRIBANK/PGD HAI NINH": {
    "msb": { "code": "38204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TINH GIA-38204015"
    }
  },
  "AGRIBANK/PGD HAI PHONG (TP NAM DINH)": {
    "msb": { "code": "36204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAI HAU-36204012"
    }
  },
  "AGRIBANK/PGD HAI TAN": {
    "msb": { "code": "30204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO HAI DUONG-30204009"
    }
  },
  "AGRIBANK/PGD HAI THANH": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD HAI TIENG": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD HAM LONG": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD HAM NGHI": {
    "msb": { "code": "79204051" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BEN THANH-79204051"
    }
  },
  "AGRIBANK/PGD HAM NHON": {
    "msb": { "code": "60204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAM THUAN BAC-60204004"
    }
  },
  "AGRIBANK/PGD HAM RONG": {
    "msb": { "code": "36204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NAM DINH-36204001"
    }
  },
  "AGRIBANK/PGD HAN THUYEN": {
    "msb": { "code": "36204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NAM DINH-36204001"
    }
  },
  "AGRIBANK/PGD HANG TRONG": {
    "msb": { "code": "01204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HA NOI-01204007"
    }
  },
  "AGRIBANK/PGD HANH": {
    "msb": { "code": "19204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU BINH-19204007"
    }
  },
  "AGRIBANK/PGD HANH THIEN": {
    "msb": { "code": "36204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUAN TRUONG-36204011"
    }
  },
  "AGRIBANK/PGD HANH TRIEU": {
    "msb": { "code": "83204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-BEN TRE-83204007"
    }
  },
  "AGRIBANK/PGD HAO NGHIA": {
    "msb": { "code": "06204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC CAN-06204001"
    }
  },
  "AGRIBANK/PGD HAU THANH": {
    "msb": { "code": "82204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAI BE-82204010"
    }
  },
  "AGRIBANK/PGD HAUTHANH DONG": {
    "msb": { "code": "80204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LONG AN-80204001"
    }
  },
  "AGRIBANK/PGD HIEP THANH (TINH BAC LIEU)": {
    "msb": { "code": "95204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC LIEU-95204001"
    }
  },
  "AGRIBANK/PGD HIEU NHON": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD HIEU PHUNG": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD HIM LAM": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD HO XA": {
    "msb": { "code": "45204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH LINH-45204010"
    }
  },
  "AGRIBANK/PGD HOA BINH (AN GIANG)": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/PGD HOA BINH (CHO LON)": {
    "msb": { "code": "79204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO LON-79204016"
    }
  },
  "AGRIBANK/PGD HOA BINH (DAKLAK)": {
    "msb": { "code": "66204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA THANG - DAKLAK-66204018"
    }
  },
  "AGRIBANK/PGD HOA BINH (LAM DONG)": {
    "msb": { "code": "68204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAM DONG-68204001"
    }
  },
  "AGRIBANK/PGD HOA BINH (TRA ON)": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD HOA CUONG": {
    "msb": { "code": "48204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI CHAU-48204003"
    }
  },
  "AGRIBANK/PGD HOA HIEP (BA RIA VUNG TAU)": {
    "msb": { "code": "77204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUYEN MOC-77204003"
    }
  },
  "AGRIBANK/PGD HOA HIEP (VINH LONG)": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD HOA HUNG": {
    "msb": { "code": "79204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG TAM SAI GON-79204015"
    }
  },
  "AGRIBANK/PGD HOA KHANH": {
    "msb": { "code": "48204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN LIEN CHIEU DN-48204008"
    }
  },
  "AGRIBANK/PGD HOA LAC - AN GIANG": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/PGD HOA LOI": {
    "msb": { "code": "84204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-TRA VINH-84204011"
    }
  },
  "AGRIBANK/PGD HOA LONG - LONG PHUOC": {
    "msb": { "code": "77204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN BA RIA VUNG TAU-77204001"
    }
  },
  "AGRIBANK/PGD HOA MINH": {
    "msb": { "code": "48204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN LIEN CHIEU DN-48204008"
    }
  },
  "AGRIBANK/PGD HOA MY": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD HOA NINH (QUANG BINH)": {
    "msb": { "code": "44204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG TRACH-44204005"
    }
  },
  "AGRIBANK/PGD HOA NINH (VINH LONG)": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD HOA PHAT": {
    "msb": { "code": "48204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DA NANG-48204001"
    }
  },
  "AGRIBANK/PGD HOA PHU": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD HOA PHUOC": {
    "msb": { "code": "48204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA VANG DN-48204002"
    }
  },
  "AGRIBANK/PGD HOA SON (DA NANG)": {
    "msb": { "code": "48204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HOA VANG DN-48204002"
    }
  },
  "AGRIBANK/PGD HOA SON (VINH PHUC)": {
    "msb": { "code": "26204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAP THACH-26204005"
    }
  },
  "AGRIBANK/PGD HOA XA": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD HOAI HUONG": {
    "msb": { "code": "52204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOAI NHON-52204008"
    }
  },
  "AGRIBANK/PGD HOAN SON": {
    "msb": { "code": "27204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN DU BAC NINH II-27204010"
    }
  },
  "AGRIBANK/PGD HOANG AN": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD HOANG DIEU": {
    "msb": { "code": "79204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG TAM SAI GON-79204015"
    }
  },
  "AGRIBANK/PGD HOANG HA": {
    "msb": { "code": "01204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG VUONG- HA NOI-01204028"
    }
  },
  "AGRIBANK/PGD HOANG LAM": {
    "msb": { "code": "83204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG KHOI-83204003"
    }
  },
  "AGRIBANK/PGD HOANG LIEN": {
    "msb": { "code": "10204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN CN COC LEU-10204012"
    }
  },
  "AGRIBANK/PGD HOANG LOC": {
    "msb": { "code": "38204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOANG HOA-38204009"
    }
  },
  "AGRIBANK/PGD HOANG VAN THAI": {
    "msb": { "code": "01204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DO-01204030"
    }
  },
  "AGRIBANK/PGD HOANG VAN THU (HCM)": {
    "msb": { "code": "79204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU NHUAN-79204006"
    }
  },
  "AGRIBANK/PGD HOANG VAN THU (THAINGUYEN)": {
    "msb": { "code": "19204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN TP THAI NGUYEN-19204011"
    }
  },
  "AGRIBANK/PGD HOANG XA": {
    "msb": { "code": "25204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH THUY-25204013"
    }
  },
  "AGRIBANK/PGD HOI DAO": {
    "msb": { "code": "38204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGA SON-38204029"
    }
  },
  "AGRIBANK/PGD HOI YEN": {
    "msb": { "code": "45204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAI LANG-45204004"
    }
  },
  "AGRIBANK/PGD HONG BANG-CN 11- HCM": {
    "msb": { "code": "79204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 11-79204003"
    }
  },
  "AGRIBANK/PGD HONG HAI": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD HONG NHAT": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD HONG QUANG (HAI DUONG)": {
    "msb": { "code": "30204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH MIEN-30204010"
    }
  },
  "AGRIBANK/PGD HONG QUANG (YEN BAI)": {
    "msb": { "code": "15204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUC YEN-15204006"
    }
  },
  "AGRIBANK/PGD HONG SON": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/PGD HONG THUAN": {
    "msb": { "code": "36204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIAO THUY-36204010"
    }
  },
  "AGRIBANK/PGD HONG TIEN": {
    "msb": { "code": "33204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN KHOAI CHAU-33204007"
    }
  },
  "AGRIBANK/PGD HONG VAN": {
    "msb": { "code": "01204042" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THUONG TIN - HA TAY-01204042"
    }
  },
  "AGRIBANK/PGD HOP MINH": {
    "msb": { "code": "15204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRAN YEN-15204008"
    }
  },
  "AGRIBANK/PGD HOP TIEN": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD HUNG DAO": {
    "msb": { "code": "30204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TU KY-30204007"
    }
  },
  "AGRIBANK/PGD HUNG DUNG": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/PGD HUNG LO": {
    "msb": { "code": "25204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA CAM-25204014"
    }
  },
  "AGRIBANK/PGD HUNG LOC": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/PGD HUNG LOI": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD HUNG PHU": {
    "msb": { "code": "79204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH CHANH-79204022"
    }
  },
  "AGRIBANK/PGD HUNG SON": {
    "msb": { "code": "25204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAM THAO-25204005"
    }
  },
  "AGRIBANK/PGD HUONG CAN": {
    "msb": { "code": "25204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH SON-25204010"
    }
  },
  "AGRIBANK/PGD HUONG SON": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD HUONG XA": {
    "msb": { "code": "25204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA HOA-25204009"
    }
  },
  "AGRIBANK/PGD HUU NGHI": {
    "msb": { "code": "17204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SONG DA-17204013"
    }
  },
  "AGRIBANK/PGD HUU THANH": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD HUYEN MUONG LAT": {
    "msb": { "code": "38204033" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN PGD HUYEN MUONG LAT-38204033"
    }
  },
  "AGRIBANK/PGD HUYEN QUAN SON": {
    "msb": { "code": "38204034" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN PGD HUYEN QUAN SON-38204034"
    }
  },
  "AGRIBANK/PGD HUYNH TAN PHAT": {
    "msb": { "code": "79204043" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 7-79204043"
    }
  },
  "AGRIBANK/PGD IASAO": {
    "msb": { "code": "64204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN IA GRAI-64204004"
    }
  },
  "AGRIBANK/PGD KA DO": {
    "msb": { "code": "68204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAM DONG-68204001"
    }
  },
  "AGRIBANK/PGD KC CHO CAU DIEN": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD KC GO MOI": {
    "msb": { "code": "80204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LONG AN-80204001"
    }
  },
  "AGRIBANK/PGD KCN AN NGHIEP": {
    "msb": { "code": "94204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SOC TRANG-94204001"
    }
  },
  "AGRIBANK/PGD KCN BAU XEO": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD KCN CAT LAI": {
    "msb": { "code": "79204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG SAI GON-79204014"
    }
  },
  "AGRIBANK/PGD KCN GIAO LONG": {
    "msb": { "code": "83204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-BEN TRE-83204007"
    }
  },
  "AGRIBANK/PGD KCN HIEP NINH": {
    "msb": { "code": "72204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TAY NINH-72204001"
    }
  },
  "AGRIBANK/PGD KCN NINH HIEP": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD KCN NOI BAI": {
    "msb": { "code": "01204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SOC SON-01204012"
    }
  },
  "AGRIBANK/PGD KCN TRA DA": {
    "msb": { "code": "64204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN TP PLEIKU - GIA LAI-64204016"
    }
  },
  "AGRIBANK/PGD KE XUYEN": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD KENH DAO": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD KENH VANG": {
    "msb": { "code": "27204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUONG TAI-27204004"
    }
  },
  "AGRIBANK/PGD KEP": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD KHAI XUAN": {
    "msb": { "code": "25204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH BA-25204007"
    }
  },
  "AGRIBANK/PGD KHAM THIEN": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD KHANH HUNG": {
    "msb": { "code": "94204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SOC TRANG-94204001"
    }
  },
  "AGRIBANK/PGD KHU 3 (HUE)": {
    "msb": { "code": "46204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU LOC-46204008"
    }
  },
  "AGRIBANK/PGD KHU DONG": {
    "msb": { "code": "34204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUNG HA-34204011"
    }
  },
  "AGRIBANK/PGD KHU MO MAO KHE": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD KHU NAM": {
    "msb": { "code": "79204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU MY HUNG-79204031"
    }
  },
  "AGRIBANK/PGD KHU TAY": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD KHU VUC CHEM": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD KHU VUC NOI BAI": {
    "msb": { "code": "01204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SOC SON-01204012"
    }
  },
  "AGRIBANK/PGD KHU VUC PHU LO": {
    "msb": { "code": "01204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SOC SON-01204012"
    }
  },
  "AGRIBANK/PGD KHUE TRUNG": {
    "msb": { "code": "48204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DA NANG-48204001"
    }
  },
  "AGRIBANK/PGD KHUONG DINH": {
    "msb": { "code": "01204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH TRI-01204004"
    }
  },
  "AGRIBANK/PGD KHUONG TRUNG": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD KIEM TAN": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD KIEU": {
    "msb": { "code": "38204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN DINH-38204005"
    }
  },
  "AGRIBANK/PGD KIM": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD KIM ANH": {
    "msb": { "code": "01204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SOC SON-01204012"
    }
  },
  "AGRIBANK/PGD KIM DONG": {
    "msb": { "code": "01204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA THANH-01204032"
    }
  },
  "AGRIBANK/PGD KIM LIEN (CN BACH KHOA)": {
    "msb": { "code": "01204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI I-01204026"
    }
  },
  "AGRIBANK/PGD KIM LIEN (CN HA THANH)": {
    "msb": { "code": "01204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA THANH-01204032"
    }
  },
  "AGRIBANK/PGD KIM LIEN (CN TRANG AN)": {
    "msb": { "code": "01204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRANG AN-01204029"
    }
  },
  "AGRIBANK/PGD KIM LIEN (NGHE AN)": {
    "msb": { "code": "40204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM DAN-40204010"
    }
  },
  "AGRIBANK/PGD KIM LONG": {
    "msb": { "code": "77204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU DUC-77204007"
    }
  },
  "AGRIBANK/PGD KIM NGOC": {
    "msb": { "code": "02204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC QUANG-02204008"
    }
  },
  "AGRIBANK/PGD KIM TIN": {
    "msb": { "code": "66204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN TP BUON MA THUOT-66204020"
    }
  },
  "AGRIBANK/PGD KIM XUYEN": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD KON BLA": {
    "msb": { "code": "64204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KBANG-64204007"
    }
  },
  "AGRIBANK/PGD KON PLONG": {
    "msb": { "code": "62204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KON RAY-62204008"
    }
  },
  "AGRIBANK/PGD KV 1 CAO LANH": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/PGD KV 2 (TP THAI BINH)": {
    "msb": { "code": "34204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP THAI BINH-34204002"
    }
  },
  "AGRIBANK/PGD KV 3 (TP THAI BINH)": {
    "msb": { "code": "34204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP THAI BINH-34204002"
    }
  },
  "AGRIBANK/PGD KV 4 (TP THAI BINH)": {
    "msb": { "code": "34204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP THAI BINH-34204002"
    }
  },
  "AGRIBANK/PGD KV 5 (TP THAI BINH)": {
    "msb": { "code": "34204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP THAI BINH-34204002"
    }
  },
  "AGRIBANK/PGD KV 6 (TP THAI BINH)": {
    "msb": { "code": "34204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP THAI BINH-34204002"
    }
  },
  "AGRIBANK/PGD KV 9 (TP THAI BINH)": {
    "msb": { "code": "34204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP THAI BINH-34204002"
    }
  },
  "AGRIBANK/PGD KV BINH THANH (TAY NINH)": {
    "msb": { "code": "72204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN KCN TRANG BANG-72204004"
    }
  },
  "AGRIBANK/PGD KV BUNG": {
    "msb": { "code": "34204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU THU-34204004"
    }
  },
  "AGRIBANK/PGD KV BUT": {
    "msb": { "code": "37204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN MO-37204005"
    }
  },
  "AGRIBANK/PGD KV CAU CAU": {
    "msb": { "code": "34204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THAI THUY-34204003"
    }
  },
  "AGRIBANK/PGD KV CAU KHOI": {
    "msb": { "code": "72204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN H.DUONG MINH CHAU-72204008"
    }
  },
  "AGRIBANK/PGD KV CHO MONG CAI": {
    "msb": { "code": "22204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG QUANG NINH-22204005"
    }
  },
  "AGRIBANK/PGD KV DAI MO": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD KV DAN": {
    "msb": { "code": "36204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU BAN-36204003"
    }
  },
  "AGRIBANK/PGD KV GIA LAC": {
    "msb": { "code": "37204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIA VIEN-37204007"
    }
  },
  "AGRIBANK/PGD KV GOC(THAI BINH)": {
    "msb": { "code": "34204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIEN XUONG-34204010"
    }
  },
  "AGRIBANK/PGD KV HAI BA TRUNG - NAM DINH": {
    "msb": { "code": "36204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NAM DINH-36204015"
    }
  },
  "AGRIBANK/PGD KV HAI LOC": {
    "msb": { "code": "36204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAI HAU-36204012"
    }
  },
  "AGRIBANK/PGD KV HUNG NHAN": {
    "msb": { "code": "34204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUNG HA-34204011"
    }
  },
  "AGRIBANK/PGD KV KHANH AN": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/PGD KV KHANH THIEN": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/PGD KV KHANH TRUNG": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/PGD KV LOC HUNG": {
    "msb": { "code": "72204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN KCN TRANG BANG-72204004"
    }
  },
  "AGRIBANK/PGD KV NA-GIA LAM - NINH BINH": {
    "msb": { "code": "37204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NHO QUAN-37204003"
    }
  },
  "AGRIBANK/PGD KV NINH CUONG": {
    "msb": { "code": "36204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUC NINH-36204008"
    }
  },
  "AGRIBANK/PGD KV PHUOC DONG": {
    "msb": { "code": "72204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN GO DAU - TAY NINH-72204011"
    }
  },
  "AGRIBANK/PGD KV QUAN LAC": {
    "msb": { "code": "36204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHIA HUNG-36204006"
    }
  },
  "AGRIBANK/PGD KV QUYNH TRANG": {
    "msb": { "code": "34204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUYNH PHU-34204007"
    }
  },
  "AGRIBANK/PGD KV RIA": {
    "msb": { "code": "37204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN KHU VUC RIA-37204012"
    }
  },
  "AGRIBANK/PGD KV TAN MY (DUC HOA)": {
    "msb": { "code": "80204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUC HOA-80204008"
    }
  },
  "AGRIBANK/PGD KV THANH LONG": {
    "msb": { "code": "34204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HUNG-34204006"
    }
  },
  "AGRIBANK/PGD KV TINH XUYEN": {
    "msb": { "code": "34204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUNG HA-34204011"
    }
  },
  "AGRIBANK/PGD KV TU": {
    "msb": { "code": "37204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN MO-37204005"
    }
  },
  "AGRIBANK/PGD KV1 (TAM NONG DONG THAP)": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/PGD KV1-CN THAP MUOI DONG THAP": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/PGD KVKHANH NHAC": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/PGD KY PHU": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD LA HIEN": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD LA NGA": {
    "msb": { "code": "45204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH LINH-45204010"
    }
  },
  "AGRIBANK/PGD LAC LONG QUAN (HCM)": {
    "msb": { "code": "79204047" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN LY THUONG KIET-HCM-79204047"
    }
  },
  "AGRIBANK/PGD LAC LONG QUAN (HN)": {
    "msb": { "code": "01204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HONG HA-01204018"
    }
  },
  "AGRIBANK/PGD LAC NGHIEP": {
    "msb": { "code": "68204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DON DUONG-68204013"
    }
  },
  "AGRIBANK/PGD LAI KHE": {
    "msb": { "code": "30204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM THANH-30204003"
    }
  },
  "AGRIBANK/PGD LAI UYEN": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH DUONG-74204001"
    }
  },
  "AGRIBANK/PGD LAM MY": {
    "msb": { "code": "40204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHI LOC-40204008"
    }
  },
  "AGRIBANK/PGD LAM SON": {
    "msb": { "code": "38204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGOC LAC-38204032"
    }
  },
  "AGRIBANK/PGD LANG CO": {
    "msb": { "code": "46204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU LOC-46204008"
    }
  },
  "AGRIBANK/PGD LE DAI HANH (CN DONG HN)": {
    "msb": { "code": "01204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG HA NOI-01204008"
    }
  },
  "AGRIBANK/PGD LE DAI HANH (CN HA THANH)": {
    "msb": { "code": "01204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA THANH-01204032"
    }
  },
  "AGRIBANK/PGD LE DAI HANH (CN TRANG AN)": {
    "msb": { "code": "01204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRANG AN-01204029"
    }
  },
  "AGRIBANK/PGD LE HONG PHONG (BINH DINH)": {
    "msb": { "code": "52204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP QUY NHON-52204002"
    }
  },
  "AGRIBANK/PGD LE HONG PHONG (HCM)": {
    "msb": { "code": "79204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 4-79204005"
    }
  },
  "AGRIBANK/PGD LE LOI (KON TUM)": {
    "msb": { "code": "62204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN KON TUM-PGD LE LOI-62204011"
    }
  },
  "AGRIBANK/PGD LE LOI (SON TAY)": {
    "msb": { "code": "01204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TP SON TAY-01204049"
    }
  },
  "AGRIBANK/PGD LE LOI (TP VINH)": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/PGD LE VAN SY": {
    "msb": { "code": "79204042" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN AN PHU-79204042"
    }
  },
  "AGRIBANK/PGD LIEN CHAU": {
    "msb": { "code": "26204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN LAC-26204004"
    }
  },
  "AGRIBANK/PGD LIEN HA": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/PGD LIEN PHUONG": {
    "msb": { "code": "36204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUC NINH-36204008"
    }
  },
  "AGRIBANK/PGD LIEN SON": {
    "msb": { "code": "15204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN CHAN-15204004"
    }
  },
  "AGRIBANK/PGD LIM": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD LINH DAM": {
    "msb": { "code": "01204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH TRI-01204004"
    }
  },
  "AGRIBANK/PGD LINH LANG": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD LINH NAM": {
    "msb": { "code": "01204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH TRI-01204004"
    }
  },
  "AGRIBANK/PGD LINH TAY": {
    "msb": { "code": "79204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DUC-79204024"
    }
  },
  "AGRIBANK/PGD LINH TRUNG": {
    "msb": { "code": "79204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DUC-79204024"
    }
  },
  "AGRIBANK/PGD LINH XUAN": {
    "msb": { "code": "79204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DUC-79204024"
    }
  },
  "AGRIBANK/PGD LOC CHAU": {
    "msb": { "code": "68204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM LAM DONG-68204002"
    }
  },
  "AGRIBANK/PGD LOC HOA": {
    "msb": { "code": "36204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NAM DINH-36204002"
    }
  },
  "AGRIBANK/PGD LOC THAI": {
    "msb": { "code": "70204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LOC NINH-70204006"
    }
  },
  "AGRIBANK/PGD LOC THUAN": {
    "msb": { "code": "83204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH DAI-83204006"
    }
  },
  "AGRIBANK/PGD LONG BINH": {
    "msb": { "code": "75204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC DONG NAI-75204002"
    }
  },
  "AGRIBANK/PGD LONG BINH (AN GIANG)": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/PGD LONG BINH (TIEN GIANG)": {
    "msb": { "code": "82204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GO CONG TAY-82204007"
    }
  },
  "AGRIBANK/PGD LONG CHAU": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD LONG DIEN (TINH BAC LIEU)": {
    "msb": { "code": "95204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC LIEU-95204001"
    }
  },
  "AGRIBANK/PGD LONG DINH": {
    "msb": { "code": "82204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-TIEN GIANG-82204009"
    }
  },
  "AGRIBANK/PGD LONG SON": {
    "msb": { "code": "77204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN BA RIA VUNG TAU-77204001"
    }
  },
  "AGRIBANK/PGD LONG TAN": {
    "msb": { "code": "77204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LONG DIEN-77204006"
    }
  },
  "AGRIBANK/PGD LONG THOI (HCM)": {
    "msb": { "code": "79204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NHA BE-79204011"
    }
  },
  "AGRIBANK/PGD LONG THOI (TRA VINH)": {
    "msb": { "code": "84204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEU CAN-84204004"
    }
  },
  "AGRIBANK/PGD LONG TIEN": {
    "msb": { "code": "82204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX CAI LAY-82204002"
    }
  },
  "AGRIBANK/PGD LONG TRUONG": {
    "msb": { "code": "79204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN MY THANH-79204049"
    }
  },
  "AGRIBANK/PGD LONG XUYEN - HAI DUONG": {
    "msb": { "code": "30204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HAI DUONG-30204001"
    }
  },
  "AGRIBANK/PGD LU": {
    "msb": { "code": "34204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIEN XUONG-34204010"
    }
  },
  "AGRIBANK/PGD LUAN THANH": {
    "msb": { "code": "38204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THUONG XUAN-38204007"
    }
  },
  "AGRIBANK/PGD LUONG KHANH THIEN": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD LUONG QUOI": {
    "msb": { "code": "83204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIONG TROM-83204010"
    }
  },
  "AGRIBANK/PGD LUONG SON": {
    "msb": { "code": "25204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN LAP-25204012"
    }
  },
  "AGRIBANK/PGD LUONG YEN": {
    "msb": { "code": "01204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LONG BIEN-01204019"
    }
  },
  "AGRIBANK/PGD LY HOA": {
    "msb": { "code": "44204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BO TRACH-44204002"
    }
  },
  "AGRIBANK/PGD MA LU THANG": {
    "msb": { "code": "12204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHONG THO-12204004"
    }
  },
  "AGRIBANK/PGD MAI LAM": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/PGD MAI SUU": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD ME TRI": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD MIEU MON": {
    "msb": { "code": "01204050" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.CHUONG MY - HA TAY-01204050"
    }
  },
  "AGRIBANK/PGD MINH AN": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD MINH CAM": {
    "msb": { "code": "44204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUYEN HOA-44204009"
    }
  },
  "AGRIBANK/PGD MINH DAI": {
    "msb": { "code": "25204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN SON-25204008"
    }
  },
  "AGRIBANK/PGD MINH DUC": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD MINH KHAI (BAC CAN)": {
    "msb": { "code": "06204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC CAN-06204001"
    }
  },
  "AGRIBANK/PGD MINH KHAI (HCM)": {
    "msb": { "code": "79204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 10-79204018"
    }
  },
  "AGRIBANK/PGD MINH KHAI (HN)": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD MINH TAN": {
    "msb": { "code": "01204046" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.PHU XUYEN - HA TAY-01204046"
    }
  },
  "AGRIBANK/PGD MINH THANH": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD MO BACH": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD MO TRANG": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD MOI": {
    "msb": { "code": "38204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THANH HOA-38204001"
    }
  },
  "AGRIBANK/PGD MUI NAI": {
    "msb": { "code": "91204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KIEN GIANG-91204001"
    }
  },
  "AGRIBANK/PGD MUONG CHUA": {
    "msb": { "code": "17204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN LAC-17204008"
    }
  },
  "AGRIBANK/PGD MUONG KIM": {
    "msb": { "code": "12204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN UYEN-12204008"
    }
  },
  "AGRIBANK/PGD MUONG LO": {
    "msb": { "code": "15204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN CHAN-15204004"
    }
  },
  "AGRIBANK/PGD MUONG THANH": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD MUONG XO": {
    "msb": { "code": "12204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHONG THO-12204004"
    }
  },
  "AGRIBANK/PGD MY AN": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD MY DA": {
    "msb": { "code": "56204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KHANH HOA-56204001"
    }
  },
  "AGRIBANK/PGD MY DINH (TU LIEM)": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD MY DUC (HAI PHONG)": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD MY DUC (QUANG BINH)": {
    "msb": { "code": "44204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LE THUY-44204003"
    }
  },
  "AGRIBANK/PGD MY HUONG": {
    "msb": { "code": "58204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH THUAN-58204001"
    }
  },
  "AGRIBANK/PGD MY LAM": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD MY LONG": {
    "msb": { "code": "84204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TRA VINH-84204001"
    }
  },
  "AGRIBANK/PGD MY PHUOC TAY": {
    "msb": { "code": "82204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX CAI LAY-82204002"
    }
  },
  "AGRIBANK/PGD MY QUY TAY": {
    "msb": { "code": "80204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LONG AN-80204001"
    }
  },
  "AGRIBANK/PGD MY THANH (BEN TRE)": {
    "msb": { "code": "83204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIONG TROM-83204010"
    }
  },
  "AGRIBANK/PGD MY THANH (BINH DINH)": {
    "msb": { "code": "52204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH DINH-52204001"
    }
  },
  "AGRIBANK/PGD MY THUAN": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD MY XUAN": {
    "msb": { "code": "77204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN KCN TAN THANH-77204005"
    }
  },
  "AGRIBANK/PGD NA DUONG": {
    "msb": { "code": "20204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LOC BINH-20204007"
    }
  },
  "AGRIBANK/PGD NA GIANG": {
    "msb": { "code": "04204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA QUANG-04204005"
    }
  },
  "AGRIBANK/PGD NA PHAC": {
    "msb": { "code": "06204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGAN SON-06204004"
    }
  },
  "AGRIBANK/PGD NA SAN": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/PGD NA TAU": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD NAM": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD NAM BAN": {
    "msb": { "code": "68204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAM HA-68204012"
    }
  },
  "AGRIBANK/PGD NAM BINH CHANH": {
    "msb": { "code": "79204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH CHANH-79204022"
    }
  },
  "AGRIBANK/PGD NAM CUA VIET": {
    "msb": { "code": "45204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN TX QUANG TRI-45204007"
    }
  },
  "AGRIBANK/PGD NAM DONG (QUANG TRI)": {
    "msb": { "code": "45204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIO LINH-45204008"
    }
  },
  "AGRIBANK/PGD NAM HAI LANG": {
    "msb": { "code": "45204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HAI LANG-45204004"
    }
  },
  "AGRIBANK/PGD NAM HONG (DONG ANH - HN)": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/PGD NAM HONG (NAM DINH)": {
    "msb": { "code": "36204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM TRUC-36204004"
    }
  },
  "AGRIBANK/PGD NAM HUNG": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD NAM KY KHOI NGHIA": {
    "msb": { "code": "77204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TP VUNG TAU-77204002"
    }
  },
  "AGRIBANK/PGD NAM LONG (LAI CHAU)": {
    "msb": { "code": "12204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAI CHAU-12204001"
    }
  },
  "AGRIBANK/PGD NAM LONG (QUANG BINH)": {
    "msb": { "code": "44204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG NINH-44204004"
    }
  },
  "AGRIBANK/PGD NAM NAM": {
    "msb": { "code": "40204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM DAN-40204010"
    }
  },
  "AGRIBANK/PGD NAM NHA TRANG": {
    "msb": { "code": "56204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM NHA TRANG-56204011"
    }
  },
  "AGRIBANK/PGD NAM SON": {
    "msb": { "code": "37204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TP TAM DIEP-37204010"
    }
  },
  "AGRIBANK/PGD NAM THANH": {
    "msb": { "code": "34204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN HAI-34204005"
    }
  },
  "AGRIBANK/PGD NAM TRUNG YEN": {
    "msb": { "code": "01204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CAU GIAY-01204016"
    }
  },
  "AGRIBANK/PGD NAM VINH YEN": {
    "msb": { "code": "26204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH PHUC-26204001"
    }
  },
  "AGRIBANK/PGD NENH": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD NGA AN": {
    "msb": { "code": "38204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGA SON-38204029"
    }
  },
  "AGRIBANK/PGD NGA TU SO": {
    "msb": { "code": "01204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG MAI- HA NOI-01204020"
    }
  },
  "AGRIBANK/PGD NGAI CAU": {
    "msb": { "code": "01204037" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.HOAI DUC - HA TAY-01204037"
    }
  },
  "AGRIBANK/PGD NGAI GIAO": {
    "msb": { "code": "77204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU DUC-77204007"
    }
  },
  "AGRIBANK/PGD NGAN DIEN": {
    "msb": { "code": "54204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SON HOA-54204003"
    }
  },
  "AGRIBANK/PGD NGAT KHEO": {
    "msb": { "code": "37204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TP TAM DIEP-37204010"
    }
  },
  "AGRIBANK/PGD NGHI PHU": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/PGD NGHIA DO": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD NGHIA DUNG": {
    "msb": { "code": "40204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN KY-40204015"
    }
  },
  "AGRIBANK/PGD NGHIA HIEU": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD NGHIA KY": {
    "msb": { "code": "51204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NGAI-51204001"
    }
  },
  "AGRIBANK/PGD NGHIA TRANG": {
    "msb": { "code": "38204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOANG HOA-38204009"
    }
  },
  "AGRIBANK/PGD NGO GIA TU": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD NGO MAY": {
    "msb": { "code": "52204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP QUY NHON-52204002"
    }
  },
  "AGRIBANK/PGD NGOC HA": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD NGOC LAP": {
    "msb": { "code": "25204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN LAP-25204012"
    }
  },
  "AGRIBANK/PGD NGOC LU": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD NGOC LUONG": {
    "msb": { "code": "17204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN THUY-17204010"
    }
  },
  "AGRIBANK/PGD NGOC TAO": {
    "msb": { "code": "01204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.PHUC THO - HA TAY-01204021"
    }
  },
  "AGRIBANK/PGD NGOC THIEN": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD NGOC XUYEN": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD NGU HIEP": {
    "msb": { "code": "01204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH TRI-01204004"
    }
  },
  "AGRIBANK/PGD NGU HUNG": {
    "msb": { "code": "30204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH MIEN-30204010"
    }
  },
  "AGRIBANK/PGD NGUYEN BINH KHIEM": {
    "msb": { "code": "83204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG KHOI-83204003"
    }
  },
  "AGRIBANK/PGD NGUYEN CHI THANH": {
    "msb": { "code": "79204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 10-79204018"
    }
  },
  "AGRIBANK/PGD NGUYEN CONG TRU": {
    "msb": { "code": "01204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG HA NOI-01204008"
    }
  },
  "AGRIBANK/PGD NGUYEN DINH CHIEU": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD NGUYEN KHE": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/PGD NGUYEN KHUYEN": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD NGUYEN LUONG BANG": {
    "msb": { "code": "79204043" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 7-79204043"
    }
  },
  "AGRIBANK/PGD NGUYEN OANH": {
    "msb": { "code": "79204046" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC SAI GON-79204046"
    }
  },
  "AGRIBANK/PGD NGUYEN SON": {
    "msb": { "code": "01204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LONG BIEN-01204019"
    }
  },
  "AGRIBANK/PGD NGUYEN THAI BINH": {
    "msb": { "code": "79204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG TAM SAI GON-79204015"
    }
  },
  "AGRIBANK/PGD NGUYEN THI TAN": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/PGD NGUYEN TRAI (HCM)": {
    "msb": { "code": "79204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG TAM SAI GON-79204015"
    }
  },
  "AGRIBANK/PGD NGUYEN TRAI (HN)": {
    "msb": { "code": "01204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG MAI- HA NOI-01204020"
    }
  },
  "AGRIBANK/PGD NGUYEN TRAI (THANH HOA)": {
    "msb": { "code": "38204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SO 2 - THANH HOA-38204013"
    }
  },
  "AGRIBANK/PGD NGUYEN TRI PHUONG": {
    "msb": { "code": "48204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI CHAU-48204003"
    }
  },
  "AGRIBANK/PGD NGUYEN TRONG TUYEN": {
    "msb": { "code": "79204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 11-79204003"
    }
  },
  "AGRIBANK/PGD NGUYEN TRUNG TRUC": {
    "msb": { "code": "91204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KIEN GIANG-91204001"
    }
  },
  "AGRIBANK/PGD NGUYEN TUAN": {
    "msb": { "code": "01204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG YEN-01204027"
    }
  },
  "AGRIBANK/PGD NGUYEN VAN CU (HCM)": {
    "msb": { "code": "79204042" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN AN PHU-79204042"
    }
  },
  "AGRIBANK/PGD NGUYEN VAN CU (HN)": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD NGUYEN VAN NGHI": {
    "msb": { "code": "79204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU NHUAN-79204006"
    }
  },
  "AGRIBANK/PGD NGUYEN VAN NINH": {
    "msb": { "code": "48204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI CHAU-48204003"
    }
  },
  "AGRIBANK/PGD NGUYEN VAN TROI": {
    "msb": { "code": "79204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU NHUAN-79204006"
    }
  },
  "AGRIBANK/PGD NGUYET DUC": {
    "msb": { "code": "26204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN LAC-26204004"
    }
  },
  "AGRIBANK/PGD NGUYET HOA": {
    "msb": { "code": "84204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-TRA VINH-84204011"
    }
  },
  "AGRIBANK/PGD NHA NAM - BAC GIANG": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD NHA RONG": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/PGD NHAN CO": {
    "msb": { "code": "67204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN TINH DAC NONG-67204001"
    }
  },
  "AGRIBANK/PGD NHAN NGHIA": {
    "msb": { "code": "17204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAC SON-17204009"
    }
  },
  "AGRIBANK/PGD NHAN THANG": {
    "msb": { "code": "27204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIA BINH-27204009"
    }
  },
  "AGRIBANK/PGD NHAT TAN": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD NHAT TAO": {
    "msb": { "code": "79204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 4-79204005"
    }
  },
  "AGRIBANK/PGD NHON": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD NHON SON": {
    "msb": { "code": "58204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH SON-58204003"
    }
  },
  "AGRIBANK/PGD NINH AN": {
    "msb": { "code": "56204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH HOA-56204005"
    }
  },
  "AGRIBANK/PGD NINH DIEM": {
    "msb": { "code": "56204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH HOA-56204005"
    }
  },
  "AGRIBANK/PGD NINH GIA": {
    "msb": { "code": "68204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAM DONG-68204001"
    }
  },
  "AGRIBANK/PGD NINH KHANH": {
    "msb": { "code": "37204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SONG VAN-37204008"
    }
  },
  "AGRIBANK/PGD NINH PHONG": {
    "msb": { "code": "37204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOA LU-37204002"
    }
  },
  "AGRIBANK/PGD NINH PHUOC - NINH BINH": {
    "msb": { "code": "37204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SONG VAN-37204008"
    }
  },
  "AGRIBANK/PGD NINH QUOI": {
    "msb": { "code": "95204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC LIEU-95204001"
    }
  },
  "AGRIBANK/PGD NON": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD NON NUOC": {
    "msb": { "code": "48204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN NGU HANH SON-48204006"
    }
  },
  "AGRIBANK/PGD NONG LAM": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD NUA": {
    "msb": { "code": "38204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRIEU SON-38204008"
    }
  },
  "AGRIBANK/PGD NY": {
    "msb": { "code": "01204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SOC SON-01204012"
    }
  },
  "AGRIBANK/PGD ONG TA": {
    "msb": { "code": "79204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 9-79204012"
    }
  },
  "AGRIBANK/PGD PGD DONG NGU": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD PHAM NGOC THACH": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/PGD PHAM VAN HAI": {
    "msb": { "code": "79204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN BINH-79204020"
    }
  },
  "AGRIBANK/PGD PHAN BOI CHAU": {
    "msb": { "code": "82204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX GO CONG-82204011"
    }
  },
  "AGRIBANK/PGD PHAN CHU TRINH": {
    "msb": { "code": "68204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN TP DA LAT-68204003"
    }
  },
  "AGRIBANK/PGD PHAP VAN": {
    "msb": { "code": "01204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG VUONG- HA NOI-01204028"
    }
  },
  "AGRIBANK/PGD PHI TRUONG": {
    "msb": { "code": "79204048" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUONG SON-79204048"
    }
  },
  "AGRIBANK/PGD PHO CA": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD PHO HO": {
    "msb": { "code": "27204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THUAN THANH-27204006"
    }
  },
  "AGRIBANK/PGD PHO HOA": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD PHO MOI": {
    "msb": { "code": "10204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN TP LAO CAI-10204009"
    }
  },
  "AGRIBANK/PGD PHONG": {
    "msb": { "code": "20204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUU LUNG-20204004"
    }
  },
  "AGRIBANK/PGD PHONG CHAU": {
    "msb": { "code": "25204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN TX PHU THO-25204004"
    }
  },
  "AGRIBANK/PGD PHONG KHE": {
    "msb": { "code": "27204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TP BAC NINH-27204002"
    }
  },
  "AGRIBANK/PGD PHONG PHU (HCM)": {
    "msb": { "code": "79204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 9-79204012"
    }
  },
  "AGRIBANK/PGD PHONG PHU (TRA VINH)": {
    "msb": { "code": "84204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAU KE-84204003"
    }
  },
  "AGRIBANK/PGD PHONG THU": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD PHU DONG (HCM)": {
    "msb": { "code": "79204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HOC MON-79204013"
    }
  },
  "AGRIBANK/PGD PHU DONG (LAM DONG)": {
    "msb": { "code": "68204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN TP DA LAT-68204003"
    }
  },
  "AGRIBANK/PGD PHU GIA": {
    "msb": { "code": "79204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU MY HUNG-79204031"
    }
  },
  "AGRIBANK/PGD PHU HO": {
    "msb": { "code": "25204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN TX PHU THO-25204004"
    }
  },
  "AGRIBANK/PGD PHU HOA (AN GIANG)": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/PGD PHU HOA (HCM)": {
    "msb": { "code": "79204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN BINH-79204020"
    }
  },
  "AGRIBANK/PGD PHU HUNG (CA MAU)": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD PHU HUNG (HCM)": {
    "msb": { "code": "79204052" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH PHU-79204052"
    }
  },
  "AGRIBANK/PGD PHU HUU": {
    "msb": { "code": "79204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN MY THANH-79204049"
    }
  },
  "AGRIBANK/PGD PHU LAM (DONG NAI)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD PHU LAM (HN)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD PHU LAP": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD PHU LOC (LANG SON)": {
    "msb": { "code": "20204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LANG SON-20204001"
    }
  },
  "AGRIBANK/PGD PHU LOC (PHU THO)": {
    "msb": { "code": "25204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU NINH - PHU THO-25204006"
    }
  },
  "AGRIBANK/PGD PHU LUC": {
    "msb": { "code": "25204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH PHU THO-25204001"
    }
  },
  "AGRIBANK/PGD PHU LUU (HA TINH)": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD PHU LUU (TUYEN QUANG)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD PHU MINH": {
    "msb": { "code": "01204046" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.PHU XUYEN - HA TAY-01204046"
    }
  },
  "AGRIBANK/PGD PHU MY": {
    "msb": { "code": "79204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU MY HUNG-79204031"
    }
  },
  "AGRIBANK/PGD PHU MY I": {
    "msb": { "code": "77204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN KCN TAN THANH-77204005"
    }
  },
  "AGRIBANK/PGD PHU NGOC": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD PHU NHON": {
    "msb": { "code": "64204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHU SE-64204003"
    }
  },
  "AGRIBANK/PGD PHU QUOI": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD PHU TAN (KCN TAN TAO)": {
    "msb": { "code": "79204045" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN TAO-79204045"
    }
  },
  "AGRIBANK/PGD PHU THI": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD PHU THIEN": {
    "msb": { "code": "64204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU THIEN - GIA LAI-64204025"
    }
  },
  "AGRIBANK/PGD PHU THO": {
    "msb": { "code": "79204047" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN LY THUONG KIET-HCM-79204047"
    }
  },
  "AGRIBANK/PGD PHU THO HOA": {
    "msb": { "code": "79204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN PHU-79204004"
    }
  },
  "AGRIBANK/PGD PHU THUONG": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD PHU TRUNG": {
    "msb": { "code": "79204042" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN AN PHU-79204042"
    }
  },
  "AGRIBANK/PGD PHU TUC": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD PHU XUAN (HCM)": {
    "msb": { "code": "79204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NHA BE-79204011"
    }
  },
  "AGRIBANK/PGD PHU XUAN (LAO CAI)": {
    "msb": { "code": "10204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAO THANG-10204008"
    }
  },
  "AGRIBANK/PGD PHU XUAN (VINH PHUC)": {
    "msb": { "code": "26204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH XUYEN-26204008"
    }
  },
  "AGRIBANK/PGD PHUC DONG": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD PHUC THANH": {
    "msb": { "code": "30204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KINH MON-30204011"
    }
  },
  "AGRIBANK/PGD PHUC TRACH": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD PHUNG XA": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD PHUOC HOI": {
    "msb": { "code": "60204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH THUAN-60204001"
    }
  },
  "AGRIBANK/PGD PHUOC HUNG": {
    "msb": { "code": "77204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LONG DIEN-77204006"
    }
  },
  "AGRIBANK/PGD PHUOC MY TRUNG": {
    "msb": { "code": "83204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN MO CAY BAC-83204012"
    }
  },
  "AGRIBANK/PGD PHUOC TAN": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD PHUOC THAI": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD PHUOC THANG": {
    "msb": { "code": "77204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TP VUNG TAU-77204002"
    }
  },
  "AGRIBANK/PGD PHUOC THIEN": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD PHUONG": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD PHUONG 3 (TAY NINH)": {
    "msb": { "code": "72204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TAY NINH-72204001"
    }
  },
  "AGRIBANK/PGD PHUONG 6 (CA MAU)": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD PHUONG 7 (CA MAU)": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD PHUONG MAI (HN)": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD PHUONG MAI (HONG HA)": {
    "msb": { "code": "01204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HONG HA-01204018"
    }
  },
  "AGRIBANK/PGD QUAN BANH": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/PGD QUAN GANH": {
    "msb": { "code": "01204042" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THUONG TIN - HA TAY-01204042"
    }
  },
  "AGRIBANK/PGD QUAN HANH": {
    "msb": { "code": "40204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHI LOC-40204008"
    }
  },
  "AGRIBANK/PGD QUAN HOA": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD QUAN THANH": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD QUAN TOAN": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD QUAN TRU": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD QUAN VUONG": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD QUANG AN": {
    "msb": { "code": "46204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG DIEN-46204006"
    }
  },
  "AGRIBANK/PGD QUANG BI": {
    "msb": { "code": "01204050" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.CHUONG MY - HA TAY-01204050"
    }
  },
  "AGRIBANK/PGD QUANG HA": {
    "msb": { "code": "26204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH XUYEN-26204008"
    }
  },
  "AGRIBANK/PGD QUANG HANH": {
    "msb": { "code": "22204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TX CAM PHA-22204012"
    }
  },
  "AGRIBANK/PGD QUANG LA": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD QUANG LUU": {
    "msb": { "code": "38204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM THANH HOA-38204010"
    }
  },
  "AGRIBANK/PGD QUANG NGOC": {
    "msb": { "code": "38204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM THANH HOA-38204010"
    }
  },
  "AGRIBANK/PGD QUANG TRUNG (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD QUANG TRUNG (HN)": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD QUANG TRUNG (SON TAY)": {
    "msb": { "code": "01204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TP SON TAY-01204049"
    }
  },
  "AGRIBANK/PGD QUANG TRUNG (THAI NGUYEN)": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD QUYET THANG": {
    "msb": { "code": "62204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN CN QUYET THANG-62204004"
    }
  },
  "AGRIBANK/PGD QUYNH CHAU": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD RACH ONG": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/PGD RANH": {
    "msb": { "code": "17204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM BOI-17204012"
    }
  },
  "AGRIBANK/PGD RO": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD ROON": {
    "msb": { "code": "44204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG TRACH-44204005"
    }
  },
  "AGRIBANK/PGD SAI DONG": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD SAN": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD SAN BAY DA NANG": {
    "msb": { "code": "48204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DA NANG-48204001"
    }
  },
  "AGRIBANK/PGD SI MA CAI": {
    "msb": { "code": "10204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC HA-10204002"
    }
  },
  "AGRIBANK/PGD SIEU THI DA NANG": {
    "msb": { "code": "48204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH KHE DN-48204005"
    }
  },
  "AGRIBANK/PGD SIM": {
    "msb": { "code": "38204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRIEU SON-38204008"
    }
  },
  "AGRIBANK/PGD SO 1 (BAC HA NOI)": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/PGD SO 1 (CA MAU)": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD SO 1 (CAO LANH)": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/PGD SO 1 (CHIEM HOA)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 1 (CU CHI)": {
    "msb": { "code": "79204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CU CHI-79204028"
    }
  },
  "AGRIBANK/PGD SO 1 (DAU TAM TO)": {
    "msb": { "code": "68204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM LAM DONG-68204002"
    }
  },
  "AGRIBANK/PGD SO 1 (DIEN NAM DIEN NGOC)": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD SO 1 (DONG HA NOI)": {
    "msb": { "code": "01204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG HA NOI-01204008"
    }
  },
  "AGRIBANK/PGD SO 1 (GIA LAI)": {
    "msb": { "code": "64204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH GIA LAI-64204001"
    }
  },
  "AGRIBANK/PGD SO 1 (GIANG VO)": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD SO 1 (HA NAM)": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD SO 1 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 1 (HAI DUONG)": {
    "msb": { "code": "30204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO HAI DUONG-30204009"
    }
  },
  "AGRIBANK/PGD SO 1 (HAU GIANG)": {
    "msb": { "code": "93204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAU GIANG-93204001"
    }
  },
  "AGRIBANK/PGD SO 1 (HIEP PHUOC)": {
    "msb": { "code": "79204050" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HIEP PHUOC-79204050"
    }
  },
  "AGRIBANK/PGD SO 1 (HOANG QUOC VIET)": {
    "msb": { "code": "01204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG QUOC VIET-01204023"
    }
  },
  "AGRIBANK/PGD SO 1 (HOI AN)": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD SO 1 (KCN TAN TAO)": {
    "msb": { "code": "79204045" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN TAO-79204045"
    }
  },
  "AGRIBANK/PGD SO 1 (KIEN GIANG)": {
    "msb": { "code": "91204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KIEN GIANG-91204001"
    }
  },
  "AGRIBANK/PGD SO 1 (KRONG PAK)": {
    "msb": { "code": "66204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KRONG PAK-66204013"
    }
  },
  "AGRIBANK/PGD SO 1 (LANG SON)": {
    "msb": { "code": "20204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG DANG-20204005"
    }
  },
  "AGRIBANK/PGD SO 1 (LAO CAI)": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD SO 1 (LONG KHANH)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD SO 1 (MIEN DONG)": {
    "msb": { "code": "79204037" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN MIEN DONG-79204037"
    }
  },
  "AGRIBANK/PGD SO 1 (MY DINH)": {
    "msb": { "code": "01204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN MY DINH-01204024"
    }
  },
  "AGRIBANK/PGD SO 1 (NINH BINH)": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/PGD SO 1 (PHAN DINH PHUNG)": {
    "msb": { "code": "79204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHAN DINH PHUNG-79204036"
    }
  },
  "AGRIBANK/PGD SO 1 (PHAN THIET)": {
    "msb": { "code": "60204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN TP PHAN THIET-60204015"
    }
  },
  "AGRIBANK/PGD SO 1 (QUAN 3)": {
    "msb": { "code": "79204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 3-79204009"
    }
  },
  "AGRIBANK/PGD SO 1 (QUAN 5)": {
    "msb": { "code": "79204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN QUAN 5-79204032"
    }
  },
  "AGRIBANK/PGD SO 1 (SA DEC)": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/PGD SO 1 (SAI GON)": {
    "msb": { "code": "79204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SAI GON-79204023"
    }
  },
  "AGRIBANK/PGD SO 1 (SON DUONG)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 1 (TAY DO)": {
    "msb": { "code": "01204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY DO-01204031"
    }
  },
  "AGRIBANK/PGD SO 1 (THANG BINH)": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/PGD SO 1 (THANG LONG)": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD SO 1 (THANH HOA)": {
    "msb": { "code": "38204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN TP THANH HOA-38204026"
    }
  },
  "AGRIBANK/PGD SO 1 (THOT NOT)": {
    "msb": { "code": "92204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN THOT NOT-92204004"
    }
  },
  "AGRIBANK/PGD SO 1 (TP DA NANG)": {
    "msb": { "code": "48204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DA NANG-48204001"
    }
  },
  "AGRIBANK/PGD SO 1 (TP NINH BINH)": {
    "msb": { "code": "37204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NINH BINH-37204009"
    }
  },
  "AGRIBANK/PGD SO 1 (TP THANH HOA)": {
    "msb": { "code": "38204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN TP THANH HOA-38204026"
    }
  },
  "AGRIBANK/PGD SO 1 (TRUNG YEN)": {
    "msb": { "code": "01204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG YEN-01204027"
    }
  },
  "AGRIBANK/PGD SO 1 (TUYEN QUANG)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 1 (TX TUYEN QUANG)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 1 (VINH LONG)": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD SO 1 (XUONG GIANG)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD SO 1 (XUYEN A)": {
    "msb": { "code": "79204044" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN XUYEN A-79204044"
    }
  },
  "AGRIBANK/PGD SO 1 (YEN BAI)": {
    "msb": { "code": "15204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO YEN BAI II-15204003"
    }
  },
  "AGRIBANK/PGD SO 1 TAY SAI GON(QTRUNG)": {
    "msb": { "code": "79204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY SAI GON-79204002"
    }
  },
  "AGRIBANK/PGD SO 1 TP CAN THO": {
    "msb": { "code": "92204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TP CAN THO-92204001"
    }
  },
  "AGRIBANK/PGD SO 1 TRAN VAN GIA": {
    "msb": { "code": "56204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KHANH HOA-56204001"
    }
  },
  "AGRIBANK/PGD SO 10 (GIANG VO)": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD SO 10 (THANH NAM)": {
    "msb": { "code": "36204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH NAM-36204014"
    }
  },
  "AGRIBANK/PGD SO 102 (XUONG GIANG)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD SO 11 (KCN HOA XA)": {
    "msb": { "code": "36204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NAM DINH-36204002"
    }
  },
  "AGRIBANK/PGD SO 11 (LANG HA)": {
    "msb": { "code": "01204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LANG HA-01204010"
    }
  },
  "AGRIBANK/PGD SO 131 (XUONG GIANG)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD SO 16 KCN THANG LONG": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD SO 17 (HOAN KIEM)": {
    "msb": { "code": "01204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOAN KIEM-01204022"
    }
  },
  "AGRIBANK/PGD SO 18 (HOAN KIEM)": {
    "msb": { "code": "01204022" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOAN KIEM-01204022"
    }
  },
  "AGRIBANK/PGD SO 1-CN HONG NGU DONG THAP": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/PGD SO 1-CN LAI VUNG DONG THAP": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/PGD SO 2 (BA RIA VUNG TAU)": {
    "msb": { "code": "77204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN BA RIA VUNG TAU-77204001"
    }
  },
  "AGRIBANK/PGD SO 2 (BAC HA NOI)": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/PGD SO 2 (CU CHI)": {
    "msb": { "code": "79204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CU CHI-79204028"
    }
  },
  "AGRIBANK/PGD SO 2 (DIEN BIEN PHU)": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD SO 2 (GIA LAM)- HA NOI": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD SO 2 (HA NAM)": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD SO 2 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 2 (HOANG QUOC VIET)": {
    "msb": { "code": "01204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG QUOC VIET-01204023"
    }
  },
  "AGRIBANK/PGD SO 2 (HUNG YEN)": {
    "msb": { "code": "33204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN TP HUNG YEN-33204012"
    }
  },
  "AGRIBANK/PGD SO 2 (KCN HOA XA)": {
    "msb": { "code": "36204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NAM DINH-36204002"
    }
  },
  "AGRIBANK/PGD SO 2 (KCN TAN TAO)": {
    "msb": { "code": "79204045" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN TAO-79204045"
    }
  },
  "AGRIBANK/PGD SO 2 (KIEN GIANG)": {
    "msb": { "code": "91204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KIEN GIANG-91204001"
    }
  },
  "AGRIBANK/PGD SO 2 (LANG HA)": {
    "msb": { "code": "01204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LANG HA-01204010"
    }
  },
  "AGRIBANK/PGD SO 2 (LONG KHANH)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD SO 2 (MY DINH)": {
    "msb": { "code": "01204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN MY DINH-01204024"
    }
  },
  "AGRIBANK/PGD SO 2 (NAM DO)": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD SO 2 (NINH BINH)": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/PGD SO 2 (PHAN DINH PHUNG)": {
    "msb": { "code": "79204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHAN DINH PHUNG-79204036"
    }
  },
  "AGRIBANK/PGD SO 2 (QUAN 3)": {
    "msb": { "code": "79204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 3-79204009"
    }
  },
  "AGRIBANK/PGD SO 2 (QUAN 5)": {
    "msb": { "code": "79204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN QUAN 5-79204032"
    }
  },
  "AGRIBANK/PGD SO 2 (SAI GON)": {
    "msb": { "code": "79204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SAI GON-79204023"
    }
  },
  "AGRIBANK/PGD SO 2 (SON DUONG)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 2 (TAY DO)": {
    "msb": { "code": "01204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY DO-01204031"
    }
  },
  "AGRIBANK/PGD SO 2 (THANG LONG)": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD SO 2 (THANH BINH)": {
    "msb": { "code": "30204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH HA-30204014"
    }
  },
  "AGRIBANK/PGD SO 2 (TP DA NANG)": {
    "msb": { "code": "48204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DA NANG-48204001"
    }
  },
  "AGRIBANK/PGD SO 2 (TP HA TINH)": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD SO 2 (TP NAM DINH)": {
    "msb": { "code": "36204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NAM DINH-36204015"
    }
  },
  "AGRIBANK/PGD SO 2 (TP PLEIKU)": {
    "msb": { "code": "64204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN TP PLEIKU - GIA LAI-64204016"
    }
  },
  "AGRIBANK/PGD SO 2 (TUYEN QUANG)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 2 (TX TUYEN QUANG)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 2 (YEN MO)": {
    "msb": { "code": "37204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN MO-37204005"
    }
  },
  "AGRIBANK/PGD SO 2 TAY SAI GON(QTRUNG)": {
    "msb": { "code": "79204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY SAI GON-79204002"
    }
  },
  "AGRIBANK/PGD SO 2 TP CAN THO": {
    "msb": { "code": "92204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TP CAN THO-92204001"
    }
  },
  "AGRIBANK/PGD SO 2 VIET HUNG": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD SO 21 (TAY HO)": {
    "msb": { "code": "01204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HO-01204025"
    }
  },
  "AGRIBANK/PGD SO 22 (TAY HO)": {
    "msb": { "code": "01204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HO-01204025"
    }
  },
  "AGRIBANK/PGD SO 23 (DONG DA HN)": {
    "msb": { "code": "01204034" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG DA-01204034"
    }
  },
  "AGRIBANK/PGD SO 24 (DONG DA HN)": {
    "msb": { "code": "01204034" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG DA-01204034"
    }
  },
  "AGRIBANK/PGD SO 25 (DONG DA HN)": {
    "msb": { "code": "01204034" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG DA-01204034"
    }
  },
  "AGRIBANK/PGD SO 2-YEN SON - TUYEN QUANG": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 3 (BAC HA NOI)": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/PGD SO 3 (CU CHI)": {
    "msb": { "code": "79204028" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CU CHI-79204028"
    }
  },
  "AGRIBANK/PGD SO 3 (DONG SAI GON)": {
    "msb": { "code": "79204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG SAI GON-79204014"
    }
  },
  "AGRIBANK/PGD SO 3 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 3 (HOA LUU)": {
    "msb": { "code": "37204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOA LU-37204002"
    }
  },
  "AGRIBANK/PGD SO 3 (KCN HOA XA)": {
    "msb": { "code": "36204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NAM DINH-36204002"
    }
  },
  "AGRIBANK/PGD SO 3 (LANG HA)": {
    "msb": { "code": "01204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LANG HA-01204010"
    }
  },
  "AGRIBANK/PGD SO 3 (MY DINH)": {
    "msb": { "code": "01204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN MY DINH-01204024"
    }
  },
  "AGRIBANK/PGD SO 3 (NAM DO)": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD SO 3 (NINH BINH)": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/PGD SO 3 (QUAN 3)": {
    "msb": { "code": "79204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 3-79204009"
    }
  },
  "AGRIBANK/PGD SO 3 (TAY DO)": {
    "msb": { "code": "01204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY DO-01204031"
    }
  },
  "AGRIBANK/PGD SO 3 (THANG LONG)": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD SO 3 (THANH BINH)": {
    "msb": { "code": "30204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH HA-30204014"
    }
  },
  "AGRIBANK/PGD SO 3 (TP DA NANG)": {
    "msb": { "code": "48204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DA NANG-48204001"
    }
  },
  "AGRIBANK/PGD SO 3 (TP HA TINH)": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD SO 3 (TP NAM DINH)": {
    "msb": { "code": "36204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NAM DINH-36204015"
    }
  },
  "AGRIBANK/PGD SO 3 (TUYEN QUANG)": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SO 3 TAY SAI GON(QTRUNG)": {
    "msb": { "code": "79204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY SAI GON-79204002"
    }
  },
  "AGRIBANK/PGD SO 32 (THANH XUAN)": {
    "msb": { "code": "01204035" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CN HA NOI II-01204035"
    }
  },
  "AGRIBANK/PGD SO 33 (THANH XUAN)": {
    "msb": { "code": "01204035" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CN HA NOI II-01204035"
    }
  },
  "AGRIBANK/PGD SO 34 (THANH XUAN)": {
    "msb": { "code": "01204035" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CN HA NOI II-01204035"
    }
  },
  "AGRIBANK/PGD SO 4 (BAC HA NOI)": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/PGD SO 4 (BACH KHOA)": {
    "msb": { "code": "01204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI I-01204026"
    }
  },
  "AGRIBANK/PGD SO 4 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 4 (NAM HA NOI)": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD SO 4 (QUAN 3)": {
    "msb": { "code": "79204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 3-79204009"
    }
  },
  "AGRIBANK/PGD SO 46 (THANH XUAN)": {
    "msb": { "code": "01204035" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN CN HA NOI II-01204035"
    }
  },
  "AGRIBANK/PGD SO 5 (BAC HA NOI)": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/PGD SO 5 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 5 (LANG HA)": {
    "msb": { "code": "01204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LANG HA-01204010"
    }
  },
  "AGRIBANK/PGD SO 5 (NAM HA NOI)": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD SO 5 (THANG LONG)": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD SO 5 (TU LIEM)": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD SO 5 GIENG DAY": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD SO 51 (HIEP HOA)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD SO 6 (BAC HA NOI)": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/PGD SO 6 (DONG SAI GON)": {
    "msb": { "code": "79204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG SAI GON-79204014"
    }
  },
  "AGRIBANK/PGD SO 6 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 6 (HOANG MAI)": {
    "msb": { "code": "01204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HOANG MAI- HA NOI-01204020"
    }
  },
  "AGRIBANK/PGD SO 6 (NAM HA NOI)": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD SO 6 (THANG LONG)": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD SO 6 (TP NAM DINH)": {
    "msb": { "code": "36204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NAM DINH-36204015"
    }
  },
  "AGRIBANK/PGD SO 6 (TP NINH BINH)": {
    "msb": { "code": "37204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NINH BINH-37204009"
    }
  },
  "AGRIBANK/PGD SO 6 (TU LIEM)": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD SO 7 (BAC HA NOI)": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/PGD SO 7 (BACH KHOA)": {
    "msb": { "code": "01204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI I-01204026"
    }
  },
  "AGRIBANK/PGD SO 7 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 7 (LANG HA)": {
    "msb": { "code": "01204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LANG HA-01204010"
    }
  },
  "AGRIBANK/PGD SO 7 (THANG LONG)": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/PGD SO 7 (THANH HOA)": {
    "msb": { "code": "38204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THANH HOA-38204001"
    }
  },
  "AGRIBANK/PGD SO 8 (BAC HA NOI)": {
    "msb": { "code": "01204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC HA NOI-01204006"
    }
  },
  "AGRIBANK/PGD SO 8 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 8 (LANG HA)": {
    "msb": { "code": "01204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN LANG HA-01204010"
    }
  },
  "AGRIBANK/PGD SO 8 (TAY HA NOI)": {
    "msb": { "code": "01204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HA NOI-01204007"
    }
  },
  "AGRIBANK/PGD SO 8 THU DO (BUI THI XUAN)": {
    "msb": { "code": "01204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DO-01204030"
    }
  },
  "AGRIBANK/PGD SO 9 (BACH KHOA)": {
    "msb": { "code": "01204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI I-01204026"
    }
  },
  "AGRIBANK/PGD SO 9 (HA TAY)": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD SO 9 (NAM HA NOI)": {
    "msb": { "code": "01204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HA NOI-01204017"
    }
  },
  "AGRIBANK/PGD SO 9 (THANH NAM)": {
    "msb": { "code": "36204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH NAM-36204014"
    }
  },
  "AGRIBANK/PGD SO 9 THU DO (BUI THI XUAN)": {
    "msb": { "code": "01204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DO-01204030"
    }
  },
  "AGRIBANK/PGD SO 92 (LUC NGAN)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD SON DA": {
    "msb": { "code": "01204044" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.BA VI - HA TAY-01204044"
    }
  },
  "AGRIBANK/PGD SON DONG (HA TAY- HA NOI)": {
    "msb": { "code": "01204037" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.HOAI DUC - HA TAY-01204037"
    }
  },
  "AGRIBANK/PGD SON HAI": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD SON LOC": {
    "msb": { "code": "01204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TP SON TAY-01204049"
    }
  },
  "AGRIBANK/PGD SON MY": {
    "msb": { "code": "51204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SON TINH-51204009"
    }
  },
  "AGRIBANK/PGD SON NAM": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD SON PHU": {
    "msb": { "code": "79204052" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH PHU-79204052"
    }
  },
  "AGRIBANK/PGD SONG DOC": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD SONG KHE": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD SONG PHU": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD SONG RAY": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD SONG THAO": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD SONG VANG": {
    "msb": { "code": "49204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG GIANG-49204025"
    }
  },
  "AGRIBANK/PGD SONG VE": {
    "msb": { "code": "51204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TU NGHIA-51204006"
    }
  },
  "AGRIBANK/PGD SU PHAM KY THUAT": {
    "msb": { "code": "79204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 9-79204012"
    }
  },
  "AGRIBANK/PGD SUOI DAU": {
    "msb": { "code": "56204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM LAM-56204010"
    }
  },
  "AGRIBANK/PGD SUOI NGHE": {
    "msb": { "code": "77204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU DUC-77204007"
    }
  },
  "AGRIBANK/PGD SUPE": {
    "msb": { "code": "25204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAM THAO-25204005"
    }
  },
  "AGRIBANK/PGD TA LUNG": {
    "msb": { "code": "04204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHUC HOA-04204011"
    }
  },
  "AGRIBANK/PGD TA UYEN": {
    "msb": { "code": "79204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 11-79204003"
    }
  },
  "AGRIBANK/PGD TAC VAN": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD TAM DA": {
    "msb": { "code": "33204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU CU-33204009"
    }
  },
  "AGRIBANK/PGD TAM PHU": {
    "msb": { "code": "79204033" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH TRIEU-79204033"
    }
  },
  "AGRIBANK/PGD TAM QUAN (BINH DINH)\\n": {
    "msb": { "code": "52204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HOAI NHON-52204008"
    }
  },
  "AGRIBANK/PGD TAM QUANG": {
    "msb": { "code": "49204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN KHU KTM CHU LAI-49204010"
    }
  },
  "AGRIBANK/PGD TAM SON": {
    "msb": { "code": "26204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAP THACH-26204005"
    }
  },
  "AGRIBANK/PGD TAM THUONG": {
    "msb": { "code": "25204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH PHU THO-25204001"
    }
  },
  "AGRIBANK/PGD TAM XUAN": {
    "msb": { "code": "49204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NUI THANH-49204027"
    }
  },
  "AGRIBANK/PGD TAN AN (BAC GIANG)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD TAN AN (NGHE AN)": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD TAN BINH (TRA VINH)": {
    "msb": { "code": "84204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CANG LONG-84204002"
    }
  },
  "AGRIBANK/PGD TAN BINH AN": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD TAN CANG": {
    "msb": { "code": "79204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH THANH-79204019"
    }
  },
  "AGRIBANK/PGD TAN CAU": {
    "msb": { "code": "68204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DI LINH-68204010"
    }
  },
  "AGRIBANK/PGD TAN DAN": {
    "msb": { "code": "30204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN SAO DO-30204012"
    }
  },
  "AGRIBANK/PGD TAN DE": {
    "msb": { "code": "34204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU THU-34204004"
    }
  },
  "AGRIBANK/PGD TAN DINH (BAC GIANG)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD TAN DINH (HCM)": {
    "msb": { "code": "79204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SAI GON-79204023"
    }
  },
  "AGRIBANK/PGD TAN HA": {
    "msb": { "code": "68204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAM DONG-68204001"
    }
  },
  "AGRIBANK/PGD TAN HAO": {
    "msb": { "code": "83204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIONG TROM-83204010"
    }
  },
  "AGRIBANK/PGD TAN HIEP (BINH DUONG)": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH DUONG-74204001"
    }
  },
  "AGRIBANK/PGD TAN HOA (BUON DON)": {
    "msb": { "code": "66204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BUON DON-66204017"
    }
  },
  "AGRIBANK/PGD TAN HOA (DAKLAK)": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/PGD TAN HOA (QUOC OAI)": {
    "msb": { "code": "01204043" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.QUOC OAI - HA TAY-01204043"
    }
  },
  "AGRIBANK/PGD TAN HOA (THAI BINH)": {
    "msb": { "code": "34204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU THU-34204004"
    }
  },
  "AGRIBANK/PGD TAN HOI (HA NOI)": {
    "msb": { "code": "01204045" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.DAN PHUONG - HA TAY-01204045"
    }
  },
  "AGRIBANK/PGD TAN HOI (LAM DONG)": {
    "msb": { "code": "68204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LAM DONG-68204001"
    }
  },
  "AGRIBANK/PGD TAN HUNG (BINH PHU)": {
    "msb": { "code": "79204052" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH PHU-79204052"
    }
  },
  "AGRIBANK/PGD TAN HUNG (NAM SAI GON)": {
    "msb": { "code": "79204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM SAI GON-79204026"
    }
  },
  "AGRIBANK/PGD TAN HUONG": {
    "msb": { "code": "79204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN PHU-79204004"
    }
  },
  "AGRIBANK/PGD TAN LAP": {
    "msb": { "code": "70204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG PHU-70204003"
    }
  },
  "AGRIBANK/PGD TAN LINH": {
    "msb": { "code": "01204044" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.BA VI - HA TAY-01204044"
    }
  },
  "AGRIBANK/PGD TAN LOC": {
    "msb": { "code": "25204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM KHE-25204002"
    }
  },
  "AGRIBANK/PGD TAN LOI": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/PGD TAN LUOC": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD TAN MAI": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD TAN MY (DONG THAP)": {
    "msb": { "code": "87204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DONG THAP-87204001"
    }
  },
  "AGRIBANK/PGD TAN MY (HCM)": {
    "msb": { "code": "79204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG TAM SAI GON-79204015"
    }
  },
  "AGRIBANK/PGD TAN QUAN": {
    "msb": { "code": "30204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HAI DUONG-30204001"
    }
  },
  "AGRIBANK/PGD TAN QUANG": {
    "msb": { "code": "30204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH GIANG-30204008"
    }
  },
  "AGRIBANK/PGD TAN QUY": {
    "msb": { "code": "79204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN PHU-79204004"
    }
  },
  "AGRIBANK/PGD TAN SON (BAC GIANG)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD TAN SON (HA NAM)": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD TAN SON NHAT": {
    "msb": { "code": "79204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA DINH-79204021"
    }
  },
  "AGRIBANK/PGD TAN SON NHI": {
    "msb": { "code": "79204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN PHU-79204004"
    }
  },
  "AGRIBANK/PGD TAN TAP": {
    "msb": { "code": "80204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAN GIUOC-80204014"
    }
  },
  "AGRIBANK/PGD TAN TAY": {
    "msb": { "code": "82204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GO CONG DONG-82204006"
    }
  },
  "AGRIBANK/PGD TAN THACH": {
    "msb": { "code": "83204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-BEN TRE-83204007"
    }
  },
  "AGRIBANK/PGD TAN THANH (LANG SON)": {
    "msb": { "code": "20204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN PGD TAN THANH - LANG SON-20204014"
    }
  },
  "AGRIBANK/PGD TAN THINH": {
    "msb": { "code": "15204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN CHAN-15204004"
    }
  },
  "AGRIBANK/PGD TAN THUAN": {
    "msb": { "code": "79204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM SAI GON-79204026"
    }
  },
  "AGRIBANK/PGD TAN THUC": {
    "msb": { "code": "33204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN AN THI-33204011"
    }
  },
  "AGRIBANK/PGD TAN TIEN": {
    "msb": { "code": "66204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KRONG PAK-66204013"
    }
  },
  "AGRIBANK/PGD TAN TRAO": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD TAN TRUNG": {
    "msb": { "code": "83204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BEN TRE-83204001"
    }
  },
  "AGRIBANK/PGD TAN TRUONG": {
    "msb": { "code": "30204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CAM GIANG-30204004"
    }
  },
  "AGRIBANK/PGD TAO XUYEN": {
    "msb": { "code": "38204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THANH HOA-38204001"
    }
  },
  "AGRIBANK/PGD TAP SON": {
    "msb": { "code": "84204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRA CU-84204005"
    }
  },
  "AGRIBANK/PGD TAY BAC": {
    "msb": { "code": "79204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HOC MON-79204013"
    }
  },
  "AGRIBANK/PGD TAY COC": {
    "msb": { "code": "25204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DOAN HUNG-25204016"
    }
  },
  "AGRIBANK/PGD TAY HOA (PHU YEN)": {
    "msb": { "code": "54204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAY HOA-54204007"
    }
  },
  "AGRIBANK/PGD TAY HOA (QUAN 9)": {
    "msb": { "code": "79204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 9-79204012"
    }
  },
  "AGRIBANK/PGD TAY LOC": {
    "msb": { "code": "46204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC SONG HUONG-46204011"
    }
  },
  "AGRIBANK/PGD TAY SON (QUY NHON)": {
    "msb": { "code": "52204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP QUY NHON-52204002"
    }
  },
  "AGRIBANK/PGD THAC BA": {
    "msb": { "code": "15204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN BINH-15204005"
    }
  },
  "AGRIBANK/PGD THACH CHAU": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD THACH DA": {
    "msb": { "code": "26204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH PHUC-26204001"
    }
  },
  "AGRIBANK/PGD THACH KHE": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD THAI HOA": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD THAM THANH": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD THANG LOI (KON TUM)": {
    "msb": { "code": "62204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN KON TUM-PGD THANG LOI-62204010"
    }
  },
  "AGRIBANK/PGD THANG LONG (THAI BINH)": {
    "msb": { "code": "34204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HUNG-34204006"
    }
  },
  "AGRIBANK/PGD THANG THUONG": {
    "msb": { "code": "36204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGHIA HUNG-36204006"
    }
  },
  "AGRIBANK/PGD THANH AM": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PGD THANH BINH (BINH PHUOC)": {
    "msb": { "code": "70204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BU DOP-70204009"
    }
  },
  "AGRIBANK/PGD THANH BINH (DIEN BIEN PHU)": {
    "msb": { "code": "11204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH DIEN BIEN-11204001"
    }
  },
  "AGRIBANK/PGD THANH BINH (HAI DUONG)": {
    "msb": { "code": "30204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH HA-30204014"
    }
  },
  "AGRIBANK/PGD THANH BINH (HOC MON)": {
    "msb": { "code": "79204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HOC MON-79204013"
    }
  },
  "AGRIBANK/PGD THANH BINH (VINH LONG)": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD THANH CO": {
    "msb": { "code": "45204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN TX QUANG TRI-45204007"
    }
  },
  "AGRIBANK/PGD THANH CONG": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/PGD THANH DONG A": {
    "msb": { "code": "91204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KIEN GIANG-91204001"
    }
  },
  "AGRIBANK/PGD THANH DUC": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD THANH HA (NINH THUAN)": {
    "msb": { "code": "58204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN TP PHAN RANG-58204002"
    }
  },
  "AGRIBANK/PGD THANH HA (PHU THO)": {
    "msb": { "code": "25204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH BA-25204007"
    }
  },
  "AGRIBANK/PGD THANH HIA": {
    "msb": { "code": "60204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH THUAN-60204001"
    }
  },
  "AGRIBANK/PGD THANH HOA": {
    "msb": { "code": "38204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN TP THANH HOA-38204026"
    }
  },
  "AGRIBANK/PGD THANH HOA (HAU GIANG)": {
    "msb": { "code": "93204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAU GIANG-93204001"
    }
  },
  "AGRIBANK/PGD THANH LOC DAN": {
    "msb": { "code": "48204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH KHE DN-48204005"
    }
  },
  "AGRIBANK/PGD THANH MY (CAN THO)": {
    "msb": { "code": "92204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TP CAN THO-92204001"
    }
  },
  "AGRIBANK/PGD THANH MY (QUANG NAM)": {
    "msb": { "code": "49204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM GIANG-49204006"
    }
  },
  "AGRIBANK/PGD THANH NHAT": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/PGD THANH NIEN": {
    "msb": { "code": "79204034" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HUNG VUONG-HCM-79204034"
    }
  },
  "AGRIBANK/PGD THANH NINH": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD THANH PHU (BINH PHUOC)": {
    "msb": { "code": "70204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BINH LONG-70204016"
    }
  },
  "AGRIBANK/PGD THANH PHU (DONG NAI)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD THANH SON (NINH THUAN)": {
    "msb": { "code": "58204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN TP PHAN RANG-58204002"
    }
  },
  "AGRIBANK/PGD THANH UYEN": {
    "msb": { "code": "25204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM NONG - PHU THO-25204011"
    }
  },
  "AGRIBANK/PGD THANH XUAN NAM": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD THAO NGUYEN": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/PGD THAP MUOI": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/PGD THI NGHE": {
    "msb": { "code": "79204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH THANH-79204019"
    }
  },
  "AGRIBANK/PGD THI PHO": {
    "msb": { "code": "51204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MO DUC-51204007"
    }
  },
  "AGRIBANK/PGD THI TRAN CAT BA": {
    "msb": { "code": "31204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN CAT BA HP-31204003"
    }
  },
  "AGRIBANK/PGD THI TRAN DOI": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD THI TRAN GACH": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD THIEN CAM": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD THO AN": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD THO LOC": {
    "msb": { "code": "44204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BO TRACH-44204002"
    }
  },
  "AGRIBANK/PGD THO QUAN": {
    "msb": { "code": "48204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN SON TRA DN-48204007"
    }
  },
  "AGRIBANK/PGD THO XUONG": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD THO YEN": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD THONG NHAT (BINH PHUOC)": {
    "msb": { "code": "70204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BU DANG-70204008"
    }
  },
  "AGRIBANK/PGD THONG NHAT (DAKLAK)": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/PGD THONG NHAT (GIA LAI)": {
    "msb": { "code": "64204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH GIA LAI-64204001"
    }
  },
  "AGRIBANK/PGD THONG NHAT (KCN BIEN HOA)": {
    "msb": { "code": "75204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC DONG NAI-75204002"
    }
  },
  "AGRIBANK/PGD THU LO": {
    "msb": { "code": "51204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN TP QUANG NGAI-51204015"
    }
  },
  "AGRIBANK/PGD THU THUAN": {
    "msb": { "code": "46204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN CN THUA THIEN HUE-46204001"
    }
  },
  "AGRIBANK/PGD THUA LUU": {
    "msb": { "code": "46204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU LOC-46204008"
    }
  },
  "AGRIBANK/PGD THUAN BAC": {
    "msb": { "code": "58204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH HAI-58204004"
    }
  },
  "AGRIBANK/PGD THUAN KIEU": {
    "msb": { "code": "79204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN CHO LON-79204016"
    }
  },
  "AGRIBANK/PGD THUONG DINH": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD THUONG LAM": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD THUONG LY": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD THUY AN": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD THUY BAI": {
    "msb": { "code": "46204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN CN THUA THIEN HUE-46204001"
    }
  },
  "AGRIBANK/PGD THUY DUONG": {
    "msb": { "code": "46204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUONG THUY-46204007"
    }
  },
  "AGRIBANK/PGD THUY LOI": {
    "msb": { "code": "33204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN LU-33204005"
    }
  },
  "AGRIBANK/PGD THUY PHU": {
    "msb": { "code": "46204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUONG THUY-46204007"
    }
  },
  "AGRIBANK/PGD TIA": {
    "msb": { "code": "01204042" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THUONG TIN - HA TAY-01204042"
    }
  },
  "AGRIBANK/PGD TIEM TOM": {
    "msb": { "code": "83204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BA TRI-83204004"
    }
  },
  "AGRIBANK/PGD TIEN LUC": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD TIEN PHONG (BAC GIANG)": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD TIEN PHONG (HN)": {
    "msb": { "code": "01204044" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.BA VI - HA TAY-01204044"
    }
  },
  "AGRIBANK/PGD TIEN PHONG (VINH PHUC)": {
    "msb": { "code": "01204051" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN ME LINH-01204051"
    }
  },
  "AGRIBANK/PGD TIEN THUY": {
    "msb": { "code": "83204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-BEN TRE-83204007"
    }
  },
  "AGRIBANK/PGD TIEN TRUNG": {
    "msb": { "code": "30204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NAM SACH-30204002"
    }
  },
  "AGRIBANK/PGD TIEU DONG": {
    "msb": { "code": "35204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA NAM-35204001"
    }
  },
  "AGRIBANK/PGD TIN NGHIA": {
    "msb": { "code": "66204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NH NN VA PTNT CN TINH DAKLAK-66204001"
    }
  },
  "AGRIBANK/PGD TINH TUC": {
    "msb": { "code": "04204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CAO BANG-04204001"
    }
  },
  "AGRIBANK/PGD TO HIEN THANH": {
    "msb": { "code": "79204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 4-79204005"
    }
  },
  "AGRIBANK/PGD TON THAT DAM": {
    "msb": { "code": "79204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG TAM SAI GON-79204015"
    }
  },
  "AGRIBANK/PGD TRA CAU": {
    "msb": { "code": "51204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUC PHO-51204010"
    }
  },
  "AGRIBANK/PGD TRA CO": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/PGD TRACH TRU": {
    "msb": { "code": "51204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MO DUC-51204007"
    }
  },
  "AGRIBANK/PGD TRAI CAU": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD TRAI HUT": {
    "msb": { "code": "15204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN YEN-15204009"
    }
  },
  "AGRIBANK/PGD TRAI MAT": {
    "msb": { "code": "68204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAM-DONG",
      "branch": "NONG NGHIEP VA PTNT VN TP DA LAT-68204003"
    }
  },
  "AGRIBANK/PGD TRAM BONG": {
    "msb": { "code": "30204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIA LOC-30204006"
    }
  },
  "AGRIBANK/PGD TRAM THAN": {
    "msb": { "code": "25204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU NINH - PHU THO-25204006"
    }
  },
  "AGRIBANK/PGD TRAN CAI LAY": {
    "msb": { "code": "82204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX CAI LAY-82204002"
    }
  },
  "AGRIBANK/PGD TRAN DI AN": {
    "msb": { "code": "74204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN TX DI AN SONG THAN-74204011"
    }
  },
  "AGRIBANK/PGD TRAN HUNG DAO (BINH DINH)": {
    "msb": { "code": "52204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP QUY NHON-52204002"
    }
  },
  "AGRIBANK/PGD TRAN HUNG DAO (HN)": {
    "msb": { "code": "01204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HONG HA-01204018"
    }
  },
  "AGRIBANK/PGD TRAN HUNG DAO (NAM DINH)": {
    "msb": { "code": "36204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH NAM-36204014"
    }
  },
  "AGRIBANK/PGD TRAN HUNG DAO (PHU YEN)": {
    "msb": { "code": "54204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH PHO TUY HOA-54204002"
    }
  },
  "AGRIBANK/PGD TRAN HUNG DAO (QUANG NGAI)": {
    "msb": { "code": "51204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN TP QUANG NGAI-51204015"
    }
  },
  "AGRIBANK/PGD TRAN HUNGDAO": {
    "msb": { "code": "79204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SAI GON-79204023"
    }
  },
  "AGRIBANK/PGD TRAN KHAT CHAN": {
    "msb": { "code": "01204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HONG HA-01204018"
    }
  },
  "AGRIBANK/PGD TRAN NGUYEN NAN": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD TRAN QUAN KHAI": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD TRANG TU": {
    "msb": { "code": "79204052" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH PHU-79204052"
    }
  },
  "AGRIBANK/PGD TRI PHU": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD TRIEU DE": {
    "msb": { "code": "26204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAP THACH-26204005"
    }
  },
  "AGRIBANK/PGD TRUC CAT": {
    "msb": { "code": "36204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUC NINH-36204008"
    }
  },
  "AGRIBANK/PGD TRUNG HOA (DAKLAK)": {
    "msb": { "code": "66204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CU KUIN-66204003"
    }
  },
  "AGRIBANK/PGD TRUNG HOA (HN)": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA NOI-01204003"
    }
  },
  "AGRIBANK/PGD TRUNG MON": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD TRUNG NGHIA": {
    "msb": { "code": "25204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH THUY-25204013"
    }
  },
  "AGRIBANK/PGD TRUNG NHI": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD TRUNG TAM - HA TINH": {
    "msb": { "code": "42204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HA TINH-42204001"
    }
  },
  "AGRIBANK/PGD TRUNG VAN": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD TRUNG VUONG": {
    "msb": { "code": "77204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TP VUNG TAU-77204002"
    }
  },
  "AGRIBANK/PGD TRUOI": {
    "msb": { "code": "46204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU LOC-46204008"
    }
  },
  "AGRIBANK/PGD TRUONG DINH": {
    "msb": { "code": "01204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA THANH-01204032"
    }
  },
  "AGRIBANK/PGD TRUONG KINH TE DOI NGOAI": {
    "msb": { "code": "79204039" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM HOA-79204039"
    }
  },
  "AGRIBANK/PGD TRUONG SON - HAI PHONG": {
    "msb": { "code": "31204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN HAI PHONG-31204001"
    }
  },
  "AGRIBANK/PGD TRUONG XA": {
    "msb": { "code": "33204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIM DONG-33204008"
    }
  },
  "AGRIBANK/PGD TTAM TM": {
    "msb": { "code": "62204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK HA-62204003"
    }
  },
  "AGRIBANK/PGD TTAM TX SON LA": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/PGD TTRAN BA TRI": {
    "msb": { "code": "83204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BA TRI-83204004"
    }
  },
  "AGRIBANK/PGD TTRAN CHO LACH": {
    "msb": { "code": "83204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHO LACH-83204009"
    }
  },
  "AGRIBANK/PGD TTRAN DAK MIL": {
    "msb": { "code": "67204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAK MIL-67204006"
    }
  },
  "AGRIBANK/PGD TTRAN DIEN KHANH": {
    "msb": { "code": "56204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DIEN KHANH-56204008"
    }
  },
  "AGRIBANK/PGD TTRAN DONG TRIEU": {
    "msb": { "code": "22204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY QUANG NINH-22204003"
    }
  },
  "AGRIBANK/PGD TTRAN EA DRANG": {
    "msb": { "code": "66204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN EA H' LEO-66204030"
    }
  },
  "AGRIBANK/PGD TTRAN GIA RA": {
    "msb": { "code": "95204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIA RAI-95204006"
    }
  },
  "AGRIBANK/PGD TTRAN HUNG HA": {
    "msb": { "code": "34204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HUNG HA-34204011"
    }
  },
  "AGRIBANK/PGD TTRAN LONG THANH": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD TTRAN MO CAY": {
    "msb": { "code": "83204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN MO CAY BAC-83204012"
    }
  },
  "AGRIBANK/PGD TTRAN NINH HOA": {
    "msb": { "code": "56204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NINH HOA-56204005"
    }
  },
  "AGRIBANK/PGD TTRAN QUANG YEN": {
    "msb": { "code": "22204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TX QUANG YEN-22204004"
    }
  },
  "AGRIBANK/PGD TTRAN SOC SON (KIEN GIANG)": {
    "msb": { "code": "91204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KIEN GIANG-91204001"
    }
  },
  "AGRIBANK/PGD TTRAN TIEN HAI": {
    "msb": { "code": "34204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN HAI-34204005"
    }
  },
  "AGRIBANK/PGD TTRAN TRANG BANG": {
    "msb": { "code": "72204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN KCN TRANG BANG-72204004"
    }
  },
  "AGRIBANK/PGD TTRAN TU SON": {
    "msb": { "code": "27204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NINH II-27204003"
    }
  },
  "AGRIBANK/PGD TTRAN VINH DIEN": {
    "msb": { "code": "49204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN TX DIEN BAN-49204021"
    }
  },
  "AGRIBANK/PGD TTTM TAN CHAU": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/PGD TU AN": {
    "msb": { "code": "66204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN LAP - DAKLAK-66204019"
    }
  },
  "AGRIBANK/PGD TU BONG": {
    "msb": { "code": "56204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN NINH-56204006"
    }
  },
  "AGRIBANK/PGD TU DA": {
    "msb": { "code": "25204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU NINH - PHU THO-25204006"
    }
  },
  "AGRIBANK/PGD TU HO": {
    "msb": { "code": "33204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN MY-33204003"
    }
  },
  "AGRIBANK/PGD TU MOI": {
    "msb": { "code": "34204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUYNH PHU-34204007"
    }
  },
  "AGRIBANK/PGD TU SY": {
    "msb": { "code": "38204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NGA SON-38204029"
    }
  },
  "AGRIBANK/PGD TU TAN": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD TU XA": {
    "msb": { "code": "25204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAM THAO-25204005"
    }
  },
  "AGRIBANK/PGD TUAN DAO": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD TUC TRANH": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD TX BA RIA": {
    "msb": { "code": "77204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN BA RIA VUNG TAU-77204001"
    }
  },
  "AGRIBANK/PGD VAC": {
    "msb": { "code": "01204039" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.THANH OAI - HA TAY-01204039"
    }
  },
  "AGRIBANK/PGD VAM DINH": {
    "msb": { "code": "96204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CA MAU-96204001"
    }
  },
  "AGRIBANK/PGD VAM LANG": {
    "msb": { "code": "82204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GO CONG DONG-82204006"
    }
  },
  "AGRIBANK/PGD VAN AN": {
    "msb": { "code": "27204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN PHONG-27204008"
    }
  },
  "AGRIBANK/PGD VAN DU": {
    "msb": { "code": "38204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THACH THANH-38204030"
    }
  },
  "AGRIBANK/PGD VAN DUONG": {
    "msb": { "code": "27204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TP BAC NINH-27204002"
    }
  },
  "AGRIBANK/PGD VAN HANH": {
    "msb": { "code": "79204050" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HIEP PHUOC-79204050"
    }
  },
  "AGRIBANK/PGD VAN HIEN": {
    "msb": { "code": "40204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DO LUONG-40204014"
    }
  },
  "AGRIBANK/PGD VAN HOI": {
    "msb": { "code": "26204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM DUONG- VINH PHUC-26204006"
    }
  },
  "AGRIBANK/PGD VAN HUNG": {
    "msb": { "code": "56204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN NINH-56204006"
    }
  },
  "AGRIBANK/PGD VAN MIEU": {
    "msb": { "code": "01204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TP SON TAY-01204049"
    }
  },
  "AGRIBANK/PGD VAN PHUC": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD VAN THANG": {
    "msb": { "code": "01204044" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.BA VI - HA TAY-01204044"
    }
  },
  "AGRIBANK/PGD VAN TIEN": {
    "msb": { "code": "15204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRAN YEN-15204008"
    }
  },
  "AGRIBANK/PGD VAN TRI": {
    "msb": { "code": "01204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG ANH-01204015"
    }
  },
  "AGRIBANK/PGD VAN TUONG": {
    "msb": { "code": "51204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NGAI-51204001"
    }
  },
  "AGRIBANK/PGD VAN XUAN": {
    "msb": { "code": "01204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH TRI-01204004"
    }
  },
  "AGRIBANK/PGD VIEN DONG": {
    "msb": { "code": "79204051" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BEN THANH-79204051"
    }
  },
  "AGRIBANK/PGD VIET AN": {
    "msb": { "code": "49204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HIEP DUC-49204005"
    }
  },
  "AGRIBANK/PGD VIET LAP": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/PGD VINH BINH (AN GIANG)": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/PGD VINH BINH (BEN TRE)": {
    "msb": { "code": "83204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-BEN TRE-83204007"
    }
  },
  "AGRIBANK/PGD VINH CHAN": {
    "msb": { "code": "25204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA HOA-25204009"
    }
  },
  "AGRIBANK/PGD VINH KIM": {
    "msb": { "code": "82204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU THANH-TIEN GIANG-82204009"
    }
  },
  "AGRIBANK/PGD VINH QUANG": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD VINH THANH (TINH BEN TRE)": {
    "msb": { "code": "83204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHO LACH-83204009"
    }
  },
  "AGRIBANK/PGD VINH TRAI": {
    "msb": { "code": "20101001" },
    "techcombank": null
  },
  "AGRIBANK/PGD VINH TUY": {
    "msb": { "code": "02204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN BAC QUANG-02204008"
    }
  },
  "AGRIBANK/PGD VINH XUAN": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/PGD VINH YEN": {
    "msb": { "code": "26204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH YEN - VINH PHUC-26204010"
    }
  },
  "AGRIBANK/PGD VO CUONG": {
    "msb": { "code": "27204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TP BAC NINH-27204002"
    }
  },
  "AGRIBANK/PGD VO LAO": {
    "msb": { "code": "10204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN BAN-10204006"
    }
  },
  "AGRIBANK/PGD VO MIEU": {
    "msb": { "code": "25204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH SON-25204010"
    }
  },
  "AGRIBANK/PGD VO XU": {
    "msb": { "code": "60204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH THUAN-60204001"
    }
  },
  "AGRIBANK/PGD VONG THE": {
    "msb": { "code": "89204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH AN GIANG-89204001"
    }
  },
  "AGRIBANK/PGD VONG XUYEN": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD VU HOI": {
    "msb": { "code": "34204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU THU-34204004"
    }
  },
  "AGRIBANK/PGD VU LAM": {
    "msb": { "code": "17204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAC SON-17204009"
    }
  },
  "AGRIBANK/PGD VU QUY": {
    "msb": { "code": "34204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KIEN XUONG-34204010"
    }
  },
  "AGRIBANK/PGD VU TIEN": {
    "msb": { "code": "34204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU THU-34204004"
    }
  },
  "AGRIBANK/PGD VUC TUAN": {
    "msb": { "code": "15204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN CHAN-15204004"
    }
  },
  "AGRIBANK/PGD VUNG A": {
    "msb": { "code": "49204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DAI LOC-49204008"
    }
  },
  "AGRIBANK/PGD XA LONG HUU": {
    "msb": { "code": "84204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DUYEN HAI-84204007"
    }
  },
  "AGRIBANK/PGD XAM KHOE": {
    "msb": { "code": "17204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MAI CHAU-17204003"
    }
  },
  "AGRIBANK/PGD XUAN ANG": {
    "msb": { "code": "25204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN HA HOA-25204009"
    }
  },
  "AGRIBANK/PGD XUAN BAI": {
    "msb": { "code": "40204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DO LUONG-40204014"
    }
  },
  "AGRIBANK/PGD XUAN BINH": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD XUAN DAI": {
    "msb": { "code": "36204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUAN TRUONG-36204011"
    }
  },
  "AGRIBANK/PGD XUAN DINH (DONG NAI)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD XUAN DINH (HN)": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/PGD XUAN HOA": {
    "msb": { "code": "26204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN CN VINH PHUC II-26204002"
    }
  },
  "AGRIBANK/PGD XUAN KHANH": {
    "msb": { "code": "01204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TP SON TAY-01204049"
    }
  },
  "AGRIBANK/PGD XUAN KIEN": {
    "msb": { "code": "36204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUAN TRUONG-36204011"
    }
  },
  "AGRIBANK/PGD XUAN LAI": {
    "msb": { "code": "38204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THO XUAN-38204004"
    }
  },
  "AGRIBANK/PGD XUAN LAM": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/PGD XUAN LANH": {
    "msb": { "code": "54204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DONG HOA-54204006"
    }
  },
  "AGRIBANK/PGD XUAN LONG HAI": {
    "msb": { "code": "36204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN GIAO THUY-36204010"
    }
  },
  "AGRIBANK/PGD XUAN LUNG": {
    "msb": { "code": "25204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LAM THAO-25204005"
    }
  },
  "AGRIBANK/PGD XUAN QUE": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/PGD XUAN SON": {
    "msb": { "code": "77204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHAU DUC-77204007"
    }
  },
  "AGRIBANK/PGD XUAN TO": {
    "msb": { "code": "89204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TINH BIEN-89204009"
    }
  },
  "AGRIBANK/PGD XUAN VAN": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD XUAT HOA": {
    "msb": { "code": "06204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-KAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC CAN-06204001"
    }
  },
  "AGRIBANK/PGD YALY": {
    "msb": { "code": "64204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN CHU PAH-64204012"
    }
  },
  "AGRIBANK/PGD YEN BINH": {
    "msb": { "code": "37204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TP TAM DIEP-37204010"
    }
  },
  "AGRIBANK/PGD YEN CHINH": {
    "msb": { "code": "36204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN Y YEN-36204005"
    }
  },
  "AGRIBANK/PGD YEN HOA": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/PGD YEN KHE": {
    "msb": { "code": "25204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH BA-25204007"
    }
  },
  "AGRIBANK/PGD YEN LANG": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD YEN LY": {
    "msb": { "code": "40204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN DIEN CHAU-40204020"
    }
  },
  "AGRIBANK/PGD YEN NGHIA": {
    "msb": { "code": "01204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HA TAY-01204036"
    }
  },
  "AGRIBANK/PGD YEN NINH": {
    "msb": { "code": "36204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN Y YEN-36204005"
    }
  },
  "AGRIBANK/PGD YEN PHU": {
    "msb": { "code": "01204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN HONG HA-01204018"
    }
  },
  "AGRIBANK/PGD YEN TAM": {
    "msb": { "code": "38204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN DINH-38204005"
    }
  },
  "AGRIBANK/PGD YEN THANG": {
    "msb": { "code": "36204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN Y YEN-36204005"
    }
  },
  "AGRIBANK/PGD YEN THE": {
    "msb": { "code": "15204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN LUC YEN-15204006"
    }
  },
  "AGRIBANK/PGD YEN THONG": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PGD YEN VIEN": {
    "msb": { "code": "01204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN GIA LAM-01204014"
    }
  },
  "AGRIBANK/PHA LAI": {
    "msb": { "code": "30204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN PHA LAI-30204015"
    }
  },
  "AGRIBANK/PHAN CHU TRINH": {
    "msb": { "code": "66204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN PHAN CHU TRINH -DAKLAK-66204012"
    }
  },
  "AGRIBANK/PHAN DINH PHUNG": {
    "msb": { "code": "79204036" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHAN DINH PHUNG-79204036"
    }
  },
  "AGRIBANK/PHAN RI CUA": {
    "msb": { "code": "60204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN PHAN RI CUA-60204006"
    }
  },
  "AGRIBANK/PHO DUC CHINH": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/PHO YEN": {
    "msb": { "code": "19204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN TX PHO YEN-19204002"
    }
  },
  "AGRIBANK/PHONG DIEN (CAN THO)": {
    "msb": { "code": "92204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN PHONG DIEN-92204006"
    }
  },
  "AGRIBANK/PHONG DIEN (THUA THIEN - HUE)": {
    "msb": { "code": "46204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHONG DIEN-46204004"
    }
  },
  "AGRIBANK/PHONG THO": {
    "msb": { "code": "12204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHONG THO-12204004"
    }
  },
  "AGRIBANK/PHU BINH (HAI DUONG)": {
    "msb": { "code": "30204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH HAI DUONG-30204001"
    }
  },
  "AGRIBANK/PHU BINH (THAI NGUYEN)": {
    "msb": { "code": "19204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU BINH-19204007"
    }
  },
  "AGRIBANK/PHU CAT": {
    "msb": { "code": "52204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU CAT-52204006"
    }
  },
  "AGRIBANK/PHU CU": {
    "msb": { "code": "33204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU CU-33204009"
    }
  },
  "AGRIBANK/PHU GIAO": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH DUONG-74204001"
    }
  },
  "AGRIBANK/PHU HOA (PHU YEN)": {
    "msb": { "code": "54204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU HOA-54204005"
    }
  },
  "AGRIBANK/PHU LAM (HCM)": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/PHU LOC (HUE)": {
    "msb": { "code": "46204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU LOC-46204008"
    }
  },
  "AGRIBANK/PHU LUONG": {
    "msb": { "code": "19204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU LUONG-19204009"
    }
  },
  "AGRIBANK/PHU MY": {
    "msb": { "code": "52204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU MY-52204007"
    }
  },
  "AGRIBANK/PHU MY HUNG": {
    "msb": { "code": "79204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU MY HUNG-79204031"
    }
  },
  "AGRIBANK/PHU NINH (PHU THO)": {
    "msb": { "code": "25204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU NINH - PHU THO-25204006"
    }
  },
  "AGRIBANK/PHU NINH (QUANG NAM)": {
    "msb": { "code": "49204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU NINH - QUANG NAM-49204026"
    }
  },
  "AGRIBANK/PHU QUOC": {
    "msb": { "code": "91204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU QUOC-91204002"
    }
  },
  "AGRIBANK/PHU QUY": {
    "msb": { "code": "60204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU QUY-60204009"
    }
  },
  "AGRIBANK/PHU RIENG": {
    "msb": { "code": "70204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU RIENG-70204014"
    }
  },
  "AGRIBANK/PHU TAI (BINH DINH)": {
    "msb": { "code": "52204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN KCN PHU TAI-52204009"
    }
  },
  "AGRIBANK/PHU TAI (TP HO CHI MINH)": {
    "msb": { "code": "79204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU NHUAN-79204006"
    }
  },
  "AGRIBANK/PHU TAN (AN GIANG)": {
    "msb": { "code": "89204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU TAN- AN GIANG-89204004"
    }
  },
  "AGRIBANK/PHU TAN (CA MAU)": {
    "msb": { "code": "96204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU TAN - CA MAU-96204009"
    }
  },
  "AGRIBANK/PHU THO": {
    "msb": { "code": "25204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH PHU THO-25204001"
    }
  },
  "AGRIBANK/PHU VANG": {
    "msb": { "code": "46204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU VANG-46204009"
    }
  },
  "AGRIBANK/PHU XUYEN (HA TAY)": {
    "msb": { "code": "01204046" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN H.PHU XUYEN - HA TAY-01204046"
    }
  },
  "AGRIBANK/PHU XUYEN (THAI NGUYEN)": {
    "msb": { "code": "19204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI NGUYEN-19204001"
    }
  },
  "AGRIBANK/PHU YEN": {
    "msb": { "code": "54204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH PHU YEN-54204001"
    }
  },
  "AGRIBANK/PHU YEN (SON LA)": {
    "msb": { "code": "14204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU YEN-14204006"
    }
  },
  "AGRIBANK/PHUC HOA": {
    "msb": { "code": "04204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHUC HOA-04204011"
    }
  },
  "AGRIBANK/PHUC YEN": {
    "msb": { "code": "26204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN CN VINH PHUC II-26204002"
    }
  },
  "AGRIBANK/PHUNG HIEP": {
    "msb": { "code": "93204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHUNG HIEP-93204008"
    }
  },
  "AGRIBANK/PHUOC BINH": {
    "msb": { "code": "70204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN PHUOC BINH-70204015"
    }
  },
  "AGRIBANK/PHUOC KIEN": {
    "msb": { "code": "79204038" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHUOC KIEN-79204038"
    }
  },
  "AGRIBANK/PHUOC LONG (BAC LIEU)": {
    "msb": { "code": "95204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHUOC LONG- BAC LIEU-95204003"
    }
  },
  "AGRIBANK/PHUOC LONG (BINH PHUOC)": {
    "msb": { "code": "70204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHUOC LONG-BINH PHUOC-70204007"
    }
  },
  "AGRIBANK/PHUOC SON": {
    "msb": { "code": "49204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHUOC SON-49204017"
    }
  },
  "AGRIBANK/PHUONG LAM": {
    "msb": { "code": "17204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHUONG LAM-17204004"
    }
  },
  "AGRIBANK/PONG DRANG": {
    "msb": { "code": "66204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN PONG DRANG-66204008"
    }
  },
  "AGRIBANK/Q. BINH THUY": {
    "msb": { "code": "92204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN BINH THUY-92204008"
    }
  },
  "AGRIBANK/Q. OMON": {
    "msb": { "code": "92204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN QUAN O MON-92204003"
    }
  },
  "AGRIBANK/Q. THOT NOT": {
    "msb": { "code": "92204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN THOT NOT-92204004"
    }
  },
  "AGRIBANK/QUAN 11 (HCM)": {
    "msb": { "code": "79204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 11-79204003"
    }
  },
  "AGRIBANK/QUAN 3 (HCM)": {
    "msb": { "code": "79204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 3-79204009"
    }
  },
  "AGRIBANK/QUAN 4 (HCM)": {
    "msb": { "code": "79204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 4-79204005"
    }
  },
  "AGRIBANK/QUAN 5 (HCM)": {
    "msb": { "code": "79204032" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN QUAN 5-79204032"
    }
  },
  "AGRIBANK/QUAN 6 (HCM)": {
    "msb": { "code": "79204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 6-79204008"
    }
  },
  "AGRIBANK/QUAN 7 (HCM)": {
    "msb": { "code": "79204043" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 7-79204043"
    }
  },
  "AGRIBANK/QUAN 8 (HCM)": {
    "msb": { "code": "79204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 8-79204007"
    }
  },
  "AGRIBANK/QUAN 9 (HCM)": {
    "msb": { "code": "79204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN 9-79204012"
    }
  },
  "AGRIBANK/QUAN BA": {
    "msb": { "code": "02204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUAN BA-02204005"
    }
  },
  "AGRIBANK/QUAN HAI AN": {
    "msb": { "code": "31204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN QUAN HAI AN-31204015"
    }
  },
  "AGRIBANK/QUAN HOA": {
    "msb": { "code": "38204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUAN HOA-38204016"
    }
  },
  "AGRIBANK/QUAN I (HCM)": {
    "msb": { "code": "79204035" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN QUAN 1-79204035"
    }
  },
  "AGRIBANK/QUAN PHU NHUAN": {
    "msb": { "code": "79204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN PHU NHUAN-79204006"
    }
  },
  "AGRIBANK/QUANG BINH (HA GIANG)": {
    "msb": { "code": "02204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG BINH-02204011"
    }
  },
  "AGRIBANK/QUANG BINH (TINH QUANG BINH)": {
    "msb": { "code": "44204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG BINH-44204001"
    }
  },
  "AGRIBANK/QUANG DIEN": {
    "msb": { "code": "46204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG DIEN-46204006"
    }
  },
  "AGRIBANK/QUANG NAM": {
    "msb": { "code": "49204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NAM-49204001"
    }
  },
  "AGRIBANK/QUANG NGAI": {
    "msb": { "code": "51204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NGAI-51204001"
    }
  },
  "AGRIBANK/QUANG NINH (QUANG BINH)": {
    "msb": { "code": "44204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG NINH-44204004"
    }
  },
  "AGRIBANK/QUANG TRACH": {
    "msb": { "code": "44204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG TRACH-44204005"
    }
  },
  "AGRIBANK/QUANG TRI": {
    "msb": { "code": "45204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG TRI-45204001"
    }
  },
  "AGRIBANK/QUANG TRUNG (KON TUM)": {
    "msb": { "code": "62204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN CN QUANG TRUNG - KON TUM-62204006"
    }
  },
  "AGRIBANK/QUANG TRUNG (QUANG BINH)": {
    "msb": { "code": "44204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN QUANG TRUNG - Q.BINH-44204007"
    }
  },
  "AGRIBANK/QUANG UYEN": {
    "msb": { "code": "04204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUANG UYEN-04204009"
    }
  },
  "AGRIBANK/QUANG XUONG": {
    "msb": { "code": "38204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN NAM THANH HOA-38204010"
    }
  },
  "AGRIBANK/QUE PHONG": {
    "msb": { "code": "40204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUE PHONG-40204007"
    }
  },
  "AGRIBANK/QUE SON": {
    "msb": { "code": "49204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUE SON-49204012"
    }
  },
  "AGRIBANK/QUE VO": {
    "msb": { "code": "27204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUE VO-27204005"
    }
  },
  "AGRIBANK/QUY CHAU": {
    "msb": { "code": "40204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUY CHAU-40204018"
    }
  },
  "AGRIBANK/QUY HOP": {
    "msb": { "code": "40204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUY HOP-40204006"
    }
  },
  "AGRIBANK/QUY NHON": {
    "msb": { "code": "52204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP QUY NHON-52204002"
    }
  },
  "AGRIBANK/QUYET THANG": {
    "msb": { "code": "62204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KON-TUM",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH KON TUM-62204001"
    }
  },
  "AGRIBANK/QUYNH LUU": {
    "msb": { "code": "40204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUYNH LUU-40204004"
    }
  },
  "AGRIBANK/QUYNH NHAI": {
    "msb": { "code": "14204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUYNH NHAI-14204004"
    }
  },
  "AGRIBANK/QUYNH PHU": {
    "msb": { "code": "34204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN QUYNH PHU-34204007"
    }
  },
  "AGRIBANK/RACH SOI": {
    "msb": { "code": "91204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN RACH SOI-91204007"
    }
  },
  "AGRIBANK/SA HUYNH": {
    "msb": { "code": "51204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN CN SA HUYNH-51204012"
    }
  },
  "AGRIBANK/SAI GON": {
    "msb": { "code": "79204023" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SAI GON-79204023"
    }
  },
  "AGRIBANK/SAM SON": {
    "msb": { "code": "38204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN SAM SON-38204002"
    }
  },
  "AGRIBANK/SAO DO (HAI DUONG)": {
    "msb": { "code": "30204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN SAO DO-30204012"
    }
  },
  "AGRIBANK/SAPA": {
    "msb": { "code": "10204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SA PA-10204011"
    }
  },
  "AGRIBANK/SIN HO": {
    "msb": { "code": "12204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SIN HO-12204005"
    }
  },
  "AGRIBANK/SO GIAO DICH": {
    "msb": { "code": "01204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SO GIAO DICH-01204002"
    }
  },
  "AGRIBANK/SO HA": {
    "msb": { "code": "51204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SON HA-51204008"
    }
  },
  "AGRIBANK/SO SAO": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN SO SAO - BINH DUONG-74204004"
    }
  },
  "AGRIBANK/SOC SON": {
    "msb": { "code": "01204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN SOC SON-01204012"
    }
  },
  "AGRIBANK/SOC TRANG": {
    "msb": { "code": "94204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SOC TRANG-94204001"
    }
  },
  "AGRIBANK/SON DONG - BAC GIANG": {
    "msb": { "code": "24204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SON DONG-24204014"
    }
  },
  "AGRIBANK/SON DUONG": {
    "msb": { "code": "08204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SON DUONG-08204003"
    }
  },
  "AGRIBANK/SON HOA": {
    "msb": { "code": "54204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SON HOA-54204003"
    }
  },
  "AGRIBANK/SON LA": {
    "msb": { "code": "14204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH SON LA-14204001"
    }
  },
  "AGRIBANK/SON TINH": {
    "msb": { "code": "51204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SON TINH-51204009"
    }
  },
  "AGRIBANK/SON TRA": {
    "msb": { "code": "48204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN SON TRA DN-48204007"
    }
  },
  "AGRIBANK/SONG CAU (PHU YEN)": {
    "msb": { "code": "54204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN THI XA SONG CAU-54204008"
    }
  },
  "AGRIBANK/SONG CAU (THAI NGUYEN)": {
    "msb": { "code": "19204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN SONG CAU-19204008"
    }
  },
  "AGRIBANK/SONG CONG": {
    "msb": { "code": "19204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TP SONG CONG-19204005"
    }
  },
  "AGRIBANK/SONG DA": {
    "msb": { "code": "17204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SONG DA-17204013"
    }
  },
  "AGRIBANK/SONG DONG": {
    "msb": { "code": "24204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC GIANG-24204001"
    }
  },
  "AGRIBANK/SONG HINH": {
    "msb": { "code": "54204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SONG HINH-54204004"
    }
  },
  "AGRIBANK/SONG LO (VINH PHUC)": {
    "msb": { "code": "26204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN SONG LO VINH PHUC-26204012"
    }
  },
  "AGRIBANK/SONG MA": {
    "msb": { "code": "14204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN SONG MA-14204005"
    }
  },
  "AGRIBANK/SONG VAN": {
    "msb": { "code": "37204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN SONG VAN-37204008"
    }
  },
  "AGRIBANK/TAM BINH": {
    "msb": { "code": "86204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM BINH-86204003"
    }
  },
  "AGRIBANK/TAM DAN": {
    "msb": { "code": "49204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TAM DAN-49204014"
    }
  },
  "AGRIBANK/TAM DAO": {
    "msb": { "code": "26204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM DAO-26204007"
    }
  },
  "AGRIBANK/TAM DUONG (LAI CHAU)": {
    "msb": { "code": "12204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM DUONG-LAI CHAU-12204003"
    }
  },
  "AGRIBANK/TAM DUONG (VINH PHUC)": {
    "msb": { "code": "26204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM DUONG- VINH PHUC-26204006"
    }
  },
  "AGRIBANK/TAM NONG (DONG THAP)": {
    "msb": { "code": "87204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM NONG - DONG THAP-87204004"
    }
  },
  "AGRIBANK/TAM NONG (PHU THO)": {
    "msb": { "code": "25204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAM NONG - PHU THO-25204011"
    }
  },
  "AGRIBANK/TAM TRINH": {
    "msb": { "code": "01204033" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAM TRINH-01204033"
    }
  },
  "AGRIBANK/TAN AN (DAKLAK)": {
    "msb": { "code": "66204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT CN BAC DAK LAK-66204011"
    }
  },
  "AGRIBANK/TAN BIEN (DONG NAI)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/TAN BIEN (TAY NINH)": {
    "msb": { "code": "72204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN BIEN-72204009"
    }
  },
  "AGRIBANK/TAN BINH-HCM": {
    "msb": { "code": "79204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN BINH-79204020"
    }
  },
  "AGRIBANK/TAN CHAU (AN GIANG)": {
    "msb": { "code": "89204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX TAN CHAU-89204008"
    }
  },
  "AGRIBANK/TAN CHAU (TAY NINH)": {
    "msb": { "code": "72204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN CHAU-72204006"
    }
  },
  "AGRIBANK/TAN HIEP (DONG NAI)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN HIEP-75204005"
    }
  },
  "AGRIBANK/TAN HIEP (KIEN GIANG)": {
    "msb": { "code": "91204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN HIEP-91204018"
    }
  },
  "AGRIBANK/TAN HONG": {
    "msb": { "code": "87204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN HONG-87204003"
    }
  },
  "AGRIBANK/TAN HUNG (LONG AN)": {
    "msb": { "code": "80204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN HUNG-80204017"
    }
  },
  "AGRIBANK/TAN KY": {
    "msb": { "code": "40204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN KY-40204015"
    }
  },
  "AGRIBANK/TAN LAC": {
    "msb": { "code": "17204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN LAC-17204008"
    }
  },
  "AGRIBANK/TAN LAP": {
    "msb": { "code": "66204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN LAP - DAKLAK-66204019"
    }
  },
  "AGRIBANK/TAN PHU (DONG NAI)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/TAN PHU (HCM)": {
    "msb": { "code": "79204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN PHU-79204004"
    }
  },
  "AGRIBANK/TAN PHU DONG (TIEN GIANG)": {
    "msb": { "code": "82204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN PHU DONG-82204003"
    }
  },
  "AGRIBANK/TAN PHUOC (TIEN GIANG)": {
    "msb": { "code": "82204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN PHUOC-82204004"
    }
  },
  "AGRIBANK/TAN PHUOC KHANH": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN TAN PHUOC KHANH-74204005"
    }
  },
  "AGRIBANK/TAN SON (PHU THO)": {
    "msb": { "code": "25204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN SON-25204008"
    }
  },
  "AGRIBANK/TAN THANH (BA RIA VUNG TAU)": {
    "msb": { "code": "77204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN THI XA PHU MY-BA RIA V.TAU-77204004"
    }
  },
  "AGRIBANK/TAN THANH (BINH PHUOC)": {
    "msb": { "code": "70204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN TAN THANH-70204002"
    }
  },
  "AGRIBANK/TAN THANH (LONG AN)": {
    "msb": { "code": "80204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN THANH- LONG AN-80204015"
    }
  },
  "AGRIBANK/TAN TRU": {
    "msb": { "code": "80204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN TRU-80204011"
    }
  },
  "AGRIBANK/TAN UYEN (BINH DUONG)": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN TAN UYEN-74204008"
    }
  },
  "AGRIBANK/TAN UYEN (LAI CHAU)": {
    "msb": { "code": "12204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN UYEN-12204008"
    }
  },
  "AGRIBANK/TAN YEN": {
    "msb": { "code": "24204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN YEN-24204004"
    }
  },
  "AGRIBANK/TANH LINH": {
    "msb": { "code": "60204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TANH LINH-60204005"
    }
  },
  "AGRIBANK/TAY DO": {
    "msb": { "code": "01204031" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY DO-01204031"
    }
  },
  "AGRIBANK/TAY GIANG": {
    "msb": { "code": "49204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAY GIANG-49204007"
    }
  },
  "AGRIBANK/TAY HA NOI": {
    "msb": { "code": "01204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HA NOI-01204007"
    }
  },
  "AGRIBANK/TAY HO": {
    "msb": { "code": "01204025" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HO-01204025"
    }
  },
  "AGRIBANK/TAY HOA (PHU YEN)": {
    "msb": { "code": "54204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAY HOA-54204007"
    }
  },
  "AGRIBANK/TAY NINH": {
    "msb": { "code": "72204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TAY-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TAY NINH-72204001"
    }
  },
  "AGRIBANK/TAY QUANG NINH": {
    "msb": { "code": "22204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY QUANG NINH-22204003"
    }
  },
  "AGRIBANK/TAY SAI GON(QTRUNG)": {
    "msb": { "code": "79204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY SAI GON-79204002"
    }
  },
  "AGRIBANK/TAY SON (BINH DINH)": {
    "msb": { "code": "52204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAY SON - BINH DINH-52204005"
    }
  },
  "AGRIBANK/TAY SON (HA TINH)": {
    "msb": { "code": "42204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAY SON- HA TINH-42204012"
    }
  },
  "AGRIBANK/TAY SON (THANG LONG)": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/THACH AN": {
    "msb": { "code": "04204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THACH AN-04204008"
    }
  },
  "AGRIBANK/THACH HA": {
    "msb": { "code": "42204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THACH HA-42204014"
    }
  },
  "AGRIBANK/THACH THANH": {
    "msb": { "code": "38204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THACH THANH-38204030"
    }
  },
  "AGRIBANK/THAI BINH": {
    "msb": { "code": "34204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THAI BINH-34204001"
    }
  },
  "AGRIBANK/THAI THUY": {
    "msb": { "code": "34204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THAI THUY-34204003"
    }
  },
  "AGRIBANK/THAN UYEN": {
    "msb": { "code": "12204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THAN UYEN-12204007"
    }
  },
  "AGRIBANK/THANG BINH": {
    "msb": { "code": "49204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANG BINH-49204018"
    }
  },
  "AGRIBANK/THANG LONG (HA NOI)": {
    "msb": { "code": "01204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANG LONG-01204011"
    }
  },
  "AGRIBANK/THANH BA": {
    "msb": { "code": "25204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH BA-25204007"
    }
  },
  "AGRIBANK/THANH BINH (DONG THAP)": {
    "msb": { "code": "87204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH BINH-87204009"
    }
  },
  "AGRIBANK/THANH CHUONG": {
    "msb": { "code": "40204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH CHUONG-40204011"
    }
  },
  "AGRIBANK/THANH DO (TAY CHO LON)": {
    "msb": { "code": "79204040" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH DO-79204040"
    }
  },
  "AGRIBANK/THANH DONG (HAI DUONG)": {
    "msb": { "code": "30204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH DONG-30204013"
    }
  },
  "AGRIBANK/THANH HA (HAI DUONG)": {
    "msb": { "code": "30204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH HA-30204014"
    }
  },
  "AGRIBANK/THANH HOA (TINH LONG AN)": {
    "msb": { "code": "80204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH HOA-80204016"
    }
  },
  "AGRIBANK/THANH HOA (TINH THANH HOA)": {
    "msb": { "code": "38204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH THANH HOA-38204001"
    }
  },
  "AGRIBANK/THANH KHE (DA NANG)": {
    "msb": { "code": "48204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH KHE DN-48204005"
    }
  },
  "AGRIBANK/THANH KHE (QUANG BINH)": {
    "msb": { "code": "44204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG BINH-44204001"
    }
  },
  "AGRIBANK/THANH LIEM": {
    "msb": { "code": "35204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH LIEM-35204003"
    }
  },
  "AGRIBANK/THANH MIEN": {
    "msb": { "code": "30204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH MIEN-30204010"
    }
  },
  "AGRIBANK/THANH MIEU": {
    "msb": { "code": "25204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH MIEU-25204015"
    }
  },
  "AGRIBANK/THANH NAM": {
    "msb": { "code": "36204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH NAM-36204014"
    }
  },
  "AGRIBANK/THANH PHO DA NANG": {
    "msb": { "code": "48204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN CN DA NANG-48204001"
    }
  },
  "AGRIBANK/THANH PHU (BEN TRE)": {
    "msb": { "code": "83204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH PHU-83204008"
    }
  },
  "AGRIBANK/THANH PHU (SOC TRANG)": {
    "msb": { "code": "94204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH PHU-94204012"
    }
  },
  "AGRIBANK/THANH SEN": {
    "msb": { "code": "42204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN THANH SEN - HA TINH-42204016"
    }
  },
  "AGRIBANK/THANH SON (PHU THO)": {
    "msb": { "code": "25204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH SON-25204010"
    }
  },
  "AGRIBANK/THANH THUY (HA GIANG)": {
    "msb": { "code": "02204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH THUY-02204009"
    }
  },
  "AGRIBANK/THANH THUY (PHU THO)": {
    "msb": { "code": "25204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THANH THUY-25204013"
    }
  },
  "AGRIBANK/THANH TRI (HA NOI)": {
    "msb": { "code": "01204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH TRI-01204004"
    }
  },
  "AGRIBANK/THANH TRI (SOC TRANG)": {
    "msb": { "code": "94204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN H.THANH TRI-SOC TRANG-94204004"
    }
  },
  "AGRIBANK/THAP CHAM": {
    "msb": { "code": "58204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN THAP CHAM-58204006"
    }
  },
  "AGRIBANK/THAP MUOI": {
    "msb": { "code": "87204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THAP MUOI-87204011"
    }
  },
  "AGRIBANK/THI TRAN BO HA": {
    "msb": { "code": "24204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN BO HA-24204008"
    }
  },
  "AGRIBANK/THI XA QUANG YEN (QUANG NINH)": {
    "msb": { "code": "22204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TX QUANG YEN-22204004"
    }
  },
  "AGRIBANK/THI XA SON TAY": {
    "msb": { "code": "01204049" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TP SON TAY-01204049"
    }
  },
  "AGRIBANK/THIEU HOA": {
    "msb": { "code": "38204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN THIEU HOA-38204018"
    }
  },
  "AGRIBANK/THINH LONG": {
    "msb": { "code": "36204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THINH LONG-36204007"
    }
  },
  "AGRIBANK/THO TANG": {
    "msb": { "code": "26204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN CN THO TANG-26204009"
    }
  },
  "AGRIBANK/THO XUAN": {
    "msb": { "code": "38204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THO XUAN-38204004"
    }
  },
  "AGRIBANK/THOAI SON": {
    "msb": { "code": "89204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THOAI SON-89204002"
    }
  },
  "AGRIBANK/THOI BINH (CA MAU)": {
    "msb": { "code": "96204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THOI BINH-96204003"
    }
  },
  "AGRIBANK/THOI LAI (CAN THO)": {
    "msb": { "code": "92204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN THOI LAI-92204007"
    }
  },
  "AGRIBANK/THONG NHAT (DONG NAI)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/THONG NONG": {
    "msb": { "code": "04204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THONG NONG-04204007"
    }
  },
  "AGRIBANK/THU DAU MOT": {
    "msb": { "code": "74204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN TX THU DAU MOT-74204009"
    }
  },
  "AGRIBANK/THU DO (BUI THI XUAN)": {
    "msb": { "code": "01204030" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DO-01204030"
    }
  },
  "AGRIBANK/THU DUC": {
    "msb": { "code": "79204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN THU DUC-79204024"
    }
  },
  "AGRIBANK/THU THUA": {
    "msb": { "code": "80204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THU THUA-80204005"
    }
  },
  "AGRIBANK/THUAN AN": {
    "msb": { "code": "74204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN TX THUAN AN SONG THAN-74204010"
    }
  },
  "AGRIBANK/THUAN CHAU": {
    "msb": { "code": "14204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THUAN CHAU-14204003"
    }
  },
  "AGRIBANK/THUAN THANH": {
    "msb": { "code": "27204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THUAN THANH-27204006"
    }
  },
  "AGRIBANK/THUONG XUAN": {
    "msb": { "code": "38204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THUONG XUAN-38204007"
    }
  },
  "AGRIBANK/THUY NGUYEN": {
    "msb": { "code": "31204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN THUY NGUYEN HP-31204009"
    }
  },
  "AGRIBANK/TIEN DU": {
    "msb": { "code": "27204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN DU BAC NINH II-27204010"
    }
  },
  "AGRIBANK/TIEN GIANG": {
    "msb": { "code": "82204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TIEN GIANG-82204001"
    }
  },
  "AGRIBANK/TIEN HAI": {
    "msb": { "code": "34204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN HAI-34204005"
    }
  },
  "AGRIBANK/TIEN LANG": {
    "msb": { "code": "31204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TIEN LANG HP-31204011"
    }
  },
  "AGRIBANK/TIEN LU": {
    "msb": { "code": "33204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN LU-33204005"
    }
  },
  "AGRIBANK/TIEN PHUOC": {
    "msb": { "code": "49204024" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN PHUOC-49204024"
    }
  },
  "AGRIBANK/TIEN YEN": {
    "msb": { "code": "22204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEN YEN-22204006"
    }
  },
  "AGRIBANK/TIEU CAN": {
    "msb": { "code": "84204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TIEU CAN-84204004"
    }
  },
  "AGRIBANK/TINH BAC NINH": {
    "msb": { "code": "27204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BAC NINH-27204001"
    }
  },
  "AGRIBANK/TINH BIEN": {
    "msb": { "code": "89204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TINH BIEN-89204009"
    }
  },
  "AGRIBANK/TINH CAO BANG": {
    "msb": { "code": "04204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH CAO BANG-04204001"
    }
  },
  "AGRIBANK/TINH GIA": {
    "msb": { "code": "38204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TINH GIA-38204015"
    }
  },
  "AGRIBANK/TINH LANG SON": {
    "msb": { "code": "20204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH LANG SON-20204001"
    }
  },
  "AGRIBANK/TINH QUANG NINH": {
    "msb": { "code": "22204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG NINH-22204001"
    }
  },
  "AGRIBANK/TINH YEN BAI": {
    "msb": { "code": "15204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH YEN BAI-15204001"
    }
  },
  "AGRIBANK/TP BAC GIANG": {
    "msb": { "code": "24204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TP BAC GIANG-24204006"
    }
  },
  "AGRIBANK/TP BAC NINH": {
    "msb": { "code": "27204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TP BAC NINH-27204002"
    }
  },
  "AGRIBANK/TP BAN ME THUOC": {
    "msb": { "code": "66204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN TP BUON MA THUOT-66204020"
    }
  },
  "AGRIBANK/TP CA MAU": {
    "msb": { "code": "96204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN TP CA MAU-96204005"
    }
  },
  "AGRIBANK/TP CAN THO": {
    "msb": { "code": "92204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TP CAN THO-92204001"
    }
  },
  "AGRIBANK/TP CAO BANG": {
    "msb": { "code": "04204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN TP CAO BANG-04204013"
    }
  },
  "AGRIBANK/TP CAO LANH": {
    "msb": { "code": "87204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN TP CAO LANH-87204005"
    }
  },
  "AGRIBANK/TP DIEN BIEN PHU": {
    "msb": { "code": "11204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN TP DIEN BIEN PHU-11204004"
    }
  },
  "AGRIBANK/TP HA LONG": {
    "msb": { "code": "22204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TP HA LONG-22204011"
    }
  },
  "AGRIBANK/TP HA TINH": {
    "msb": { "code": "42204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN TP HA TINH-42204002"
    }
  },
  "AGRIBANK/TP HAI DUONG": {
    "msb": { "code": "30204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO HAI DUONG-30204009"
    }
  },
  "AGRIBANK/TP HO CHI MINH": {
    "msb": { "code": "79204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN HCM-79204001"
    }
  },
  "AGRIBANK/TP HUNG YEN": {
    "msb": { "code": "33204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN TP HUNG YEN-33204012"
    }
  },
  "AGRIBANK/TP LAI CHAU": {
    "msb": { "code": "12204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN TP LAI CHAU-12204002"
    }
  },
  "AGRIBANK/TP LANG SON": {
    "msb": { "code": "20204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN TP LANG SON-20204006"
    }
  },
  "AGRIBANK/TP LAO CAI": {
    "msb": { "code": "10204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN TP LAO CAI-10204009"
    }
  },
  "AGRIBANK/TP LONG XUYEN - AN GIANG": {
    "msb": { "code": "89204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TP LONG XUYEN-89204006"
    }
  },
  "AGRIBANK/TP MY THO": {
    "msb": { "code": "82204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TP MY THO-82204005"
    }
  },
  "AGRIBANK/TP NAM DINH": {
    "msb": { "code": "36204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NAM DINH-36204015"
    }
  },
  "AGRIBANK/TP NHA TRANG": {
    "msb": { "code": "56204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN TP NHA TRANG-56204002"
    }
  },
  "AGRIBANK/TP NINH BINH": {
    "msb": { "code": "37204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TP NINH BINH-37204009"
    }
  },
  "AGRIBANK/TP PHAN RANG": {
    "msb": { "code": "58204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN TP PHAN RANG-58204002"
    }
  },
  "AGRIBANK/TP PHAN THIET": {
    "msb": { "code": "60204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN TP PHAN THIET-60204015"
    }
  },
  "AGRIBANK/TP PHU LY - HA NAM": {
    "msb": { "code": "35204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN TP PHU LY-HA NAM-35204006"
    }
  },
  "AGRIBANK/TP PLEIKU": {
    "msb": { "code": "64204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN TP PLEIKU - GIA LAI-64204016"
    }
  },
  "AGRIBANK/TP QUANG BINH": {
    "msb": { "code": "44204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH QUANG BINH-44204001"
    }
  },
  "AGRIBANK/TP QUANG NGAI": {
    "msb": { "code": "51204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN TP QUANG NGAI-51204015"
    }
  },
  "AGRIBANK/TP SOC TRANG": {
    "msb": { "code": "94204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN TP SOC TRANG-94204002"
    }
  },
  "AGRIBANK/TP SON LA": {
    "msb": { "code": "14204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN TP SON LA-14204008"
    }
  },
  "AGRIBANK/TP TAM KY": {
    "msb": { "code": "49204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN TP TAM KY - QUANG NAM-49204020"
    }
  },
  "AGRIBANK/TP THAI BINH": {
    "msb": { "code": "34204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TP THAI BINH-34204002"
    }
  },
  "AGRIBANK/TP THAI NGUYEN": {
    "msb": { "code": "19204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN TP THAI NGUYEN-19204011"
    }
  },
  "AGRIBANK/TP THANH HOA": {
    "msb": { "code": "38204026" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN TP THANH HOA-38204026"
    }
  },
  "AGRIBANK/TP TUY HOA": {
    "msb": { "code": "54204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN THANH PHO TUY HOA-54204002"
    }
  },
  "AGRIBANK/TP VINH": {
    "msb": { "code": "40204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH - NGHE AN-40204002"
    }
  },
  "AGRIBANK/TP VUNG TAU": {
    "msb": { "code": "77204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN CN TP VUNG TAU-77204002"
    }
  },
  "AGRIBANK/TP YEN BAI": {
    "msb": { "code": "15204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN TP YEN BAI-15204002"
    }
  },
  "AGRIBANK/TP YEN BAI II": {
    "msb": { "code": "15204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN THANH PHO YEN BAI II-15204003"
    }
  },
  "AGRIBANK/TRA BA": {
    "msb": { "code": "64204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRA BA - GIA LAI-64204020"
    }
  },
  "AGRIBANK/TRA BONG": {
    "msb": { "code": "51204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRA BONG-51204011"
    }
  },
  "AGRIBANK/TRA CU": {
    "msb": { "code": "84204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRA CU-84204005"
    }
  },
  "AGRIBANK/TRA LINH": {
    "msb": { "code": "04204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRA LINH-04204010"
    }
  },
  "AGRIBANK/TRA ON": {
    "msb": { "code": "86204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRA ON-86204010"
    }
  },
  "AGRIBANK/TRA VINH": {
    "msb": { "code": "84204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TRA VINH-84204001"
    }
  },
  "AGRIBANK/TRAM TAU": {
    "msb": { "code": "15204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRAM TAU-15204007"
    }
  },
  "AGRIBANK/TRAN DE": {
    "msb": { "code": "94204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TRAN DE-94204013"
    }
  },
  "AGRIBANK/TRAN HUNG DAO (QUANG BINH)": {
    "msb": { "code": "44204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TRAN HUNG DAO-Q.BINH-44204006"
    }
  },
  "AGRIBANK/TRAN PHU - BINH THUAN": {
    "msb": { "code": "60204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH BINH THUAN-60204001"
    }
  },
  "AGRIBANK/TRAN PHU - HAI PHONG": {
    "msb": { "code": "31204016" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TRAN PHU-31204016"
    }
  },
  "AGRIBANK/TRAN VAN THOI (CA MAU)": {
    "msb": { "code": "96204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRAN VAN THOI-96204007"
    }
  },
  "AGRIBANK/TRAN YEN": {
    "msb": { "code": "15204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRAN YEN-15204008"
    }
  },
  "AGRIBANK/TRANG AN (LANG THUONG)": {
    "msb": { "code": "01204029" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRANG AN-01204029"
    }
  },
  "AGRIBANK/TRANG BOM": {
    "msb": { "code": "75204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN H.TRANG BOM BAC DONG NAI-75204009"
    }
  },
  "AGRIBANK/TRANG DINH": {
    "msb": { "code": "20204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRANG DINH-20204003"
    }
  },
  "AGRIBANK/TRANG TIEN": {
    "msb": { "code": "01204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRANG TIEN-01204288"
    }
  },
  "AGRIBANK/TRI TON": {
    "msb": { "code": "89204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "AN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRI TON-89204005"
    }
  },
  "AGRIBANK/TRIEU SON": {
    "msb": { "code": "38204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRIEU SON-38204008"
    }
  },
  "AGRIBANK/TRUC NINH": {
    "msb": { "code": "36204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUC NINH-36204008"
    }
  },
  "AGRIBANK/TRUNG KHANH": {
    "msb": { "code": "04204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAO-BANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TRUNG KHANH-04204006"
    }
  },
  "AGRIBANK/TRUNG YEN": {
    "msb": { "code": "01204027" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUNG YEN-01204027"
    }
  },
  "AGRIBANK/TRUONG AN": {
    "msb": { "code": "46204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THUATHIEN-HUE",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUONG AN - HUE-46204003"
    }
  },
  "AGRIBANK/TRUONG CHINH": {
    "msb": { "code": "01204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TAY HA NOI-01204007"
    }
  },
  "AGRIBANK/TRUONG SON - HCM": {
    "msb": { "code": "79204048" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUONG SON-79204048"
    }
  },
  "AGRIBANK/TRUONG XUAN": {
    "msb": { "code": "49204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN TRUONG XUAN-49204009"
    }
  },
  "AGRIBANK/TU KY": {
    "msb": { "code": "30204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TU KY-30204007"
    }
  },
  "AGRIBANK/TU LIEM": {
    "msb": { "code": "01204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN TU LIEM-01204005"
    }
  },
  "AGRIBANK/TU NGHIA": {
    "msb": { "code": "51204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NGAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TU NGHIA-51204006"
    }
  },
  "AGRIBANK/TU SON": {
    "msb": { "code": "27204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN CN BAC NINH II-27204003"
    }
  },
  "AGRIBANK/TUA CHUA": {
    "msb": { "code": "11204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUA CHUA-11204003"
    }
  },
  "AGRIBANK/TUAN GIAO": {
    "msb": { "code": "11204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DIEN-BIEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUAN GIAO-11204005"
    }
  },
  "AGRIBANK/TUONG DUONG": {
    "msb": { "code": "40204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUONG DUONG-40204017"
    }
  },
  "AGRIBANK/TUY AN": {
    "msb": { "code": "54204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUY AN-54204009"
    }
  },
  "AGRIBANK/TUY PHONG": {
    "msb": { "code": "60204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-THUAN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUY PHONG-60204003"
    }
  },
  "AGRIBANK/TUY PHUOC": {
    "msb": { "code": "52204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUY PHUOC-52204003"
    }
  },
  "AGRIBANK/TUYEN HOA": {
    "msb": { "code": "44204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TUYEN HOA-44204009"
    }
  },
  "AGRIBANK/TUYEN QUANG": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/TX AN KHE": {
    "msb": { "code": "64204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN TX AN KHE - GIA LAI-64204017"
    }
  },
  "AGRIBANK/TX BAC LIEU": {
    "msb": { "code": "95204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN CN TP BAC LIEU-95204002"
    }
  },
  "AGRIBANK/TX BEN TRE": {
    "msb": { "code": "83204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BEN-TRE",
      "branch": "NONG NGHIEP VA PTNT VN TP BEN TRE-83204002"
    }
  },
  "AGRIBANK/TX CAM PHA": {
    "msb": { "code": "22204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TX CAM PHA-22204012"
    }
  },
  "AGRIBANK/TX DONG HA": {
    "msb": { "code": "45204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN TP DONG HA-45204002"
    }
  },
  "AGRIBANK/TX DONG XOAI": {
    "msb": { "code": "70204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN TX DONG XOAI-70204012"
    }
  },
  "AGRIBANK/TX GIA NGHIA": {
    "msb": { "code": "67204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-NONG",
      "branch": "NONG NGHIEP VA PTNT VN TX GIA NGHIA-67204004"
    }
  },
  "AGRIBANK/TX GO CONG": {
    "msb": { "code": "82204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX GO CONG-82204011"
    }
  },
  "AGRIBANK/TX HA TIEN": {
    "msb": { "code": "91204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX HA TIEN-91204006"
    }
  },
  "AGRIBANK/TX HONG LINH": {
    "msb": { "code": "42204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN THI XA HONG LINH-42204008"
    }
  },
  "AGRIBANK/TX KIEN TUONG (LONG AN)": {
    "msb": { "code": "80204020" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN CN TX KIEN TUONG-80204020"
    }
  },
  "AGRIBANK/TX LONG KHANH": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN THI XA LONG KHANH-75204008"
    }
  },
  "AGRIBANK/TX NGA BAY": {
    "msb": { "code": "93204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN TX NGA BAY-93204003"
    }
  },
  "AGRIBANK/TX PHU THO": {
    "msb": { "code": "25204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN TX PHU THO-25204004"
    }
  },
  "AGRIBANK/TX SA DEC": {
    "msb": { "code": "87204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-THAP",
      "branch": "NONG NGHIEP VA PTNT VN TP SA DEC-87204012"
    }
  },
  "AGRIBANK/TX TAM DIEP": {
    "msb": { "code": "37204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN TP TAM DIEP-37204010"
    }
  },
  "AGRIBANK/TX TAN AN (LONG AN)": {
    "msb": { "code": "80204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN THI XA TAN AN-80204002"
    }
  },
  "AGRIBANK/TX THAI HOA (NGHIA BINH)": {
    "msb": { "code": "40204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THAI HOA-40204019"
    }
  },
  "AGRIBANK/TX TRA VINH": {
    "msb": { "code": "84204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TRA-VINH",
      "branch": "NONG NGHIEP VA PTNT VN TP TRA VINH-84204010"
    }
  },
  "AGRIBANK/TX TUYEN QUANG": {
    "msb": { "code": "08204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN TP TUYEN QUANG-08204006"
    }
  },
  "AGRIBANK/TX UONG BI": {
    "msb": { "code": "22204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN TX UONG BI-22204010"
    }
  },
  "AGRIBANK/TX VINH LONG": {
    "msb": { "code": "86204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN TP VINH LONG-86204009"
    }
  },
  "AGRIBANK/U MINH": {
    "msb": { "code": "96204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CA-MAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN U MINH-96204010"
    }
  },
  "AGRIBANK/VAM LANG": {
    "msb": { "code": "31204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN VAM LANG-31204021"
    }
  },
  "AGRIBANK/VAN BAN": {
    "msb": { "code": "10204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAO-CAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN BAN-10204006"
    }
  },
  "AGRIBANK/VAN CANH": {
    "msb": { "code": "52204013" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN CANH-52204013"
    }
  },
  "AGRIBANK/VAN CHAN": {
    "msb": { "code": "15204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN CHAN-15204004"
    }
  },
  "AGRIBANK/VAN CO": {
    "msb": { "code": "25204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN VAN CO-25204003"
    }
  },
  "AGRIBANK/VAN DONG": {
    "msb": { "code": "22204015" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN DON-22204015"
    }
  },
  "AGRIBANK/VAN GIANG": {
    "msb": { "code": "33204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN GIANG-33204004"
    }
  },
  "AGRIBANK/VAN LAM": {
    "msb": { "code": "33204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN VAN LAM-33204006"
    }
  },
  "AGRIBANK/VAN LANG": {
    "msb": { "code": "20204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN LANG-20204002"
    }
  },
  "AGRIBANK/VAN NINH": {
    "msb": { "code": "56204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN NINH-56204006"
    }
  },
  "AGRIBANK/VAN QUAN (LANG SON)": {
    "msb": { "code": "20204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN QUAN-20204011"
    }
  },
  "AGRIBANK/VAN QUANG": {
    "msb": { "code": "20204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LANG-SON",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN QUAN-20204011"
    }
  },
  "AGRIBANK/VAN YEN": {
    "msb": { "code": "15204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VAN YEN-15204009"
    }
  },
  "AGRIBANK/VI THUY": {
    "msb": { "code": "93204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAU-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VI THUY-93204005"
    }
  },
  "AGRIBANK/VI XUYEN": {
    "msb": { "code": "02204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VI XUYEN-02204012"
    }
  },
  "AGRIBANK/VIET YEN": {
    "msb": { "code": "24204002" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VIET YEN-24204002"
    }
  },
  "AGRIBANK/VINH BAO": {
    "msb": { "code": "31204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HAI-PHONG",
      "branch": "NONG NGHIEP VA PTNT VN CN VINH BAO HP-31204012"
    }
  },
  "AGRIBANK/VINH CHAU": {
    "msb": { "code": "94204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SOC-TRANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH CHAU-94204010"
    }
  },
  "AGRIBANK/VINH CUU": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/VINH HANH": {
    "msb": { "code": "92204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN CN TP CAN THO-92204001"
    }
  },
  "AGRIBANK/VINH HIEP": {
    "msb": { "code": "56204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN VINH HIEP-56204004"
    }
  },
  "AGRIBANK/VINH HUNG": {
    "msb": { "code": "80204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH HUNG-80204018"
    }
  },
  "AGRIBANK/VINH LAC": {
    "msb": { "code": "91204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN VINH LAC-91204008"
    }
  },
  "AGRIBANK/VINH LINH": {
    "msb": { "code": "45204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "QUANG-TRI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH LINH-45204010"
    }
  },
  "AGRIBANK/VINH LOC": {
    "msb": { "code": "38204014" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH LOC-38204014"
    }
  },
  "AGRIBANK/VINH LOI": {
    "msb": { "code": "95204007" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-LIEU",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN VINH LOI-95204007"
    }
  },
  "AGRIBANK/VINH LONG": {
    "msb": { "code": "86204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH LONG-86204001"
    }
  },
  "AGRIBANK/VINH PHUC": {
    "msb": { "code": "26204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH VINH PHUC-26204001"
    }
  },
  "AGRIBANK/VINH THANH (CAN THO)": {
    "msb": { "code": "92204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH THANH - CAN THO-92204005"
    }
  },
  "AGRIBANK/VINH THANH (TINH BINH DINH)": {
    "msb": { "code": "52204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH THANH- BINH DINH-52204012"
    }
  },
  "AGRIBANK/VINH THO": {
    "msb": { "code": "56204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KHANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN CN VINH THO-56204003"
    }
  },
  "AGRIBANK/VINH THUAN": {
    "msb": { "code": "91204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH THUAN-91204012"
    }
  },
  "AGRIBANK/VINH TUONG": {
    "msb": { "code": "26204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH TUONG-26204003"
    }
  },
  "AGRIBANK/VO NHAI": {
    "msb": { "code": "19204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-NGUYEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VO NHAI-19204004"
    }
  },
  "AGRIBANK/VOI": {
    "msb": { "code": "42204006" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN CN VOI - HA TINH-42204006"
    }
  },
  "AGRIBANK/VP DAI DIEN KV MIEN NAM": {
    "msb": { "code": "79204017" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN VPDD KV MIEN NAM-79204017"
    }
  },
  "AGRIBANK/VP DAI DIEN KV MIEN TRUNG": {
    "msb": { "code": "48204018" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DA-NANG",
      "branch": "NONG NGHIEP VA PTNT VN VPDD KV MIEN TRUNG-48204018"
    }
  },
  "AGRIBANK/VP DAI DIEN KV TAY NAM BO": {
    "msb": { "code": "92204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "CAN-THO",
      "branch": "NONG NGHIEP VA PTNT VN VPDD KV TAY NAM BO-92204012"
    }
  },
  "AGRIBANK/VU BAN": {
    "msb": { "code": "36204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU BAN-36204003"
    }
  },
  "AGRIBANK/VU QUANG": {
    "msb": { "code": "42204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-TINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU QUANG-42204010"
    }
  },
  "AGRIBANK/VU THU": {
    "msb": { "code": "34204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THAI-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VU THU-34204004"
    }
  },
  "AGRIBANK/VUNG LIEM": {
    "msb": { "code": "86204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-LONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VUNG LIEM-86204005"
    }
  },
  "AGRIBANK/XIN MAN": {
    "msb": { "code": "02204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XIN MAN-02204010"
    }
  },
  "AGRIBANK/XUAN LOC (DONG NAI)": {
    "msb": { "code": "75204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG NAI-75204001"
    }
  },
  "AGRIBANK/XUAN LOC (PHU YEN)": {
    "msb": { "code": "54204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-YEN",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH PHU YEN-54204001"
    }
  },
  "AGRIBANK/XUAN MAI": {
    "msb": { "code": "01204048" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NOI",
      "branch": "NONG NGHIEP VA PTNT VN CN XUAN MAI - HA TAY-01204048"
    }
  },
  "AGRIBANK/XUAN TRUONG": {
    "msb": { "code": "36204011" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUAN TRUONG-36204011"
    }
  },
  "AGRIBANK/XUONG GIANG": {
    "msb": { "code": "24204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN XUONG GIANG-24204003"
    }
  },
  "AGRIBANK/XUYEN A": {
    "msb": { "code": "79204044" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HO-CHI-MINH",
      "branch": "NONG NGHIEP VA PTNT VN CN XUYEN A-79204044"
    }
  },
  "AGRIBANK/XUYEN MOC": {
    "msb": { "code": "77204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BARIA-VUNGTAU",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUYEN MOC-77204003"
    }
  },
  "AGRIBANK/Y YEN": {
    "msb": { "code": "36204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NAM-DINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN Y YEN-36204005"
    }
  },
  "AGRIBANK/YEN BAI - NINH BINH": {
    "msb": { "code": "37204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH NINH BINH-37204001"
    }
  },
  "AGRIBANK/YEN BINH": {
    "msb": { "code": "15204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "YEN-BAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN BINH-15204005"
    }
  },
  "AGRIBANK/YEN CHAU": {
    "msb": { "code": "14204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "SON-LA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN CHAU-14204010"
    }
  },
  "AGRIBANK/YEN DINH": {
    "msb": { "code": "38204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "THANH-HOA",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN DINH-38204005"
    }
  },
  "AGRIBANK/YEN DO": {
    "msb": { "code": "64204019" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN CN YEN DO - GIA LAI-64204019"
    }
  },
  "AGRIBANK/YEN DUNG": {
    "msb": { "code": "24204009" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN YEN DUNG-24204009"
    }
  },
  "AGRIBANK/YEN KHANH": {
    "msb": { "code": "37204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN KHANH-37204004"
    }
  },
  "AGRIBANK/YEN LAC": {
    "msb": { "code": "26204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "VINH-PHUC",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN LAC-26204004"
    }
  },
  "AGRIBANK/YEN LAP": {
    "msb": { "code": "25204012" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "PHU-THO",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN LAP-25204012"
    }
  },
  "AGRIBANK/YEN MINH": {
    "msb": { "code": "02204004" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN MINH-02204004"
    }
  },
  "AGRIBANK/YEN MO": {
    "msb": { "code": "37204005" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NINH-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN MO-37204005"
    }
  },
  "AGRIBANK/YEN MY": {
    "msb": { "code": "33204003" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HUNG-YEN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN MY-33204003"
    }
  },
  "AGRIBANK/YEN PHONG": {
    "msb": { "code": "27204008" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-NINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN PHONG-27204008"
    }
  },
  "AGRIBANK/YEN SON": {
    "msb": { "code": "08204001" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN TINH TUYEN QUANG-08204001"
    }
  },
  "AGRIBANK/YEN THANH": {
    "msb": { "code": "40204021" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "NGHE-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN THANH-40204021"
    }
  },
  "AGRIBANK/YEN THE": {
    "msb": { "code": "24204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BAC-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN THE-24204010"
    }
  },
  "AGRIBANK/YEN THUY": {
    "msb": { "code": "17204010" },
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HOA-BINH",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN THUY-17204010"
    }
  },
  "ANZ/HO CHI MINH (HCM)": {
    "msb": { "code": "79602001" },
    "techcombank": {
      "bank": "ANZ VN",
      "region": "Ca nuoc",
      "branch": "ANZ VN-602"
    }
  },
  "ANZ/HOI SO CHINH (HSC)": {
    "msb": { "code": "01602002" },
    "techcombank": {
      "bank": "ANZ VN",
      "region": "Ca nuoc",
      "branch": "ANZ VN-602"
    }
  },
  "ANZ/NAM SAI GON": {
    "msb": { "code": "79602003" },
    "techcombank": {
      "bank": "ANZ VN",
      "region": "Ca nuoc",
      "branch": "ANZ VN-602"
    }
  },
  "ANZ/SO GIAO DICH (SGD)": {
    "msb": { "code": "01602001" },
    "techcombank": {
      "bank": "ANZ VN",
      "region": "Ca nuoc",
      "branch": "ANZ VN-602"
    }
  },
  "ANZ/TRUNG TAM NGHIEP VU": {
    "msb": { "code": "79602002" },
    "techcombank": {
      "bank": "ANZ VN",
      "region": "Ca nuoc",
      "branch": "ANZ VN-602"
    }
  },
  "BAN VIET/AN GIANG": {
    "msb": { "code": "89327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/BACH DANG": {
    "msb": { "code": "79327003" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/BINH DUONG": {
    "msb": { "code": "74327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/BUON MA THUOT": {
    "msb": { "code": "66327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/CA MAU": {
    "msb": { "code": "96327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/CAN THO": {
    "msb": { "code": "92327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/DA NANG": {
    "msb": { "code": "48327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/DONG NAI": {
    "msb": { "code": "75327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/HA NOI": {
    "msb": { "code": "01327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/HANG XANH": {
    "msb": { "code": "79327004" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/HOI SO CHINH": {
    "msb": { "code": "79327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/LONG AN": {
    "msb": { "code": "80327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/NHA TRANG": {
    "msb": { "code": "56327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/PHAN THIET": {
    "msb": { "code": "60327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/SAI GON": {
    "msb": { "code": "79327002" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/TAY NINH": {
    "msb": { "code": "72327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/TIEN GIANG": {
    "msb": { "code": "82327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BAN VIET/VUNG TAU": {
    "msb": { "code": "77327001" },
    "techcombank": {
      "bank": "BAN VIET (VIETCAPITALBANK)",
      "region": "Ca nuoc",
      "branch": "BAN VIET (VIETCAPITALBANK)-327"
    }
  },
  "BANGKOK BANK/HA NOI": {
    "msb": { "code": "01612001" },
    "techcombank": {
      "bank": "BANGKOK",
      "region": "HA-NOI",
      "branch": "BANGKOK CN HA NOI-01612001"
    }
  },
  "BANGKOK BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79612001" },
    "techcombank": {
      "bank": "BANGKOK",
      "region": "HO-CHI-MINH",
      "branch": "BANGKOK CN HCM-79612001"
    }
  },
  "BANK OF CHINA/HO CHI MINH (HCM)": {
    "msb": { "code": "79620001" },
    "techcombank": {
      "bank": "BANK OF CHINA",
      "region": "Ca nuoc",
      "branch": "BANK OF CHINA-620"
    }
  },
  "BANKCOMM/BANK OF COMMUNICATIONS": {
    "msb": { "code": "79615001" },
    "techcombank": {
      "bank": "BANK OF COMMUNICATIONS",
      "region": "Ca nuoc",
      "branch": "BANK OF COMMUNICATIONS-615"
    }
  },
  "BAOVIET BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79359001" },
    "techcombank": {
      "bank": "BAO VIET (BAOVIETBANK)",
      "region": "Ca nuoc",
      "branch": "BAO VIET (BAOVIETBANK)-359"
    }
  },
  "BAOVIET BANK/HOI SO CHINH (HSC)": {
    "msb": { "code": "01359001" },
    "techcombank": {
      "bank": "BAO VIET (BAOVIETBANK)",
      "region": "Ca nuoc",
      "branch": "BAO VIET (BAOVIETBANK)-359"
    }
  },
  "BAOVIET BANK/SO GIAO DICH (SGD)": {
    "msb": { "code": "01359002" },
    "techcombank": {
      "bank": "BAO VIET (BAOVIETBANK)",
      "region": "Ca nuoc",
      "branch": "BAO VIET (BAOVIETBANK)-359"
    }
  },
  "BIDC/HA NOI": {
    "msb": { "code": "01638001" },
    "techcombank": {
      "bank": "DT VA PT CAMPUCHIA (BIDC) CN HN",
      "region": "Ca nuoc",
      "branch": "DT VA PT CAMPUCHIA (BIDC) CN HN-638"
    }
  },
  "BIDC/HO CHI MINH (HCM)": {
    "msb": { "code": "79648001" },
    "techcombank": {
      "bank": "DT VA PT CAMPUCHIA (BIDC) CN HCM",
      "region": "Ca nuoc",
      "branch": "DT VA PT CAMPUCHIA (BIDC) CN HCM-648"
    }
  },
  "BIDV/AN GIANG": {
    "msb": { "code": "89202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BA CHIEU - TP HCM": {
    "msb": { "code": "79202021" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BA DINH": {
    "msb": { "code": "01202013" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BA RIA": {
    "msb": { "code": "77202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BA RIA VUNG TAU": {
    "msb": { "code": "77202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC AN GIANG": {
    "msb": { "code": "89202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC CAN": {
    "msb": { "code": "06202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC DAKLAK": {
    "msb": { "code": "66202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC GIANG": {
    "msb": { "code": "24202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC HA": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC HA NOI": {
    "msb": { "code": "01202004" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC HAI DUONG": {
    "msb": { "code": "30202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC LIEU": {
    "msb": { "code": "95202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC NGHE AN": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC NINH": {
    "msb": { "code": "27202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC QUANG BINH": {
    "msb": { "code": "44202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAC SAI GON": {
    "msb": { "code": "79202005" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAN ME - DAK LAK": {
    "msb": { "code": "66202004" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BAO LOC": {
    "msb": { "code": "68202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BEN NGHE": {
    "msb": { "code": "79202013" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BEN TRE": {
    "msb": { "code": "83202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BIEN HOA - DONG NAI": {
    "msb": { "code": "75202004" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BIM SON": {
    "msb": { "code": "38202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BINH DINH": {
    "msb": { "code": "52202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BINH DUONG": {
    "msb": { "code": "74202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BINH PHUOC": {
    "msb": { "code": "70202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/BINH THUAN": {
    "msb": { "code": "60202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CA MAU": {
    "msb": { "code": "96202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CAN THO": {
    "msb": { "code": "92202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CAO BANG": {
    "msb": { "code": "04202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CAO LANH - DONG THAP": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CAU GIAY": {
    "msb": { "code": "01202010" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CHAU DOC - AN GIANG": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CHUONG DUONG": {
    "msb": { "code": "01202022" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CON DAO - BR VUNG TAU": {
    "msb": { "code": "77202004" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CONG TY CHO THUE TAI CHINH": {
    "msb": { "code": "01202500" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/CUU LONG - VINH LONG": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DA LAT": {
    "msb": { "code": "68202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DA NANG": {
    "msb": { "code": "48202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DAC NONG": {
    "msb": { "code": "67202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DAI LA": {
    "msb": { "code": "01202030" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DAKLAK": {
    "msb": { "code": "66202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DAT MUI - CA MAU": {
    "msb": { "code": "96202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DIEN BIEN": {
    "msb": { "code": "11202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG DAKLAK": {
    "msb": { "code": "66202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG DANG": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG DO": {
    "msb": { "code": "01202007" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG DONG NAI": {
    "msb": { "code": "75202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG HA NOI": {
    "msb": { "code": "01202008" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG HAI PHONG": {
    "msb": { "code": "31202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG KHOI - BEN TRE": {
    "msb": { "code": "83202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG NAI": {
    "msb": { "code": "75202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG SAI GON": {
    "msb": { "code": "79202006" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DONG THAP": {
    "msb": { "code": "87202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DUONG DONG - KIEN GIANG": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/DUYEN HAI - TRA VINH": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/GIA DINH": {
    "msb": { "code": "79202007" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/GIA LAI": {
    "msb": { "code": "64202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HA DONG": {
    "msb": { "code": "01202029" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HA GIANG": {
    "msb": { "code": "02202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HA LONG": {
    "msb": { "code": "22202004" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HA NAM": {
    "msb": { "code": "35202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HA NOI (HN)": {
    "msb": { "code": "01202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HA TAY": {
    "msb": { "code": "01202017" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HA THANH": {
    "msb": { "code": "01202005" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HA TINH": {
    "msb": { "code": "42202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HAI BA TRUNG": {
    "msb": { "code": "01202011" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HAI DUONG": {
    "msb": { "code": "30202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HAI PHONG": {
    "msb": { "code": "31202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HAI VAN DA NANG": {
    "msb": { "code": "48202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HAM NGHI - TP HCM": {
    "msb": { "code": "79202020" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HAU GIANG": {
    "msb": { "code": "93202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HO CHI MINH (HCM)": {
    "msb": { "code": "79202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HOA BINH": {
    "msb": { "code": "17202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HOAN KIEM": {
    "msb": { "code": "01202021" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HOI AN": {
    "msb": { "code": "49202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HUNG VUONG": {
    "msb": { "code": "25202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/HUNG YEN": {
    "msb": { "code": "33202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/KHANH HOA": {
    "msb": { "code": "56202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/KIEN GIANG": {
    "msb": { "code": "91202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/KINH BAC": {
    "msb": { "code": "27202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/KON TUM": {
    "msb": { "code": "62202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/LACH TRAY": {
    "msb": { "code": "31202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/LAI CHAU": {
    "msb": { "code": "12202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/LAM DONG": {
    "msb": { "code": "68202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/LAM SON": {
    "msb": { "code": "38202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/LANG SON": {
    "msb": { "code": "20202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/LAO CAI": {
    "msb": { "code": "10202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/LONG AN": {
    "msb": { "code": "80202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/LONG XUYEN - AN GIANG": {
    "msb": { "code": "89202004" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/MINH HAI - BAC LIEU": {
    "msb": { "code": "95202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/MOC HOA - LONG AN": {
    "msb": { "code": "80202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/MONG CAI": {
    "msb": { "code": "22202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/MY PHUOC": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/MY THO - TIEN GIANG": {
    "msb": { "code": "82202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NAM BINH DUONG": {
    "msb": { "code": "74202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NAM DINH": {
    "msb": { "code": "36202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NAM DONG NAI": {
    "msb": { "code": "75202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NAM HA NOI": {
    "msb": { "code": "01202014" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NAM KY KHOI NGHIA": {
    "msb": { "code": "79202008" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NGHE AN": {
    "msb": { "code": "40202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NHA TRANG": {
    "msb": { "code": "56202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NINH BINH": {
    "msb": { "code": "37202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/NINH THUAN": {
    "msb": { "code": "58202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/PHO NUI - GIA LAI": {
    "msb": { "code": "64202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/PHU MY": {
    "msb": { "code": "77202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/PHU QUY": {
    "msb": { "code": "40202004" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/PHU TAI BINHDINH": {
    "msb": { "code": "52202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/PHU THO": {
    "msb": { "code": "25202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/PHU XUAN": {
    "msb": { "code": "46202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/PHU YEN": {
    "msb": { "code": "54202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/PHUC YEN": {
    "msb": { "code": "26202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/QUANG BINH": {
    "msb": { "code": "44202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/QUANG NAM": {
    "msb": { "code": "49202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/QUANG NGAI": {
    "msb": { "code": "51202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/QUANG NINH": {
    "msb": { "code": "22202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/QUANG TRI": {
    "msb": { "code": "45202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/QUANG TRUNG": {
    "msb": { "code": "01202009" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/RACH GIA - KIEN GIANG": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SA DEC - DONG THAP": {
    "msb": { "code": "87202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SAI GON": {
    "msb": { "code": "79202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SO GIAO DICH 1 (HN)": {
    "msb": { "code": "01202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SO GIAO DICH 2 (HCM)": {
    "msb": { "code": "79202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SOC TRANG": {
    "msb": { "code": "94202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SON LA": {
    "msb": { "code": "14202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SONG BE - BINH DUONG": {
    "msb": { "code": "74202005" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SONG HAN": {
    "msb": { "code": "48202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/SONG HAU - SOC TRANG": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TAN AN - LONG AN": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TAY DO - CAN THO": {
    "msb": { "code": "92202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TAY HA NOI": {
    "msb": { "code": "01202020" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TAY HO": {
    "msb": { "code": "01202016" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TAY NGHE AN": {
    "msb": { "code": "40202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TAY NINH": {
    "msb": { "code": "72202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TAY SAI GON": {
    "msb": { "code": "79202004" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TAY SON - BINH DINH": {
    "msb": { "code": "52202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/THAI BINH": {
    "msb": { "code": "34202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/THAI NGUYEN": {
    "msb": { "code": "19202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/THANG LONG HA NOI": {
    "msb": { "code": "01202006" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/THANH DONG": {
    "msb": { "code": "30202003" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/THANH HOA": {
    "msb": { "code": "38202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/THANH VINH": {
    "msb": { "code": "40202005" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/THANH XUAN": {
    "msb": { "code": "01202019" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/THUA THIEN HUE": {
    "msb": { "code": "46202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TIEN GIANG": {
    "msb": { "code": "82202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TRA CO": {
    "msb": { "code": "22202005" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TRA VINH": {
    "msb": { "code": "84202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TRUONG SON - TP HCM": {
    "msb": { "code": "79202023" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TU SON": {
    "msb": { "code": "27202002" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/TUYEN QUANG": {
    "msb": { "code": "08202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/VI THANH - HAU GIANG": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/VIET NAM": {
    "msb": { "code": "01202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/VINH LONG": {
    "msb": { "code": "86202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/VINH PHUC": {
    "msb": { "code": "26202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BIDV/YEN BAI": {
    "msb": { "code": "15202001" },
    "techcombank": {
      "bank": "DAU TU VA PHAT TRIEN VN ( BIDV)",
      "region": "Ca nuoc",
      "branch": "DAU TU VA PHAT TRIEN VN ( BIDV)-202"
    }
  },
  "BNP PARIBAS/HA NOI (HN)": {
    "msb": { "code": "01657001" },
    "techcombank": {
      "bank": "BNP PARIBAS CN HA NOI",
      "region": "Ca nuoc",
      "branch": "BNP PARIBAS CN HA NOI-657"
    }
  },
  "BNP PARIBAS/HO CHI MINH (HCM)": {
    "msb": { "code": "79614001" },
    "techcombank": {
      "bank": "BNP PARIBAS CN HCM",
      "region": "Ca nuoc",
      "branch": "BNP PARIBAS CN HCM-614"
    }
  },
  "BPCE IOM/HO CHI MINH (HCM)": {
    "msb": { "code": "79601001" },
    "techcombank": {
      "bank": "BPCEIOM",
      "region": "Ca nuoc",
      "branch": "BPCEIOM-601"
    }
  },
  "CHINA CONSTRUCTION BANK/HCM": {
    "msb": { "code": "79611001" },
    "techcombank": {
      "bank": "CHINA CONSTRUCTION CORPORATION",
      "region": "Ca nuoc",
      "branch": "CHINA CONSTRUCTION CORPORATION-611"
    }
  },
  "CIMB/VIET NAM": {
    "msb": { "code": "01661001" },
    "techcombank": {
      "bank": "CIMB VIET NAM",
      "region": "Ca nuoc",
      "branch": "CIMB VIET NAM-661"
    }
  },
  "CITIBANK/HA NOI (HN)": {
    "msb": { "code": "01605001" },
    "techcombank": {
      "bank": "CITIBANK HA NOI",
      "region": "Ca nuoc",
      "branch": "CITIBANK HA NOI-605"
    }
  },
  "CITIBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79654001" },
    "techcombank": {
      "bank": "CITIBANK HO CHI MINH",
      "region": "Ca nuoc",
      "branch": "CITIBANK HO CHI MINH-654"
    }
  },
  "COMMONWEALTH BANK OF AUSTRALIA/HCM": {
    "msb": { "code": "79643001" },
    "techcombank": null
  },
  "CREDIT AGRICOLE CIB/HA NOI (HN)": {
    "msb": { "code": "01621001" },
    "techcombank": null
  },
  "CTBC BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79629001" },
    "techcombank": {
      "bank": "CHINA TRUST COMMERCIAL (CTBC)",
      "region": "Ca nuoc",
      "branch": "CHINA TRUST COMMERCIAL (CTBC)-629"
    }
  },
  "DBS/HO CHI MINH (HCM) (HO)": {
    "msb": { "code": "79650001" },
    "techcombank": {
      "bank": "DBS BANK LTD",
      "region": "Ca nuoc",
      "branch": "DBS BANK LTD-650"
    }
  },
  "DEUTSCHE BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79619001" },
    "techcombank": {
      "bank": "DEUTSCHE",
      "region": "Ca nuoc",
      "branch": "DEUTSCHE-619"
    }
  },
  "DONGA BANK/NAM DINH": {
    "msb": { "code": "01304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/AN GIANG": {
    "msb": { "code": "89304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BAC GIANG": {
    "msb": { "code": "24304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BAC LIEU": {
    "msb": { "code": "95304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BAC NINH": {
    "msb": { "code": "27304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BEN TRE": {
    "msb": { "code": "83304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BIEN HOA": {
    "msb": { "code": "75304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BINH DINH": {
    "msb": { "code": "52304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BINH DUONG": {
    "msb": { "code": "74304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BINH PHUOC": {
    "msb": { "code": "70304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BINH TAY": {
    "msb": { "code": "79304010" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/BINH THUAN": {
    "msb": { "code": "60304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/CA MAU": {
    "msb": { "code": "96304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/CAN THO": {
    "msb": { "code": "92304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/CAO LANH": {
    "msb": { "code": "87304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/DA LAT": {
    "msb": { "code": "68304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/DA NANG": {
    "msb": { "code": "48304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/DAC LAC": {
    "msb": { "code": "66304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/DINH TIEN HOANG": {
    "msb": { "code": "79304006" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/GO VAP": {
    "msb": { "code": "79304007" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/HA NOI (HN)": {
    "msb": { "code": "01304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/HAI PHONG": {
    "msb": { "code": "31304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/HOI AN": {
    "msb": { "code": "49304002" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/HUE": {
    "msb": { "code": "46304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/HUNG YEN": {
    "msb": { "code": "33304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/KIEN GIANG": {
    "msb": { "code": "91304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/KON TUM": {
    "msb": { "code": "62304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/LE DAI HANH": {
    "msb": { "code": "79304005" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/LE VAN SY": {
    "msb": { "code": "79304015" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/LONG AN": {
    "msb": { "code": "80304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/NHA TRANG": {
    "msb": { "code": "56304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/NINH THUAN": {
    "msb": { "code": "58304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/PHU MY HUNG": {
    "msb": { "code": "79304012" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/PHU NHUAN": {
    "msb": { "code": "79304011" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/PHU YEN": {
    "msb": { "code": "54304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/PLEIKU": {
    "msb": { "code": "64304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/QUAN 1": {
    "msb": { "code": "79304002" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/QUAN 10": {
    "msb": { "code": "79304003" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/QUAN 4": {
    "msb": { "code": "79304013" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/QUAN 5": {
    "msb": { "code": "79304009" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/QUAN 9": {
    "msb": { "code": "79304008" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/QUANG NAM": {
    "msb": { "code": "49304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/QUANG NGAI": {
    "msb": { "code": "51304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/QUANG NINH": {
    "msb": { "code": "22304002" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/SO GIAO DICH (SGD)": {
    "msb": { "code": "79304014" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/SOC TRANG": {
    "msb": { "code": "94304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/TAN BINH": {
    "msb": { "code": "79304004" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/TAYNINH": {
    "msb": { "code": "72304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/THAI BINH": {
    "msb": { "code": "34304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/THAI NGUYEN": {
    "msb": { "code": "19304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/THUAN AN": {
    "msb": { "code": "74304002" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/TIEN GIANG": {
    "msb": { "code": "82304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/TRA VINH": {
    "msb": { "code": "84304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/VINH LONG": {
    "msb": { "code": "86304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/VINH YEN": {
    "msb": { "code": "26304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "DONGA BANK/VUNG TAU": {
    "msb": { "code": "77304001" },
    "techcombank": {
      "bank": "DONG A (DAB)",
      "region": "Ca nuoc",
      "branch": "DONG A (DAB)-304"
    }
  },
  "ESUN BANK/DONG NAI": {
    "msb": { "code": "75658001" },
    "techcombank": {
      "bank": "E.SUN CN DONG NAI",
      "region": "Ca nuoc",
      "branch": "E.SUN CN DONG NAI-658"
    }
  },
  "EXIMBANK/AN GIANG": {
    "msb": { "code": "89305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/BA RIA": {
    "msb": { "code": "77305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/BAC LIEU": {
    "msb": { "code": "95305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/BINH DUONG": {
    "msb": { "code": "74305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/BINH PHU": {
    "msb": { "code": "79305013" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/BINH TAN": {
    "msb": { "code": "79305015" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/BUON MA THUOT": {
    "msb": { "code": "66305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/CAU GIAY": {
    "msb": { "code": "01305005" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/CHO LON": {
    "msb": { "code": "79305007" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/CONG HOA": {
    "msb": { "code": "79305012" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/DA LAT": {
    "msb": { "code": "68305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/DA NANG": {
    "msb": { "code": "48305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/DONG DA": {
    "msb": { "code": "01305006" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/DONG NAI": {
    "msb": { "code": "75305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/HA NOI (HN)": {
    "msb": { "code": "01305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/HAI BA TRUNG": {
    "msb": { "code": "01305004" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/HAI PHONG": {
    "msb": { "code": "31305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/HOA BINH": {
    "msb": { "code": "79305005" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/HUE": {
    "msb": { "code": "46305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/HUNG VUONG": {
    "msb": { "code": "48305002" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/LANG HA": {
    "msb": { "code": "01305002" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/LONG AN": {
    "msb": { "code": "80305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/LONG BIEN": {
    "msb": { "code": "01305003" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/MY THO": {
    "msb": { "code": "82305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/NHA TRANG": {
    "msb": { "code": "56305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/PHU MY HUNG": {
    "msb": { "code": "79305014" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/QUAN 10": {
    "msb": { "code": "79305004" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/QUAN 11": {
    "msb": { "code": "79305003" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/QUAN 3": {
    "msb": { "code": "79305017" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/QUAN 4": {
    "msb": { "code": "79305009" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/QUAN 7": {
    "msb": { "code": "79305010" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/QUANG NGAI": {
    "msb": { "code": "51305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/QUANG NINH": {
    "msb": { "code": "22305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/SAI GON": {
    "msb": { "code": "79305002" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/SO GIAO DICH (SGD) 1": {
    "msb": { "code": "79305008" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/TAN DINH": {
    "msb": { "code": "79305006" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/TAN SON NHAT": {
    "msb": { "code": "79305016" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/THU DUC": {
    "msb": { "code": "79305011" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "EXIMBANK/VINH": {
    "msb": { "code": "40305001" },
    "techcombank": {
      "bank": "XUAT NHAP KHAU (EXIMBANK)",
      "region": "Ca nuoc",
      "branch": "XUAT NHAP KHAU (EXIMBANK)-305"
    }
  },
  "FAR EAST NATIONAL BANK/HOI SO": {
    "msb": { "code": "79632001" },
    "techcombank": null
  },
  "FIRST COMMERCIAL BANK/CN TP HCM": {
    "msb": { "code": "79630001" },
    "techcombank": {
      "bank": "FIRST COMMERCIAL BANK CN HCM",
      "region": "Ca nuoc",
      "branch": "FIRST COMMERCIAL BANK CN HCM-630"
    }
  },
  "FIRST COMMERCIAL BANK/HA NOI": {
    "msb": { "code": "01608001" },
    "techcombank": {
      "bank": "FIRST COMMERCIAL BANK CN HA NOI",
      "region": "Ca nuoc",
      "branch": "FIRST COMMERCIAL BANK CN HA NOI-608"
    }
  },
  "GPBANK/GIA LAI": {
    "msb": { "code": "64320001" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "GPBANK/HA NOI (HN)": {
    "msb": { "code": "01320001" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "GPBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79320001" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "GPBANK/HOAN KIEM": {
    "msb": { "code": "01320002" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "GPBANK/NINH BINH": {
    "msb": { "code": "37320001" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "GPBANK/SAI GON": {
    "msb": { "code": "79320002" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "GPBANK/SO GIAO DICH (SGD)": {
    "msb": { "code": "01320005" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "GPBANK/THANG LONG": {
    "msb": { "code": "01320004" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "GPBANK/VUNG TAU": {
    "msb": { "code": "77320001" },
    "techcombank": {
      "bank": "DAU KHI TOAN CAU (GPBANK)",
      "region": "Ca nuoc",
      "branch": "DAU KHI TOAN CAU (GPBANK)-320"
    }
  },
  "HANABANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79656001" },
    "techcombank": {
      "bank": "KEB HANA CN TP HCM",
      "region": "Ca nuoc",
      "branch": "KEB HANA CN TP HCM-656"
    }
  },
  "HDBANK/AN LAC": {
    "msb": { "code": "79321005" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/BIEN HOA": {
    "msb": { "code": "75321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/BINH DUONG": {
    "msb": { "code": "74321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/CAN THO": {
    "msb": { "code": "92321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/CAU GIAY": {
    "msb": { "code": "01321003" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/CONG HOA": {
    "msb": { "code": "79321006" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/DA NANG": {
    "msb": { "code": "79321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/HA NOI (HN)": {
    "msb": { "code": "01321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/HAI PHONG": {
    "msb": { "code": "31321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/HIEP PHU": {
    "msb": { "code": "79321007" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/HOAN KIEM": {
    "msb": { "code": "01321002" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/LANH BINH THANG": {
    "msb": { "code": "79321003" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/NGUYEN TRAI": {
    "msb": { "code": "79321004" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/NHA TRANG": {
    "msb": { "code": "56321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/PHU NHUAN": {
    "msb": { "code": "79321002" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/PHU THO": {
    "msb": { "code": "79321008" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/SAI GON": {
    "msb": { "code": "79321009" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/VINH": {
    "msb": { "code": "40321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HDBANK/VUNG TAU": {
    "msb": { "code": "77321001" },
    "techcombank": {
      "bank": "PHAT TRIEN TP HCM (HDBANK)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN TP HCM (HDBANK)-321"
    }
  },
  "HONG LEONG/HA NOI (HN)": {
    "msb": { "code": "01603001" },
    "techcombank": {
      "bank": "HONG LEONG VIET NAM",
      "region": "Ca nuoc",
      "branch": "HONG LEONG VIET NAM-603"
    }
  },
  "HONG LEONG/HOI SO CHINH (HSC) (HCM)": {
    "msb": { "code": "79603001" },
    "techcombank": {
      "bank": "HONG LEONG VIET NAM",
      "region": "Ca nuoc",
      "branch": "HONG LEONG VIET NAM-603"
    }
  },
  "HSBC/HA NOI (HN)": {
    "msb": { "code": "01617001" },
    "techcombank": {
      "bank": "HSBC",
      "region": "Ca nuoc",
      "branch": "HSBC-617"
    }
  },
  "HSBC/LE DAI HANH": {
    "msb": { "code": "79617002" },
    "techcombank": {
      "bank": "HSBC",
      "region": "Ca nuoc",
      "branch": "HSBC-617"
    }
  },
  "HSBC/VIET NAM": {
    "msb": { "code": "79617001" },
    "techcombank": {
      "bank": "HSBC",
      "region": "Ca nuoc",
      "branch": "HSBC-617"
    }
  },
  "HSBC/VIET NAM BINH DUONG": {
    "msb": { "code": "74617001" },
    "techcombank": {
      "bank": "HSBC",
      "region": "Ca nuoc",
      "branch": "HSBC-617"
    }
  },
  "HUA NAN COMMERCIAL BANK/HO CHI MINH": {
    "msb": { "code": "79640001" },
    "techcombank": {
      "bank": "HUA NAN COMMERCIAL",
      "region": "Ca nuoc",
      "branch": "HUA NAN COMMERCIAL-640"
    }
  },
  "ICBC/HA NOI (HN)": {
    "msb": { "code": "01649001" },
    "techcombank": {
      "bank": "ICBC HA NOI",
      "region": "Ca nuoc",
      "branch": "ICBC HA NOI-649"
    }
  },
  "INDOVINABANK/BEN THANH": {
    "msb": { "code": "79502004" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/BINH DUONG": {
    "msb": { "code": "74502001" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/CAN THO": {
    "msb": { "code": "92502001" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/CHO LON": {
    "msb": { "code": "79502002" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/DA NANG": {
    "msb": { "code": "48502001" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/DONG DA": {
    "msb": { "code": "01502002" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/DONG NAI": {
    "msb": { "code": "75502001" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/HA NOI (HN)": {
    "msb": { "code": "01502001" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/HAI PHONG": {
    "msb": { "code": "31502001" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79502001" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/MY DINH": {
    "msb": { "code": "01502004" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/TAN BINH": {
    "msb": { "code": "79502003" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "INDOVINABANK/THIEN LONG": {
    "msb": { "code": "01502003" },
    "techcombank": {
      "bank": "INDOVINA",
      "region": "Ca nuoc",
      "branch": "INDOVINA-502"
    }
  },
  "JPMORGAN CHASE N.A/HO CHI MINH (HCM)": {
    "msb": { "code": "79627001" },
    "techcombank": null
  },
  "KIENLONGBANK/AN GIANG": {
    "msb": { "code": "89353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/BAC LIEU": {
    "msb": { "code": "95353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/BEN NHUT": {
    "msb": { "code": "91353002" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/BEN TRE": {
    "msb": { "code": "83353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/BINH DINH": {
    "msb": { "code": "52353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/BINH DUONG": {
    "msb": { "code": "74353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/CA MAU": {
    "msb": { "code": "96353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/CAN THO": {
    "msb": { "code": "92353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/DA NANG": {
    "msb": { "code": "48353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/DAKLAK": {
    "msb": { "code": "66353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/DONG NAI": {
    "msb": { "code": "75353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/DONG THAP": {
    "msb": { "code": "87353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/HA NOI (HN)": {
    "msb": { "code": "01353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/HAI PHONG": {
    "msb": { "code": "31353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/HAU GIANG": {
    "msb": { "code": "93353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/HOI SO CHINH (HSC)": {
    "msb": { "code": "91353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/KHANH HOA": {
    "msb": { "code": "56353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/LONG AN": {
    "msb": { "code": "80353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/PHU QUOC": {
    "msb": { "code": "91353004" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/PHU YEN": {
    "msb": { "code": "54353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/RACH GIA": {
    "msb": { "code": "91353003" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/SAI GON": {
    "msb": { "code": "79353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/SOC TRANG": {
    "msb": { "code": "94353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/TIEN GIANG": {
    "msb": { "code": "82353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/TRA VINH": {
    "msb": { "code": "84353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/VINH LONG": {
    "msb": { "code": "86353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KIENLONGBANK/VUNG TAU": {
    "msb": { "code": "77353001" },
    "techcombank": {
      "bank": "KIEN LONG (KIENLONGBANK)",
      "region": "Ca nuoc",
      "branch": "KIEN LONG (KIENLONGBANK)-353"
    }
  },
  "KOOKMIN/HO CHI MINH (HCM) (HO)": {
    "msb": { "code": "79631001" },
    "techcombank": {
      "bank": "KOOKMIN CN TP HO CHI MINH",
      "region": "Ca nuoc",
      "branch": "KOOKMIN CN TP HO CHI MINH-631"
    }
  },
  "KOREA EXCHANGE BANK/HA NOI": {
    "msb": { "code": "01626001" },
    "techcombank": null
  },
  "LAO VIET BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79202013" },
    "techcombank": null
  },
  "LAO VIET BANK/HA NOI (HN)": {
    "msb": { "code": "01202001" },
    "techcombank": null
  },
  "LIENVIETPOSTBANK/AN GIANG": {
    "msb": { "code": "89357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/BEN TRE": {
    "msb": { "code": "83357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/BINH THUAN": {
    "msb": { "code": "60357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/CAN THO": {
    "msb": { "code": "92357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/CHO LON": {
    "msb": { "code": "79357003" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/DA NANG": {
    "msb": { "code": "48357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/DONG DO": {
    "msb": { "code": "01357002" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/DUNG QUAT": {
    "msb": { "code": "51357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/HA GIANG": {
    "msb": { "code": "02357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/HA NOI (HN)": {
    "msb": { "code": "01357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/HAI DUONG": {
    "msb": { "code": "30357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/HOI SO CHINH (HSC)": {
    "msb": { "code": "01357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/TAN BINH": {
    "msb": { "code": "79357002" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/THAI BINH": {
    "msb": { "code": "34357001" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "LIENVIETPOSTBANK/THANG LONG": {
    "msb": { "code": "01357003" },
    "techcombank": {
      "bank": "BUU DIEN LIEN VIET (LPB)",
      "region": "Ca nuoc",
      "branch": "BUU DIEN LIEN VIET (LPB)-357"
    }
  },
  "MSB/BINH DINH": {
    "msb": { "code": "52302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/CAM PHA": {
    "msb": { "code": "22302003" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/CAN THO": {
    "msb": { "code": "92302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/CAU GIAY": {
    "msb": { "code": "01302006" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/CONG HOA": {
    "msb": { "code": "79302005" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/DA NANG": {
    "msb": { "code": "48302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/DAKLAK": {
    "msb": { "code": "66302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/DO THANH": {
    "msb": { "code": "79302003" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/DONG DA": {
    "msb": { "code": "01302004" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HA NAM": {
    "msb": { "code": "36302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HAI DUONG": {
    "msb": { "code": "30302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HAI PHONG": {
    "msb": { "code": "31302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HCMC": {
    "msb": { "code": "79302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HO GUOM": {
    "msb": { "code": "01302003" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HOA KHANH": {
    "msb": { "code": "48302002" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HONG BANG": {
    "msb": { "code": "31302002" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HUE": {
    "msb": { "code": "46302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/LONG BIEN": {
    "msb": { "code": "01302007" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/MY TOAN": {
    "msb": { "code": "79302002" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/NAM DINH": {
    "msb": { "code": "36302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/NAM HA NOI": {
    "msb": { "code": "01302005" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/NGHE AN": {
    "msb": { "code": "40302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/NHA TRANG": {
    "msb": { "code": "56302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/NINH KIEU": {
    "msb": { "code": "92302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/PHU THO": {
    "msb": { "code": "26302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/QUANG NINH": {
    "msb": { "code": "22302002" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/SO GIAO DICH": {
    "msb": { "code": "01302005" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/TAN BINH": {
    "msb": { "code": "79302002" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/THAI BINH": {
    "msb": { "code": "34302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/THANH HOA": {
    "msb": { "code": "38302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/THANH XUAN": {
    "msb": { "code": "01302002" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/TRU SO CHINH": {
    "msb": { "code": "01302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/VINH PHUC": {
    "msb": { "code": "26302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/VUNG TAU": {
    "msb": { "code": "77302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/BAC NINH": {
    "msb": { "code": "27302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/BAI CHAY": {
    "msb": { "code": "22302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/DONG NAI": {
    "msb": { "code": "75302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/HA NOI": {
    "msb": { "code": "01302003" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/SAI GON": {
    "msb": { "code": "79302004" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/THAI NGUYEN": {
    "msb": { "code": "19302001" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MSB/LE CHAN": {
    "msb": { "code": "31302003" },
    "techcombank": {
      "bank": "HANG HAI (MARITIMEBANK-MSB)",
      "region": "Ca nuoc",
      "branch": "HANG HAI (MARITIMEBANK-MSB)-302"
    }
  },
  "MAYBANK/HA NOI (HN)": {
    "msb": { "code": "01609001" },
    "techcombank": {
      "bank": "MAY BANK HA NOI",
      "region": "Ca nuoc",
      "branch": "MAY BANK HA NOI-609"
    }
  },
  "MB/AN PHU": {
    "msb": { "code": "79311003" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/BAC SAI GON": {
    "msb": { "code": "79311002" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/BINH DINH": {
    "msb": { "code": "52311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/CHO LON": {
    "msb": { "code": "79311007" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/DAC LAK": {
    "msb": { "code": "66311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/DIENBIEN PHU": {
    "msb": { "code": "01311002" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/DONG NAI": {
    "msb": { "code": "75311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/HA NOI (HN)": {
    "msb": { "code": "01311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/HAI BA TRUNG": {
    "msb": { "code": "01311007" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/HAI PHONG": {
    "msb": { "code": "01311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/HO CHI MINH (HCM)": {
    "msb": { "code": "79311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/HOA BINH": {
    "msb": { "code": "01311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/HOAN KIEM": {
    "msb": { "code": "01311013" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/HUE": {
    "msb": { "code": "46311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/KHANH HOA": {
    "msb": { "code": "56311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/LONG BIEN": {
    "msb": { "code": "01311008" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/MY DINH": {
    "msb": { "code": "01311014" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/NGHE AN": {
    "msb": { "code": "40311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/NINH BINH": {
    "msb": { "code": "37311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/PHU NHUAN": {
    "msb": { "code": "79311006" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/QUANG NGAI": {
    "msb": { "code": "51311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/QUANG NINH": {
    "msb": { "code": "22311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/SAI GON": {
    "msb": { "code": "79311005" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/SO GIAO DICH (SGD)": {
    "msb": { "code": "01311003" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/TAY HA NOI": {
    "msb": { "code": "01311012" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/THANG LONG": {
    "msb": { "code": "01311006" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/TRAN DUY HUNG": {
    "msb": { "code": "01311010" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/VIET TRI": {
    "msb": { "code": "25311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MB/VUNG TAU": {
    "msb": { "code": "77311001" },
    "techcombank": {
      "bank": "QUAN DOI (MB)",
      "region": "Ca nuoc",
      "branch": "QUAN DOI (MB)-311"
    }
  },
  "MEGA ICBC/HO CHI MINH (HCM)": {
    "msb": { "code": "79623001" },
    "techcombank": {
      "bank": "MEGA ICBC",
      "region": "Ca nuoc",
      "branch": "MEGA ICBC-623"
    }
  },
  "MIZUHO/HA NOI (HN)": {
    "msb": { "code": "01613001" },
    "techcombank": {
      "bank": "MIZUHO CN HA NOI",
      "region": "Ca nuoc",
      "branch": "MIZUHO CN HA NOI-613"
    }
  },
  "MIZUHO/HO CHI MINH (HCM)": {
    "msb": { "code": "79639001" },
    "techcombank": {
      "bank": "MIZUHO CN HO CHI MINH",
      "region": "Ca nuoc",
      "branch": "MIZUHO CN HO CHI MINH-639"
    }
  },
  "MUFG BANK/HA NOI (HN)": {
    "msb": { "code": "01653001" },
    "techcombank": {
      "bank": "MUFG Bank  Ltd CN HA NOI",
      "region": "Ca nuoc",
      "branch": "MUFG Bank  Ltd CN HA NOI-653"
    }
  },
  "MUFG BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79622001" },
    "techcombank": {
      "bank": "MUFG Bank  Ltd CN HCM",
      "region": "Ca nuoc",
      "branch": "MUFG Bank  Ltd CN HCM-622"
    }
  },
  "NAB/AN DONG": {
    "msb": { "code": "79306004" },
    "techcombank": null
  },
  "NAB/BEN THANH": {
    "msb": { "code": "79306010" },
    "techcombank": null
  },
  "NAB/BINH DUONG": {
    "msb": { "code": "74306001" },
    "techcombank": null
  },
  "NAB/BINH PHUOC": {
    "msb": { "code": "70306001" },
    "techcombank": null
  },
  "NAB/BINH TAY": {
    "msb": { "code": "79306001" },
    "techcombank": null
  },
  "NAB/DA NANG": {
    "msb": { "code": "48306001" },
    "techcombank": null
  },
  "NAB/HA NOI (HN)": {
    "msb": { "code": "01306001" },
    "techcombank": null
  },
  "NAB/HO CHI MINH (HCM)": {
    "msb": { "code": "79306001" },
    "techcombank": null
  },
  "NAB/NGA BAY": {
    "msb": { "code": "79306006" },
    "techcombank": null
  },
  "NAB/NHA TRANG": {
    "msb": { "code": "56306001" },
    "techcombank": null
  },
  "NAB/QUANG TRUNG": {
    "msb": { "code": "79306007" },
    "techcombank": null
  },
  "NAB/QUY NHON": {
    "msb": { "code": "52306001" },
    "techcombank": null
  },
  "NAB/TAN DINH": {
    "msb": { "code": "79306009" },
    "techcombank": null
  },
  "NAB/THI NGHE": {
    "msb": { "code": "79306005" },
    "techcombank": null
  },
  "NAB/THU DUC": {
    "msb": { "code": "79306003" },
    "techcombank": null
  },
  "NAB/TRUONG CHINH": {
    "msb": { "code": "79306002" },
    "techcombank": null
  },
  "NAB/VAN THANH": {
    "msb": { "code": "79306011" },
    "techcombank": null
  },
  "NASBANK/CAT LINH": {
    "msb": { "code": "01313005" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/CAU GIAY": {
    "msb": { "code": "01313006" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/DBSCL": {
    "msb": { "code": "92313001" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/HA NOI (HN)": {
    "msb": { "code": "01313001" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/HA TINH": {
    "msb": { "code": "42313001" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/HANG DAU": {
    "msb": { "code": "01313003" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79313001" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/HOI SO CHINH": {
    "msb": { "code": "40313001" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/KIEN GIANG": {
    "msb": { "code": "91313001" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/KIM LIEN": {
    "msb": { "code": "01313007" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/PHUONG MAI": {
    "msb": { "code": "01313004" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/THAI HA": {
    "msb": { "code": "01313002" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NASBANK/THANH HOA": {
    "msb": { "code": "38313001" },
    "techcombank": {
      "bank": "BAC A (NASB)",
      "region": "Ca nuoc",
      "branch": "BAC A (NASB)-313"
    }
  },
  "NCB/AN GIANG": {
    "msb": { "code": "89352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/BA RIA VUNG TAU": {
    "msb": { "code": "77352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/BAC GIANG": {
    "msb": { "code": "24352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/BAC LIEU": {
    "msb": { "code": "95352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/BAC NINH": {
    "msb": { "code": "27352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/BINH DUONG": {
    "msb": { "code": "74352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/BINH DUONG PGD SO 15": {
    "msb": { "code": "74352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/CA MAU": {
    "msb": { "code": "96352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/CAN THO": {
    "msb": { "code": "92352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/CAN THO PGD SO 02": {
    "msb": { "code": "86352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/DA NANG": {
    "msb": { "code": "48352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/DA NANG  PGD SO 5": {
    "msb": { "code": "46352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/DONGNAI": {
    "msb": { "code": "75352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/HA NOI (HN)": {
    "msb": { "code": "01352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/HAI PHONG": {
    "msb": { "code": "31352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/HOI SO CHINH": {
    "msb": { "code": "01352002" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/HUNG YEN": {
    "msb": { "code": "33352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/KGG 07": {
    "msb": { "code": "95352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/KIEN GIANG": {
    "msb": { "code": "91352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/LONG AN": {
    "msb": { "code": "80352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/SO GIAO DICH (SGD)": {
    "msb": { "code": "79352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/THAI BINH PGD SO 9": {
    "msb": { "code": "34352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/THAI NGUYEN": {
    "msb": { "code": "19352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/THUA THIEN - HUE": {
    "msb": { "code": "46352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/TIEN GIANG": {
    "msb": { "code": "82352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NCB/VINH LONG": {
    "msb": { "code": "86352001" },
    "techcombank": {
      "bank": "QUOC DAN (NCB)",
      "region": "Ca nuoc",
      "branch": "QUOC DAN (NCB)-352"
    }
  },
  "NH CONG NGHIEP HAN QUOC (IBK)/HA NOI": {
    "msb": { "code": "01652001" },
    "techcombank": {
      "bank": "INDUSTRIAL BANK OF KOREA HA NOI (IBK)",
      "region": "Ca nuoc",
      "branch": "INDUSTRIAL BANK OF KOREA HA NOI (IBK)-652"
    }
  },
  "NH CONG NGHIEP HAN QUOC (IBK)/HCM": {
    "msb": { "code": "79641001" },
    "techcombank": {
      "bank": "INDUSTRIAL BANK OF KOREA HO CHI MINH (IBK)",
      "region": "Ca nuoc",
      "branch": "INDUSTRIAL BANK OF KOREA HO CHI MINH (IBK)-641"
    }
  },
  "NH HOP TAC/(CO-OPBANK)": {
    "msb": { "code": "01901001" },
    "techcombank": {
      "bank": "HOP TAC (CO-OPBANK)",
      "region": "Ca nuoc",
      "branch": "HOP TAC (CO-OPBANK)-901"
    }
  },
  "NH HOP TAC/CN THAI BINH": {
    "msb": { "code": "34901001" },
    "techcombank": {
      "bank": "HOP TAC (CO-OPBANK)",
      "region": "Ca nuoc",
      "branch": "HOP TAC (CO-OPBANK)-901"
    }
  },
  "NH XAY DUNG/AN GIANG": {
    "msb": { "code": "89339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/BEN TRE": {
    "msb": { "code": "83339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/CAN THO": {
    "msb": { "code": "92339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/DA NANG": {
    "msb": { "code": "48339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/DONG NAI": {
    "msb": { "code": "75339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/HA NOI (HN)": {
    "msb": { "code": "01339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/HOI SO CHINH (HSC)": {
    "msb": { "code": "80339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/LAM GIANG": {
    "msb": { "code": "79339002" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/LONG AN": {
    "msb": { "code": "80339002" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/RACH KIEN": {
    "msb": { "code": "80339003" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/SAI GON": {
    "msb": { "code": "79339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/SO GIAO DICH (SGD)": {
    "msb": { "code": "80339004" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/TIEN GIANG": {
    "msb": { "code": "82339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/VINH LONG": {
    "msb": { "code": "86339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NH XAY DUNG/VUNG TAU": {
    "msb": { "code": "77339001" },
    "techcombank": {
      "bank": "XAY DUNG VIET NAM (VNCB)",
      "region": "Ca nuoc",
      "branch": "XAY DUNG VIET NAM (VNCB)-339"
    }
  },
  "NONGHYUP/HA NOI": {
    "msb": { "code": "01662001" },
    "techcombank": {
      "bank": "NONG HYUP CN HA NOI",
      "region": "Ca nuoc",
      "branch": "NONG HYUP CN HA NOI-662"
    }
  },
  "OCB/AN GIANG": {
    "msb": { "code": "89333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/BAC LIEU": {
    "msb": { "code": "95333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/BEN THANH": {
    "msb": { "code": "79333006" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/BINH DUONG": {
    "msb": { "code": "74333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/CA MAU": {
    "msb": { "code": "96333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/CHO LON": {
    "msb": { "code": "79333004" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/DAKLAK": {
    "msb": { "code": "66333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/DONG NAI": {
    "msb": { "code": "75333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/GIA DINH": {
    "msb": { "code": "79333003" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/HA NOI (HN)": {
    "msb": { "code": "01333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/HO CHI MINH (HCM)": {
    "msb": { "code": "79333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/HOA AN": {
    "msb": { "code": "93333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/KHANH HOA": {
    "msb": { "code": "56333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/KIEN GIANG": {
    "msb": { "code": "91333002" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/LONG AN": {
    "msb": { "code": "80333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/PHU LAM": {
    "msb": { "code": "79333005" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/PHU NHUAN": {
    "msb": { "code": "79333002" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/QUAN 4": {
    "msb": { "code": "79333010" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/SO GIAO DICH (SGD)": {
    "msb": { "code": "79333009" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/SOCTRANG": {
    "msb": { "code": "94333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/TAN BINH": {
    "msb": { "code": "79333011" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/TAN THUAN": {
    "msb": { "code": "79333008" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/TAY DO": {
    "msb": { "code": "92333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/THU DUC": {
    "msb": { "code": "79333007" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCB/TRUNG VIET": {
    "msb": { "code": "48333001" },
    "techcombank": {
      "bank": "PHUONG DONG (OCB)",
      "region": "Ca nuoc",
      "branch": "PHUONG DONG (OCB)-333"
    }
  },
  "OCBC/HO CHI MINH (HCM)": {
    "msb": { "code": "79625001" },
    "techcombank": {
      "bank": "OVERSEA-CHINESE (OCBC)",
      "region": "Ca nuoc",
      "branch": "OVERSEA-CHINESE (OCBC)-625"
    }
  },
  "OCEANBANK/CA MAU": {
    "msb": { "code": "96319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/CAN THO": {
    "msb": { "code": "92319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/DA NANG": {
    "msb": { "code": "48319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/HA NOI (HN)": {
    "msb": { "code": "01319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/HAI DUONG": {
    "msb": { "code": "30319002" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/HAI PHONG": {
    "msb": { "code": "31319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79319002" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/QUANG NGAI": {
    "msb": { "code": "51319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/QUANG NINH": {
    "msb": { "code": "22319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/SAI GON": {
    "msb": { "code": "79319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/THANG LONG": {
    "msb": { "code": "01319002" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/VINH": {
    "msb": { "code": "40319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "OCEANBANK/VUNG TAU": {
    "msb": { "code": "77319001" },
    "techcombank": {
      "bank": "DAI DUONG (OCEAN BANK)",
      "region": "Ca nuoc",
      "branch": "DAI DUONG (OCEAN BANK)-319"
    }
  },
  "PGBANK/AN GIANG": {
    "msb": { "code": "89341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/BA RIA VUNG TAU": {
    "msb": { "code": "77341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/BAC NINH": {
    "msb": { "code": "27341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/BINH DUONG": {
    "msb": { "code": "74341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/CAN THO": {
    "msb": { "code": "92341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/DA NANG": {
    "msb": { "code": "48341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/DONG NAI": {
    "msb": { "code": "75341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/DONG THAP": {
    "msb": { "code": "87341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/HA NOI (HN)": {
    "msb": { "code": "01341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/HAI DUONG": {
    "msb": { "code": "30341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/HAI PHONG": {
    "msb": { "code": "31341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/HOI SO CHINH (HSC)": {
    "msb": { "code": "01341003" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/KHANH HOA": {
    "msb": { "code": "56341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/LONG AN": {
    "msb": { "code": "80341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/QUANG NINH": {
    "msb": { "code": "22341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/SAI GON": {
    "msb": { "code": "79341001" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PGBANK/THANG LONG": {
    "msb": { "code": "01341002" },
    "techcombank": {
      "bank": "XANG DAU PETROLIMEX (PGBANK)",
      "region": "Ca nuoc",
      "branch": "XANG DAU PETROLIMEX (PGBANK)-341"
    }
  },
  "PVCOMBANK/AN GIANG": {
    "msb": { "code": "89360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/BA RIA VUNG TAU": {
    "msb": { "code": "77360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/BAC NINH": {
    "msb": { "code": "27360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/BINH DUONG": {
    "msb": { "code": "74360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/CA MAU": {
    "msb": { "code": "96360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/CAN THO": {
    "msb": { "code": "92360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/DA LAT": {
    "msb": { "code": "68360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/DA NANG": {
    "msb": { "code": "48360002" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/DONG NAI": {
    "msb": { "code": "75360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/HA NOI": {
    "msb": { "code": "01360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/HAI PHONG": {
    "msb": { "code": "31360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/NAM DINH": {
    "msb": { "code": "36360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/QUANG NGAI": {
    "msb": { "code": "51360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/SAI GON": {
    "msb": { "code": "79360002" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/SAI GON GIA DINH": {
    "msb": { "code": "79360003" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/SO GIAO DICH": {
    "msb": { "code": "01360002" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/SONG HAN": {
    "msb": { "code": "48360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/TAY DO": {
    "msb": { "code": "92360002" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/THANG LONG": {
    "msb": { "code": "01360003" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/THANH HOA": {
    "msb": { "code": "38360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/TIEN GIANG": {
    "msb": { "code": "82360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/VINH LONG": {
    "msb": { "code": "86360001" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "PVCOMBANK/VUNG TAU": {
    "msb": { "code": "77360002" },
    "techcombank": {
      "bank": "DAI CHUNG VN (PVCOMBANK)",
      "region": "Ca nuoc",
      "branch": "DAI CHUNG VN (PVCOMBANK)-360"
    }
  },
  "SACOMBANK/8 THANG 3 (HCM)": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/8-3 HA NOI (HN)": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/AN GIANG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BA RIA VUNG TAU": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BAC LIEU": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BAC NINH": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BEN TRE": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BINH DINH": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BINH DUONG": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BINH PHUOC": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BINH TAY": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BINH THANH": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/BINH THUAN": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/CA MAU": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/CAN THO": {
    "msb": { "code": "92303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/CHO LON": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/CONG TY CHO THUE TAI CHINH": {
    "msb": { "code": "79303500" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/CUCHI": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/DA NANG": {
    "msb": { "code": "48303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/DAK NONG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/DAKLAK": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/DIEN BIEN PHU": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/DONG DA": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/DONG DO": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/DONG NAI": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/DONG THAP": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/GIA LAI": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/GO VAP": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HA NAM": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HA NOI (HN)": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HAI DUONG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HAI PHONG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HAU GIANG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HOA VIET": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HOC MON": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HUNG DAO": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/HUNG YEN": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/KHANH HOA": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/KIEN GIANG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/KONTUM": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/LAM DONG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/LANG SON": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/LONG AN": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/LONG BIEN": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/NGHE AN": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/NINH THUAN": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/PHU QUOC": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/PHU THO": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/PHU YEN": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/QUAN 4": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/QUAN 8": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/QUANG BINH": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/QUANG NAM": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/QUANG NGAI": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/QUANG NINH": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/QUANG TRI": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/SAI GON": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/SO GIAO DICH (SGD)": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/SOC TRANG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/TAN BINH": {
    "msb": { "code": "79303008" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/TAN PHU": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/TAY NINH": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/THAI NGUYEN": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/THANG LONG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/THANH HOA": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/THANH TRI": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/THU DO": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/THU DUC": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/THUA THIEN HUE": {
    "msb": { "code": "79303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/TIEN GIANG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/TRA VINH": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SACOMBANK/VINH LONG": {
    "msb": { "code": "01303001" },
    "techcombank": {
      "bank": "SAI GON THUONG TIN (SACOMBANK)",
      "region": "Ca nuoc",
      "branch": "SAI GON THUONG TIN (SACOMBANK)-303"
    }
  },
  "SAI GON CONG THUONG/SOC TRANG": {
    "msb": { "code": "94308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "SOC-TRANG",
      "branch": "SAI GON CONG THUONG CN SOC TRANG-94308001"
    }
  },
  "SAIGON BANK/BA DINH": {
    "msb": { "code": "01308006" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HA-NOI",
      "branch": "SAI GON CONG THUONG CN BA DINH-01308006"
    }
  },
  "SAIGON BANK/CAU GIAY": {
    "msb": { "code": "01308003" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HA-NOI",
      "branch": "SAI GON CONG THUONG CN CAU GIAY-01308003"
    }
  },
  "SAIGON BANK/DA NANG": {
    "msb": { "code": "48308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "DA-NANG",
      "branch": "SAI GON CONG THUONG CN DA NANG-48308001"
    }
  },
  "SAIGON BANK/DONG DA": {
    "msb": { "code": "01308004" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HA-NOI",
      "branch": "SAI GON CONG THUONG CN DONG DA-01308004"
    }
  },
  "SAIGON BANK/HA NOI (HN)": {
    "msb": { "code": "01308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HA-NOI",
      "branch": "SAI GON CONG THUONG CN HA NOI-01308001"
    }
  },
  "SAIGON BANK/HAI PHONG": {
    "msb": { "code": "31308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HAI-PHONG",
      "branch": "SAI GON CONG THUONG CN HAI PHONG-31308001"
    }
  },
  "SAIGON BANK/HOAN KIEM": {
    "msb": { "code": "01308005" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HA-NOI",
      "branch": "SAI GON CONG THUONG CN HOAN KIEM-01308005"
    }
  },
  "SAIGON BANK/HUE": {
    "msb": { "code": "46308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "THUATHIEN-HUE",
      "branch": "SAI GON CONG THUONG CN HUE-46308001"
    }
  },
  "SAIGON BANK/LAO CAI": {
    "msb": { "code": "10308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "LAO-CAI",
      "branch": "SAI GON CONG THUONG CN LAO CAI-10308001"
    }
  },
  "SAIGON BANK/LONG BIEN": {
    "msb": { "code": "01308002" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HA-NOI",
      "branch": "SAI GON CONG THUONG CN LONG BIEN-01308002"
    }
  },
  "SAIGON BANK/QUANG NINH": {
    "msb": { "code": "22308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "QUANG-NINH",
      "branch": "SAI GON CONG THUONG QUANG NINH-22308001"
    }
  },
  "SAIGON BANK/3 THANG 2": {
    "msb": { "code": "79308011" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN 3 THANG 2-79308011"
    }
  },
  "SAIGON BANK/AN DONG": {
    "msb": { "code": "79308012" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN KHANH HOI-79308012"
    }
  },
  "SAIGON BANK/AN GIANG": {
    "msb": { "code": "89308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "AN-GIANG",
      "branch": "SAI GON CONG THUONG CN AN GIANG-89308001"
    }
  },
  "SAIGON BANK/BA CHIEU": {
    "msb": { "code": "79308009" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN BA CHIEU-79308009"
    }
  },
  "SAIGON BANK/BAC LIEU": {
    "msb": { "code": "95308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "BAC-LIEU",
      "branch": "SAI GON CONG THUONG CN BAC LIEU-95308001"
    }
  },
  "SAIGON BANK/BEN NGHE": {
    "msb": { "code": "79308004" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN QUAN 7-79308004"
    }
  },
  "SAIGON BANK/BINH CHANH": {
    "msb": { "code": "79308005" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG BINH CHANH-79308005"
    }
  },
  "SAIGON BANK/BINH DUONG": {
    "msb": { "code": "74308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "BINH-DUONG",
      "branch": "SAI GON CONG THUONG BINH DUONG-74308001"
    }
  },
  "SAIGON BANK/BINH HOA": {
    "msb": { "code": "79308008" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN BINH HOA-79308008"
    }
  },
  "SAIGON BANK/BINH THUAN": {
    "msb": { "code": "60308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "BINH-THUAN",
      "branch": "SAI GON CONG THUONG BINH THUAN-60308001"
    }
  },
  "SAIGON BANK/CA MAU": {
    "msb": { "code": "96308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "CA-MAU",
      "branch": "SAI GON CONG THUONG CN CA MAU-96308001"
    }
  },
  "SAIGON BANK/CAN THO": {
    "msb": { "code": "92308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "CAN-THO",
      "branch": "SAI GON CONG THUONG CN CAN THO-92308001"
    }
  },
  "SAIGON BANK/CHO LON": {
    "msb": { "code": "79308002" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN CHO LON-79308002"
    }
  },
  "SAIGON BANK/DAKLAK": {
    "msb": { "code": "66308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "DAC-LAK",
      "branch": "SAI GON CONG THUONG CN DAKLAK-66308001"
    }
  },
  "SAIGON BANK/DONG NAI": {
    "msb": { "code": "75308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "DONG-NAI",
      "branch": "SAI GON CONG THUONG CN DONG NAI-75308001"
    }
  },
  "SAIGON BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG HCM-79308001"
    }
  },
  "SAIGON BANK/TAN BINH": {
    "msb": { "code": "79308010" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN TAN BINH-79308010"
    }
  },
  "SAIGON BANK/TAN DINH": {
    "msb": { "code": "79308003" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN TAN DINH-79308003"
    }
  },
  "SAIGON BANK/TAN PHU": {
    "msb": { "code": "79308007" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN TAN PHU-79308007"
    }
  },
  "SAIGON BANK/THAI BINH HO CHI MINH (HCM)": {
    "msb": { "code": "79308006" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "HO-CHI-MINH",
      "branch": "SAI GON CONG THUONG CN THAI BINH-79308006"
    }
  },
  "SAIGON BANK/THOT NOT CT": {
    "msb": { "code": "92308002" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "CAN-THO",
      "branch": "SAI GON CONG THUONG CN THOT NOT-92308002"
    }
  },
  "SAIGON BANK/TIEN GIANG": {
    "msb": { "code": "82308001" },
    "techcombank": {
      "bank": "SAI GON CONG THUONG",
      "region": "TIEN-GIANG",
      "branch": "SAI GON CONG THUONG TIEN GIANG-82308001"
    }
  },
  "SCB/CN HAI BA TRUNG": {
    "msb": { "code": "01334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/20-10": {
    "msb": { "code": "79334008" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/AN DONG": {
    "msb": { "code": "79334003" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/AN GIANG": {
    "msb": { "code": "89334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/BA RIA - VUNG TAU": {
    "msb": { "code": "77334002" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/BAC NINH": {
    "msb": { "code": "27334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/BEN TRE": {
    "msb": { "code": "83334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/BINH DINH": {
    "msb": { "code": "52334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/BINH DUONG": {
    "msb": { "code": "74334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/BINH THUAN": {
    "msb": { "code": "60334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/CA MAU": {
    "msb": { "code": "96334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/CAN THO": {
    "msb": { "code": "92334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/CAU GIAY": {
    "msb": { "code": "01334002" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/CHO HAN": {
    "msb": { "code": "48334002" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/CU CHI": {
    "msb": { "code": "79334010" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/DA NANG": {
    "msb": { "code": "48334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/DAK LAK": {
    "msb": { "code": "66334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/DONG NAI": {
    "msb": { "code": "75334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/DONG THAP": {
    "msb": { "code": "87334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/GIA DINH": {
    "msb": { "code": "79334005" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/GIA LAI": {
    "msb": { "code": "64334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/HA NOI": {
    "msb": { "code": "01334004" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/HAI DUONG": {
    "msb": { "code": "30334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/HAI PHONG": {
    "msb": { "code": "31334002" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/HO CHI MINH (HCM)": {
    "msb": { "code": "79334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/HONG BANG": {
    "msb": { "code": "31334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/KHANH HOA": {
    "msb": { "code": "56334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/KIEN GIANG": {
    "msb": { "code": "91334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/LONG AN": {
    "msb": { "code": "80334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/NGHE AN": {
    "msb": { "code": "40334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/NHA RONG": {
    "msb": { "code": "79334004" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/NINH KIEU": {
    "msb": { "code": "92334002" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/QUAN 10": {
    "msb": { "code": "79334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/QUANG NINH": {
    "msb": { "code": "22334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/TAN AN": {
    "msb": { "code": "80334002" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/TAN BINH": {
    "msb": { "code": "79334006" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/TAN DINH": {
    "msb": { "code": "79334007" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/THANG LONG": {
    "msb": { "code": "01334003" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/TIEN GIANG": {
    "msb": { "code": "82334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/TRA VINH": {
    "msb": { "code": "84334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/VINH LONG": {
    "msb": { "code": "86334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SCB/VUNG TAU": {
    "msb": { "code": "77334001" },
    "techcombank": {
      "bank": "SAI GON (SCB)",
      "region": "Ca nuoc",
      "branch": "SAI GON (SCB)-334"
    }
  },
  "SEABANK/BA DINH": {
    "msb": { "code": "01317004" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/BAC NINH": {
    "msb": { "code": "27317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/BINH DUONG": {
    "msb": { "code": "74317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/CAN THO": {
    "msb": { "code": "92317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/CAU GIAY": {
    "msb": { "code": "01317005" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/CHO LON": {
    "msb": { "code": "79317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/DA NANG": {
    "msb": { "code": "48317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/DONG DA": {
    "msb": { "code": "01317006" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/HA DONG": {
    "msb": { "code": "01317008" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/HA NOI (HN)": {
    "msb": { "code": "01317002" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/HAI BA TRUNG": {
    "msb": { "code": "01317007" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/HAI DUONG": {
    "msb": { "code": "30317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/HAI PHONG": {
    "msb": { "code": "31317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79317002" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/HOI SO CHINH": {
    "msb": { "code": "01317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/LANG HA": {
    "msb": { "code": "01317003" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/NHA TRANG": {
    "msb": { "code": "56317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/QUANG NINH": {
    "msb": { "code": "22317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SEABANK/VUNG TAU": {
    "msb": { "code": "77317001" },
    "techcombank": {
      "bank": "DONG NAM A (SEA BANK)",
      "region": "Ca nuoc",
      "branch": "DONG NAM A (SEA BANK)-317"
    }
  },
  "SHB/AN GIANG": {
    "msb": { "code": "89348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/BINH DUONG": {
    "msb": { "code": "74348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/CAN THO": {
    "msb": { "code": "92348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/DA NANG": {
    "msb": { "code": "48348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/DONG NAI": {
    "msb": { "code": "75348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/GIALAI": {
    "msb": { "code": "64348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/HA NOI (HN)": {
    "msb": { "code": "01348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/HAI PHONG": {
    "msb": { "code": "31348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/HO CHI MINH (HCM)": {
    "msb": { "code": "79348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/HOI SO CHINH": {
    "msb": { "code": "01348002" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/HUNG YEN": {
    "msb": { "code": "33348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/KHANH HOA": {
    "msb": { "code": "56348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/KIEN GIANG": {
    "msb": { "code": "91348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/LAM DONG": {
    "msb": { "code": "68348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/NGHE AN": {
    "msb": { "code": "40348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/PHU NHUAN": {
    "msb": { "code": "79348002" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/QUANG NAM": {
    "msb": { "code": "49348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/QUANG NINH": {
    "msb": { "code": "22348001" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHB/SAI GON": {
    "msb": { "code": "79348003" },
    "techcombank": {
      "bank": "SAI GON - HA NOI (SHB)",
      "region": "Ca nuoc",
      "branch": "SAI GON - HA NOI (SHB)-348"
    }
  },
  "SHINHAN VIETNAM/BAC NINH": {
    "msb": { "code": "27616001" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/BIEN HOA": {
    "msb": { "code": "75616001" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/BINH DUONG": {
    "msb": { "code": "74616001" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/CN TRAN DUY HUNG": {
    "msb": { "code": "01616001" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/DONG NAI": {
    "msb": { "code": "75616002" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/HA NOI (HN)": {
    "msb": { "code": "01616002" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/HAI PHONG": {
    "msb": { "code": "31616001" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/HO CHI MINH (HCM)": {
    "msb": { "code": "79616002" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/HOI SO CHINH (HSC)": {
    "msb": { "code": "79616001" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SHINHAN VIETNAM/SONG THAN": {
    "msb": { "code": "74616002" },
    "techcombank": {
      "bank": "SHINHAN VIET NAM",
      "region": "Ca nuoc",
      "branch": "SHINHAN VIET NAM-616"
    }
  },
  "SMBC/HO CHI MINH (HCM)": {
    "msb": { "code": "79636001" },
    "techcombank": {
      "bank": "SUMITOMO MITSUI BANKING CORP",
      "region": "HO-CHI-MINH",
      "branch": "SUMITOMO MITSUI BANKING CORP HCM-79636001"
    }
  },
  "SOUTHERNBANK/AN GIANG": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/BINH THUAN": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/CAU GIAY": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/CHO LON": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/CHO LON  LONG AN": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/DA NANG": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/DAI NAM": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/DONG BANG SCL": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/DONG THAP": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/GIANG VO": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/GO VAP": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/HA NOI (HN)": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/HONG BANG": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/HUNG PHU": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/LONG AN": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/LONG BIEN": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/LONG MY": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/LY THAI TO": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/LY THUONG KIET": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/MINH PHUNG": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/NGUYEN VAN TROI": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/PASTEUR": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/QUAN 12": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/SAI GON": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/SG  BIEN HOA": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/THANH XUAN": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/TIEN GIANG": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/TRA VINH": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/VI THANH": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "SOUTHERNBANK/VINH LONG": {
    "msb": { "code": "79303001" },
    "techcombank": null
  },
  "STANDARD CHARTERED BANK/HO CHI MINH": {
    "msb": { "code": "79604001" },
    "techcombank": {
      "bank": "STANDARD CHARTERED",
      "region": "Ca nuoc",
      "branch": "STANDARD CHARTERED-604"
    }
  },
  "STANDARD CHARTERED BANK/HOI SO CHINH": {
    "msb": { "code": "01604002" },
    "techcombank": {
      "bank": "STANDARD CHARTERED",
      "region": "Ca nuoc",
      "branch": "STANDARD CHARTERED-604"
    }
  },
  "STANDARD CHARTERED BANK/LE DAI HANH": {
    "msb": { "code": "01604003" },
    "techcombank": {
      "bank": "STANDARD CHARTERED",
      "region": "Ca nuoc",
      "branch": "STANDARD CHARTERED-604"
    }
  },
  "STANDARD CHARTERED BANK/SO GIAO DICH HN": {
    "msb": { "code": "01604001" },
    "techcombank": {
      "bank": "STANDARD CHARTERED",
      "region": "Ca nuoc",
      "branch": "STANDARD CHARTERED-604"
    }
  },
  "SUMITOMO MITSUI BANKING CORPORATION/HN": {
    "msb": { "code": "01636001" },
    "techcombank": {
      "bank": "SUMITOMO MITSUI BANKING CORP",
      "region": "HA-NOI",
      "branch": "SUMITOMO MITSUI CN HA NOI-01636001"
    }
  },
  "TAIPEI FUBON/BINH DUONG (HO)": {
    "msb": { "code": "74655001" },
    "techcombank": {
      "bank": "TAIPEI FUBON CN BINH DUONG",
      "region": "Ca nuoc",
      "branch": "TAIPEI FUBON CN BINH DUONG-655"
    }
  },
  "TAIPEI FUBON/HA NOI (HN)": {
    "msb": { "code": "01642001" },
    "techcombank": {
      "bank": "TAIPEI FUBON CN HA NOI",
      "region": "Ca nuoc",
      "branch": "TAIPEI FUBON CN HA NOI-642"
    }
  },
  "TAIPEI FUBON/HO CHI MINH (HCM)": {
    "msb": { "code": "79651001" },
    "techcombank": {
      "bank": "TAIPEI FUBON CN HCM",
      "region": "Ca nuoc",
      "branch": "TAIPEI FUBON CN HCM-651"
    }
  },
  "TECHCOMBANK/AN GIANG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/BA DINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/BAC GIANG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/BAC NINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/BINH DUONG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/CHO LON": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/CHUONG DUONG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/DA NANG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/DAKLAK": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/DONG DO": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/DONG NAI": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/DONG THAP": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/GIA DINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HA NOI (HN)": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HA TAY": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HA TINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HAI BA TRUNG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HAI DUONG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HAI PHONG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HOAN KIEM": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HOANG QUOC VIET": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HOI SO CHINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HUE": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/HUNG YEN": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/LANG SON": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/LAO CAI": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/LONG AN": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/NAM DINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/NGHE AN": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/NHA TRANG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/NINH BINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/NOI BAI": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/PGD THANH HOA": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/PHU MY HUNG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/PHU NHUAN": {
    "msb": { "code": "79310009" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/PLEIKU": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/QUAN 3": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/QUAN 5": {
    "msb": { "code": "79310008" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/QUANG NAM - HOI AN": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/QUANG NGAI": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/QUANG NINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/QUANG TRUNG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/QUY NHON": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/TAN BINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/THAI BINH": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/THAI NGUYEN": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/THANG LONG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/THANH KHE": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/THU DUC": {
    "msb": { "code": "79310010" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/VIET TRI": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/VINH LONG": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/VINH PHUC": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TECHCOMBANK/VUNG TAU": {
    "msb": { "code": "01310001" },
    "techcombank": {
      "bank": "NH TMCP KY THUONG VN",
      "region": "Ca nuoc",
      "branch": "NH TMCP KY THUONG VN-310"
    }
  },
  "TPBANK/HA NOI": {
    "msb": { "code": "01358002" },
    "techcombank": {
      "bank": "TIEN PHONG (TPBANK)",
      "region": "Ca nuoc",
      "branch": "TIEN PHONG (TPBANK)-358"
    }
  },
  "TPBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79358001" },
    "techcombank": {
      "bank": "TIEN PHONG (TPBANK)",
      "region": "Ca nuoc",
      "branch": "TIEN PHONG (TPBANK)-358"
    }
  },
  "TPBANK/HOI SO CHINH (HSC)": {
    "msb": { "code": "01358001" },
    "techcombank": {
      "bank": "TIEN PHONG (TPBANK)",
      "region": "Ca nuoc",
      "branch": "TIEN PHONG (TPBANK)-358"
    }
  },
  "TPBANK/THANG LONG": {
    "msb": { "code": "01358004" },
    "techcombank": {
      "bank": "TIEN PHONG (TPBANK)",
      "region": "Ca nuoc",
      "branch": "TIEN PHONG (TPBANK)-358"
    }
  },
  "UOB/HO HO CHI MINH (HCM)": {
    "msb": { "code": "79665001" },
    "techcombank": {
      "bank": "UNITED OVERSEAS BANK VIET NAM",
      "region": "Ca nuoc",
      "branch": "UNITED OVERSEAS BANK VIET NAM-665"
    }
  },
  "VDB/BAC CAN": {
    "msb": { "code": "06208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/BAC LIEU": {
    "msb": { "code": "95208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/BAC NINH": {
    "msb": { "code": "27208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/BAC NINH - BAC GIANG": {
    "msb": { "code": "24208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/BINH DINH": {
    "msb": { "code": "52208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/BINH PHUOC": {
    "msb": { "code": "70208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/CAO BANG": {
    "msb": { "code": "04208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/DIEN BIEN": {
    "msb": { "code": "11208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/HA GIANG": {
    "msb": { "code": "02208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/HA TAY": {
    "msb": { "code": "01208003" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/HA TINH": {
    "msb": { "code": "42208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/HAI DUONG": {
    "msb": { "code": "30208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/HAI PHONG": {
    "msb": { "code": "31208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/HOA BINH": {
    "msb": { "code": "17208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/HOI SO CHINH (HSC)": {
    "msb": { "code": "01208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/KHANH HOA": {
    "msb": { "code": "56208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/KHU VUC DAKLAK DAC NONG": {
    "msb": { "code": "66208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/KHU VUC MINH HAI": {
    "msb": { "code": "96208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/KON TUM": {
    "msb": { "code": "01208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/KV BAC KAN - THAI NGUYEN": {
    "msb": { "code": "19208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/LAI CHAU": {
    "msb": { "code": "12208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/LAM DONG": {
    "msb": { "code": "68208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/LANG SON": {
    "msb": { "code": "20208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/LAO CAI": {
    "msb": { "code": "10208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/NAM DINH": {
    "msb": { "code": "36208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/NINH BINH": {
    "msb": { "code": "01208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/NINH THUAN": {
    "msb": { "code": "58208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/PHU THO": {
    "msb": { "code": "25208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/PHU YEN": {
    "msb": { "code": "54208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/QUANG NGAI": {
    "msb": { "code": "51208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/QUANG TRI": {
    "msb": { "code": "45208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/SO GIAO DICH 1 (SGD)": {
    "msb": { "code": "01208002" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/SO GIAO DICH 2 (SGD)": {
    "msb": { "code": "79208002" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/SOC TRANG": {
    "msb": { "code": "94208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/SON LA": {
    "msb": { "code": "14208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/TAY NINH": {
    "msb": { "code": "72208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/THAI BINH": {
    "msb": { "code": "34208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/TIEN GIANG": {
    "msb": { "code": "82208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/TRA VINH": {
    "msb": { "code": "84208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/TUYEN QUANG": {
    "msb": { "code": "08208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/VINH PHUC": {
    "msb": { "code": "26208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VDB/YEN BAI": {
    "msb": { "code": "15208001" },
    "techcombank": {
      "bank": "PHAT TRIEN VIET NAM (VDB)",
      "region": "Ca nuoc",
      "branch": "PHAT TRIEN VIET NAM (VDB)-208"
    }
  },
  "VIB/AN GIANG": {
    "msb": { "code": "89314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/BA DINH": {
    "msb": { "code": "01314005" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/CAM PHA": {
    "msb": { "code": "22314002" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/CAU GIAY": {
    "msb": { "code": "01314003" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/DA NANG": {
    "msb": { "code": "48314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/DONG DA": {
    "msb": { "code": "01314004" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/HA DONG": {
    "msb": { "code": "01314010" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/HAI BA TRUNG": {
    "msb": { "code": "01314009" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/HAI DUONG": {
    "msb": { "code": "30314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/HOAN KIEM": {
    "msb": { "code": "01314007" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/HUE": {
    "msb": { "code": "46314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/LONG BIEN": {
    "msb": { "code": "01314008" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/NHA TRANG": {
    "msb": { "code": "56314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/QUANG NGAI": {
    "msb": { "code": "51314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/QUANG NINH": {
    "msb": { "code": "22314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/QUY NHON": {
    "msb": { "code": "52314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/THAI BINH": {
    "msb": { "code": "34314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/THAI NGUYEN": {
    "msb": { "code": "19314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/THANH HOA": {
    "msb": { "code": "38314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/THANH XUAN": {
    "msb": { "code": "01314006" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/VIET TRI": {
    "msb": { "code": "25314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/VINH": {
    "msb": { "code": "40314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/VINH PHUC": {
    "msb": { "code": "26314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/BINH DUONG": {
    "msb": { "code": "74314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/CA MAU": {
    "msb": { "code": "96314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/CAN THO": {
    "msb": { "code": "92314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/DAKLAK": {
    "msb": { "code": "66314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/DONG NAI": {
    "msb": { "code": "75314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/DONG THAP": {
    "msb": { "code": "87314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/HAI PHONG": {
    "msb": { "code": "31314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/HO CHI MINH (HCM)": {
    "msb": { "code": "79314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/KIEN GIANG": {
    "msb": { "code": "91314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/LAM DONG": {
    "msb": { "code": "68314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/SAI GON": {
    "msb": { "code": "79314002" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/TAY NINH": {
    "msb": { "code": "72314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIB/VUNG TAU": {
    "msb": { "code": "77314001" },
    "techcombank": {
      "bank": "QUOC TE (VIB)",
      "region": "Ca nuoc",
      "branch": "QUOC TE (VIB)-314"
    }
  },
  "VIDPUBLIC BANK/BINH DUONG": {
    "msb": { "code": "74501001" },
    "techcombank": {
      "bank": "PUBLIC VIET NAM",
      "region": "Ca nuoc",
      "branch": "PUBLIC VIET NAM-501"
    }
  },
  "VIDPUBLIC BANK/CHO LON": {
    "msb": { "code": "79501002" },
    "techcombank": {
      "bank": "PUBLIC VIET NAM",
      "region": "Ca nuoc",
      "branch": "PUBLIC VIET NAM-501"
    }
  },
  "VIDPUBLIC BANK/DA NANG": {
    "msb": { "code": "48501001" },
    "techcombank": {
      "bank": "PUBLIC VIET NAM",
      "region": "Ca nuoc",
      "branch": "PUBLIC VIET NAM-501"
    }
  },
  "VIDPUBLIC BANK/DONG NAI": {
    "msb": { "code": "75501001" },
    "techcombank": {
      "bank": "PUBLIC VIET NAM",
      "region": "Ca nuoc",
      "branch": "PUBLIC VIET NAM-501"
    }
  },
  "VIDPUBLIC BANK/HA NOI (HN)": {
    "msb": { "code": "01501002" },
    "techcombank": {
      "bank": "PUBLIC VIET NAM",
      "region": "Ca nuoc",
      "branch": "PUBLIC VIET NAM-501"
    }
  },
  "VIDPUBLIC BANK/HAI PHONG": {
    "msb": { "code": "31501001" },
    "techcombank": {
      "bank": "PUBLIC VIET NAM",
      "region": "Ca nuoc",
      "branch": "PUBLIC VIET NAM-501"
    }
  },
  "VIDPUBLIC BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79501001" },
    "techcombank": {
      "bank": "PUBLIC VIET NAM",
      "region": "Ca nuoc",
      "branch": "PUBLIC VIET NAM-501"
    }
  },
  "VIDPUBLIC BANK/HOI SO CHINH (HSC)": {
    "msb": { "code": "01501001" },
    "techcombank": {
      "bank": "PUBLIC VIET NAM",
      "region": "Ca nuoc",
      "branch": "PUBLIC VIET NAM-501"
    }
  },
  "VIETABANK/BINH DUONG": {
    "msb": { "code": "01355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/AN GIANG": {
    "msb": { "code": "01355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/BAC LIEU": {
    "msb": { "code": "01355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/CAN THO": {
    "msb": { "code": "01355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/CHO LON": {
    "msb": { "code": "01355002" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/DA NANG": {
    "msb": { "code": "01355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/DONG NAI": {
    "msb": { "code": "75355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/HA NOI (HN)": {
    "msb": { "code": "01355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/HO CHI MINH (HCM)": {
    "msb": { "code": "01355002" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/HOI AN": {
    "msb": { "code": "01355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/HOI SO CHINH": {
    "msb": { "code": "01355002" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/HUYEN CU CHI": {
    "msb": { "code": "01355002" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/QUANG NGAI": {
    "msb": { "code": "01355001" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETABANK/SO GIAO DICH": {
    "msb": { "code": "01355002" },
    "techcombank": {
      "bank": "VIET A (VIETABANK)",
      "region": "Ca nuoc",
      "branch": "VIET A (VIETABANK)-355"
    }
  },
  "VIETBANK/BA RIA - VUNG TAU": {
    "msb": { "code": "77356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/CAN THO": {
    "msb": { "code": "92356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/DA NANG": {
    "msb": { "code": "48356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/HAI PHONG": {
    "msb": { "code": "31356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/HOI SO CHINH (HSC)": {
    "msb": { "code": "94356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/KHANH HOA": {
    "msb": { "code": "56356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/LONG AN": {
    "msb": { "code": "80356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/NGHE AN": {
    "msb": { "code": "40356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/SO GIAO DICH (SGD) HA NOI (HN)": {
    "msb": { "code": "01356001" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },
  "VIETBANK/SO GIAO DICH (SGD) SOC TRANG": {
    "msb": { "code": "94356002" },
    "techcombank": {
      "bank": "VIET NAM THUONG TIN (VIETBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THUONG TIN (VIETBANK)-356"
    }
  },

  "VCB/AN GIANG": {
    "msb": { "code": "89203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BA DINH": {
    "msb": { "code": "01203005" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BA RIA VUNG TAU": {
    "msb": { "code": "77203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BAC GIANG": {
    "msb": { "code": "24203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BAC LIEU": {
    "msb": { "code": "95203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BAC NINH": {
    "msb": { "code": "27203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BAC SAI GON": {
    "msb": { "code": "79203006" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BEN THANH": {
    "msb": { "code": "79203008" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BEN TRE": {
    "msb": { "code": "83203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BIEN HOA": {
    "msb": { "code": "75203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BINH DUONG": {
    "msb": { "code": "74203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BINH TAY": {
    "msb": { "code": "79203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BINH THANH": {
    "msb": { "code": "79203004" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/BINH THUAN": {
    "msb": { "code": "60203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/CA MAU": {
    "msb": { "code": "96203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/CAM RANH": {
    "msb": { "code": "56203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/CAN THO": {
    "msb": { "code": "92203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/CHAU DOC": {
    "msb": { "code": "89203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/CHUONG DUONG": {
    "msb": { "code": "01203007" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/CONG TY CHO THUE TAI CHINH": {
    "msb": { "code": "01203500" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/DA LAT": {
    "msb": { "code": "68203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/DA NANG": {
    "msb": { "code": "48203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/DAKLAK": {
    "msb": { "code": "66203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/DONG NAI": {
    "msb": { "code": "75203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/DONG THAP": {
    "msb": { "code": "87203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/DUNG QUAT": {
    "msb": { "code": "51203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/GIA LAI": {
    "msb": { "code": "64203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HA NAM": {
     "msb": null,
     "techcombank": {
            "bank": "NGOAI THUONG VN (VCB)",
            "region": "Ca nuoc",
            "branch": "NGOAI THUONG VN (VCB)-203"
     }
   },
  "VCB/HA LONG": {
    "msb": { "code": "22203003" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HA NOI (HN)": {
    "msb": { "code": "01203003" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HA TAY": {
    "msb": { "code": "01203009" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HA TINH": {
    "msb": { "code": "42203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HAI DUONG": {
    "msb": { "code": "30203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HAI PHONG": {
    "msb": { "code": "31203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HO CHI MINH (HCM)": {
    "msb": { "code": "79203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HOAN KIEM": {
    "msb": { "code": "01203008" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HUE": {
    "msb": { "code": "46203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/HUNG YEN": {
    "msb": { "code": "33203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/KCN BINH DUONG": {
    "msb": { "code": "74203003" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/KIEN GIANG": {
    "msb": { "code": "91203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/KONTUM": {
    "msb": { "code": "62203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/KY DONG": {
    "msb": { "code": "79203012" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/LAO CAI": {
    "msb": { "code": "10203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/LONG AN": {
    "msb": { "code": "80203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/MONG CAI": {
    "msb": { "code": "22203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/NAM SAI GON": {
    "msb": { "code": "79203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/NHA TRANG": {
    "msb": { "code": "56203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/NHON TRACH": {
    "msb": { "code": "75203003" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/PHU TAI": {
    "msb": { "code": "52203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/PHU THO": {
    "msb": { "code": "79203003" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/PHU YEN": {
    "msb": { "code": "54203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/QUAN 5": {
    "msb": { "code": "79203007" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/QUANG BINH": {
    "msb": { "code": "44203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/QUANG NAM": {
    "msb": { "code": "49203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/QUANG NGAI": {
    "msb": { "code": "51203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/QUANG NINH": {
    "msb": { "code": "22203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/QUANG TRI": {
    "msb": { "code": "45203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/QUY NHON": {
    "msb": { "code": "52203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/SO GIAO DICH (SGD)": {
    "msb": { "code": "01203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/SOC TRANG": {
    "msb": { "code": "94203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/SONG THAN": {
    "msb": { "code": "74203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/TAN BINH": {
    "msb": { "code": "79203010" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/TAN DINH": {
    "msb": { "code": "79203009" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/TAN THUAN": {
    "msb": { "code": "79203011" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/TAY NINH": {
    "msb": { "code": "72203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/THAI BINH": {
    "msb": { "code": "34203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/THANG LONG": {
    "msb": { "code": "01203004" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/THANH CONG": {
    "msb": { "code": "01203006" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/THANH XUAN": {
    "msb": { "code": "01203010" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/THU DUC": {
    "msb": { "code": "79203005" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/TIEN GIANG": {
    "msb": { "code": "82203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/TRA NOC": {
    "msb": { "code": "92203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/TRA VINH": {
    "msb": { "code": "84203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/VIET NAM": {
    "msb": { "code": "01203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/VIET TRI": {
    "msb": { "code": "25203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/VINH": {
    "msb": { "code": "40203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/VINH LOC": {
    "msb": { "code": "79203006" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/VINH LONG": {
    "msb": { "code": "86203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/VINH PHUC": {
    "msb": { "code": "26203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/XUAN AN HA TINH": {
    "msb": { "code": "42203002" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VCB/THANH HOA": {
    "msb": { "code": "01203001" },
    "techcombank": {
      "bank": "NGOAI THUONG VN (VCB)",
      "region": "Ca nuoc",
      "branch": "NGOAI THUONG VN (VCB)-203"
    }
  },
  "VIETINBANK/1 HO CHI MINH (HCM)": {
    "msb": { "code": "79201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/10 HO CHI MINH (HCM)": {
    "msb": { "code": "79201011" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/11 HO CHI MINH (HCM)": {
    "msb": { "code": "79201014" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/12 HO CHI MINH (HCM)": {
    "msb": { "code": "79201016" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/2 HO CHI MINH (HCM)": {
    "msb": { "code": "79201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/3 HO CHI MINH (HCM)": {
    "msb": { "code": "79201004" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/4 HO CHI MINH (HCM)": {
    "msb": { "code": "79201005" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/5 HO CHI MINH (HCM)": {
    "msb": { "code": "79201006" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/6 HO CHI MINH (HCM)": {
    "msb": { "code": "79201007" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/7 HO CHI MINH (HCM)": {
    "msb": { "code": "79201008" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/8 HO CHI MINH (HCM)": {
    "msb": { "code": "79201009" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/9 HO CHI MINH (HCM)": {
    "msb": { "code": "79201010" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/AN GIANG": {
    "msb": { "code": "89201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BA DINH": {
    "msb": { "code": "01201004" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BA RIA VUNG TAU": {
    "msb": { "code": "77201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAC CAN": {
    "msb": { "code": "06201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAC DA NANG": {
    "msb": { "code": "48201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAC GIANG": {
    "msb": { "code": "24201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAC HA NOI": {
    "msb": { "code": "01201009" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAC LIEU": {
    "msb": { "code": "95201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAC NGHE AN": {
    "msb": { "code": "40201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAC NINH": {
    "msb": { "code": "27201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAI CHAY": {
    "msb": { "code": "22201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BAO LOC": {
    "msb": { "code": "68201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BEN LUC": {
    "msb": { "code": "80201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BEN THUY": {
    "msb": { "code": "40201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BEN TRE": {
    "msb": { "code": "83201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BIM SON": {
    "msb": { "code": "38201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BINH DINH": {
    "msb": { "code": "52201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BINH DUONG": {
    "msb": { "code": "74201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BINH PHUOC": {
    "msb": { "code": "70201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BINH THUAN": {
    "msb": { "code": "60201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/BINH XUYEN": {
    "msb": { "code": "26201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CA MAU": {
    "msb": { "code": "96201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CAM PHA": {
    "msb": { "code": "22201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CAN THO": {
    "msb": { "code": "92201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CAO BANG": {
    "msb": { "code": "04201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CHAU DOC": {
    "msb": { "code": "89201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CHAU THANH": {
    "msb": { "code": "01201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CHUONG DUONG": {
    "msb": { "code": "01201005" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CN TAY SAI GON": {
    "msb": { "code": "79201012" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CONG TY CHO THUE TAI CHINH": {
    "msb": { "code": "01201500" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CU CHI": {
    "msb": { "code": "79201019" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/CUA LO": {
    "msb": { "code": "40201004" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DA NANG": {
    "msb": { "code": "48201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DAKLAK": {
    "msb": { "code": "66201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DEN HUNG": {
    "msb": { "code": "25201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DIEN BIEN": {
    "msb": { "code": "11201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DO SON": {
    "msb": { "code": "31201005" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DONG ANH": {
    "msb": { "code": "01201006" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DONG DA": {
    "msb": { "code": "01201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DONG HA NOI": {
    "msb": { "code": "01201010" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DONG NAI": {
    "msb": { "code": "75201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DONG SAI GON": {
    "msb": { "code": "79201015" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/DONG THAP": {
    "msb": { "code": "87201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/GIA LAI": {
    "msb": { "code": "64201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HA GIANG": {
    "msb": { "code": "02201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HA NAM": {
    "msb": { "code": "35201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HA NOI (HN)": {
    "msb": { "code": "01201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HA TAY": {
    "msb": { "code": "01201019" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HA TINH": {
    "msb": { "code": "42201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HAI BA TRUNG": {
    "msb": { "code": "01201012" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HAI DUONG": {
    "msb": { "code": "30201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HAI PHONG": {
    "msb": { "code": "31201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HOA BINH": {
    "msb": { "code": "17201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HOA THANH": {
    "msb": { "code": "72201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HOAN KIEM": {
    "msb": { "code": "01201011" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HOANG MAI": {
    "msb": { "code": "01201014" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HOI AN": {
    "msb": { "code": "49201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HONG BANG": {
    "msb": { "code": "31201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/HUNG YEN": {
    "msb": { "code": "33201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KCN BIEN HOA": {
    "msb": { "code": "75201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KCN BINH DUONG": {
    "msb": { "code": "74201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KCN HAI DUONG": {
    "msb": { "code": "30201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KCN PHU TAI": {
    "msb": { "code": "52201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KCN QUE VO": {
    "msb": { "code": "27201004" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KCN TIEN SON": {
    "msb": { "code": "27201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KCN TRA NOC": {
    "msb": { "code": "92201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KCN TRANG BANG": {
    "msb": { "code": "72201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KHANH HOA": {
    "msb": { "code": "56201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KIEN AN": {
    "msb": { "code": "31201007" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KIEN GIANG": {
    "msb": { "code": "91201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/KON TUM": {
    "msb": { "code": "62201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/LAI CHAU": {
    "msb": { "code": "12201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/LAM DONG": {
    "msb": { "code": "68201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/LANG HOA LAC": {
    "msb": { "code": "01201018" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/LANG SON": {
    "msb": { "code": "20201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/LAO CAI": {
    "msb": { "code": "10201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/LE CHAN": {
    "msb": { "code": "31201004" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/LONG AN": {
    "msb": { "code": "80201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/LUU XA": {
    "msb": { "code": "19201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/MONG CAI": {
    "msb": { "code": "22201004" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/MY HAO": {
    "msb": { "code": "33201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NAM DINH": {
    "msb": { "code": "36201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NAM SAI GON": {
    "msb": { "code": "79201020" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NAM THANG LONG": {
    "msb": { "code": "01201008" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NAM VIET TRI": {
    "msb": { "code": "25201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NGHE AN": {
    "msb": { "code": "40201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NGO QUYEN": {
    "msb": { "code": "31201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NGU HANH SON": {
    "msb": { "code": "48201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NGUYEN TRAI": {
    "msb": { "code": "01201017" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NHA BE": {
    "msb": { "code": "79201018" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NHI CHIEU": {
    "msb": { "code": "30201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NHON TRACH": {
    "msb": { "code": "75201004" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NINH BINH": {
    "msb": { "code": "37201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/NINH THUAN": {
    "msb": { "code": "58201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/PHU BAI": {
    "msb": { "code": "46201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/PHU THO": {
    "msb": { "code": "25201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/PHU YEN": {
    "msb": { "code": "54201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/PHUC YEN": {
    "msb": { "code": "26201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/QUANG BINH": {
    "msb": { "code": "44201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/QUANG MINH": {
    "msb": { "code": "01201025" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/QUANG NAM": {
    "msb": { "code": "49201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/QUANG NGAI": {
    "msb": { "code": "51201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/QUANG NINH": {
    "msb": { "code": "22201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/QUANG TRI": {
    "msb": { "code": "45201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/QUANG TRUNG": {
    "msb": { "code": "01201016" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/SA DEC": {
    "msb": { "code": "87201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/SAM SON": {
    "msb": { "code": "38201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/SOC TRANG": {
    "msb": { "code": "94201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/SON LA": {
    "msb": { "code": "14201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/SONG CONG": {
    "msb": { "code": "19201003" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/SONG NHUE": {
    "msb": { "code": "01201015" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TAM DIEP": {
    "msb": { "code": "37201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TAN BINH": {
    "msb": { "code": "79201017" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TAY HA NOI": {
    "msb": { "code": "01201013" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TAY NINH": {
    "msb": { "code": "72201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TAY TIEN GIANG": {
    "msb": { "code": "82201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/THAI BINH": {
    "msb": { "code": "34201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/THAI NGUYEN": {
    "msb": { "code": "19201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/THANH HOA": {
    "msb": { "code": "38201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/THANH XUAN": {
    "msb": { "code": "01201007" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/THU DUC": {
    "msb": { "code": "79201013" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/THU THIEM": {
    "msb": { "code": "79201021" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/THUA THIEN HUE": {
    "msb": { "code": "46201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TIEN GIANG": {
    "msb": { "code": "82201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TIEN SON": {
    "msb": { "code": "27201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TO HIEU": {
    "msb": { "code": "31201006" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TP NAM DINH": {
    "msb": { "code": "36201002" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TRA VINH": {
    "msb": { "code": "84201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TUYEN QUANG": {
    "msb": { "code": "08201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/TX PHU THO": {
    "msb": { "code": "25201004" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/UONG BI": {
    "msb": { "code": "22201005" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/VIET NAM": {
    "msb": { "code": "01201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/VINH LONG": {
    "msb": { "code": "86201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/VINH PHUC": {
    "msb": { "code": "26201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VIETINBANK/YEN BAI": {
    "msb": { "code": "15201001" },
    "techcombank": {
      "bank": "CONG THUONG VN (VIETINBANK)",
      "region": "Ca nuoc",
      "branch": "CONG THUONG VN (VIETINBANK)-201"
    }
  },
  "VPBANK/AN GIANG": {
    "msb": { "code": "89309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/BAC GIANG": {
    "msb": { "code": "24309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/BAC NINH": {
    "msb": { "code": "27309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/BINH DINH": {
    "msb": { "code": "52309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/BINH THUAN": {
    "msb": { "code": "60309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/DONG NAI": {
    "msb": { "code": "75309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/DONG THAP": {
    "msb": { "code": "87309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/HA NOI (HN)": {
    "msb": { "code": "01309009" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/HA TINH": {
    "msb": { "code": "42309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/HAI DUONG": {
    "msb": { "code": "30309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/HAI PHONG": {
    "msb": { "code": "01309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/HO CHI MINH (HCM)": {
    "msb": { "code": "79309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/HOA BINH": {
    "msb": { "code": "17309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/HOI SO CHINH (HSC)": {
    "msb": { "code": "01309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/HUE": {
    "msb": { "code": "46309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/KIEN GIANG": {
    "msb": { "code": "91309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/LONG AN": {
    "msb": { "code": "80309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/NAM DINH": {
    "msb": { "code": "36309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/NGHE AN": {
    "msb": { "code": "40309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/NGO QUYEN": {
    "msb": { "code": "01309004" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/NHA TRANG": {
    "msb": { "code": "56309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/PHU THO": {
    "msb": { "code": "25309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/QUANG BINH": {
    "msb": { "code": "44309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/QUANG NINH": {
    "msb": { "code": "22309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/QUANG TRI": {
    "msb": { "code": "45309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/THAI BINH": {
    "msb": { "code": "34309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/THAI NGUYEN": {
    "msb": { "code": "19309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/THANG LONG": {
    "msb": { "code": "01309010" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/THANH HOA": {
    "msb": { "code": "38309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/VINH LONG": {
    "msb": { "code": "86309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VPBANK/VINH PHUC": {
    "msb": { "code": "26309001" },
    "techcombank": {
      "bank": "VIET NAM THINH VUONG (VPBANK)",
      "region": "Ca nuoc",
      "branch": "VIET NAM THINH VUONG (VPBANK)-309"
    }
  },
  "VRB/DA NANG": {
    "msb": { "code": "01505002" },
    "techcombank": {
      "bank": "LD VIET NGA (VRB)",
      "region": "Ca nuoc",
      "branch": "LD VIET NGA (VRB)-505"
    }
  },
  "VRB/HA NOI (HN)": {
    "msb": { "code": "01505001" },
    "techcombank": {
      "bank": "LD VIET NGA (VRB)",
      "region": "Ca nuoc",
      "branch": "LD VIET NGA (VRB)-505"
    }
  },
  "VRB/HAI PHONG": {
    "msb": { "code": "01505002" },
    "techcombank": {
      "bank": "LD VIET NGA (VRB)",
      "region": "Ca nuoc",
      "branch": "LD VIET NGA (VRB)-505"
    }
  },
  "VRB/HO CHI MINH (HCM)": {
    "msb": { "code": "79505001" },
    "techcombank": {
      "bank": "LD VIET NGA (VRB)",
      "region": "Ca nuoc",
      "branch": "LD VIET NGA (VRB)-505"
    }
  },
  "VRB/KHANH HOA": {
    "msb": { "code": "01505002" },
    "techcombank": {
      "bank": "LD VIET NGA (VRB)",
      "region": "Ca nuoc",
      "branch": "LD VIET NGA (VRB)-505"
    }
  },
  "VRB/SO GIAO DICH (SGD)": {
    "msb": { "code": "01505002" },
    "techcombank": {
      "bank": "LD VIET NGA (VRB)",
      "region": "Ca nuoc",
      "branch": "LD VIET NGA (VRB)-505"
    }
  },
  "VRB/VUNG TAU": {
    "msb": { "code": "01505002" },
    "techcombank": {
      "bank": "LD VIET NGA (VRB)",
      "region": "Ca nuoc",
      "branch": "LD VIET NGA (VRB)-505"
    }
  },
  "WOORI BANK/HA NOI (HN)": {
    "msb": { "code": "01663001" },
    "techcombank": {
      "bank": "WOORI VIET NAM",
      "region": "Ca nuoc",
      "branch": "WOORI VIET NAM-663"
    }
  },
  "WOORI BANK/HO CHI MINH (HCM)": {
    "msb": { "code": "01663001" },
    "techcombank": {
      "bank": "WOORI VIET NAM",
      "region": "Ca nuoc",
      "branch": "WOORI VIET NAM-663"
    }
  },
  "AGRIBANK/DONG VAN (HA NAM)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "HA-NAM",
      "branch": "NONG NGHIEP VA PTNT VN CN DONG VAN-35204008"
    }
  },
  "AGRIBANK/EA CPAM (DAC LAK)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DAC-LAK",
      "branch": "NONG NGHIEP VA PTNT VN CN EA CPAM-66204031"
    }
  },
  "AGRIBANK/HUYEN BU GIA MAP (BINH PHUOC)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN BU GIA MAP-70204017"
    }
  },
  "AGRIBANK/HUYEN HON QUAN (BINH PHUOC)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-PHUOC",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN HON QUAN-70204018"
    }
  },
  "AGRIBANK/HUYEN LAM BINH (TUYEN QUANG)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN LAM BINH-08204008"
    }
  },
  "AGRIBANK/HUYEN NAM NHUN LAI CHAI (LAI CHAU)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LAI-CHAU",
      "branch": "NONG NGHIEP VA PTNT VN CN HUYEN NAM NHUN LAI CHAI-12204009"
    }
  },
  "AGRIBANK/TP BIEN HOA (DONG NAI)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN CN TP BIEN HOA-75204015"
    }
  },
  "AGRIBANK/U MINH THUONG (KIEN GIANG)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "KIEN-GIANG",
      "branch": "NONG NGHIEP VA PTNT VN CN U MINH THUONG-91204019"
    }
  },
  "AGRIBANK/HUYEN KONGCHRO (GIA LAI)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "GIA-LAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN KONGCHRO-64204014"
    }
  },
  "AGRIBANK/HUYEN MOC HOA (LONG AN)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "LONG-AN",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN MOC HOA-80204021"
    }
  },
  "AGRIBANK/HUYEN NA HANG (TUYEN QUANG)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN NA HANG-08204007"
    }
  },
  "AGRIBANK/HUYEN PHU GIAO (BINH DUONG)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "BINH-DUONG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN PHU GIAO-74204007"
    }
  },
  "AGRIBANK/HUYEN TAN PHU (DONG NAI)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN TAN PHU-75204011"
    }
  },
  "AGRIBANK/HUYEN THONG NHAT (DONG NAI)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN THONG NHAT-75204013"
    }
  },
  "AGRIBANK/HUYEN VINH CUU (DONG NAI)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN VINH CUU-75204012"
    }
  },
  "AGRIBANK/HUYEN XUAN LOC (DONG NAI)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "DONG-NAI",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN XUAN LOC-75204004"
    }
  },
  "AGRIBANK/HUYEN YEN SON (TUYEN QUANG)": {
    "msb": null,
    "techcombank": {
      "bank": "NONG NGHIEP VA PTNT VN (AGRIBANK)",
      "region": "TUYEN-QUANG",
      "branch": "NONG NGHIEP VA PTNT VN HUYEN YEN SON-08204002"
    }
  }
}
